export const TREASURY = {
  MESSAGES: {
    ALL_REQUIRED_FIELDS: 'TREASURY.MESSAGES.ALL_REQUIRED_FIELDS', // Tods los campos requeridos deben ser diligenciados / All required fields must be filled
  },
  COMMON: {
    STATUS: 'COMMON.STATUS',
    LOADING: 'COMMON.LOADING',
    SAVING: 'COMMON.SAVING',
    SAVE: 'COMMON.SAVE',
    BACK: 'COMMON.BACK',
    REFRESH: 'COMMON.REFRESH',
    ACTIONS: 'COMMON.ACTIONS', // Acciones / Actions
    ACCEPT: 'ACTIONS.ACCEPT', // Aceptar / Accept
    CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
    CONSULT: 'ACTIONS.CONSULT', // Consultar / Consult
    NO_PERMISSION: 'COMMON.NO_PERMISSION',
    APPLY: 'COMMON.ACTIONS', // Aplicar / Apply
    CLEAR: 'COMMON.CLEAR', // Limpiar / Clear
    SAVES: 'ACTIONS.SAVE', // Guardar / Save
    TABLE: {
      EMPTY: {
        DESCRIPTION_WITH_DATE: 'COMMON.TABLE.EMPTY.DESCRIPTION_WITH_DATE',
      },
    },
    MODALS: {
      SEARCH: {
        THIRD_PARTY: {
          PLACEHOLDER: 'TREASURY.MODALS.SEARCH.THIRD_PARTY.PLACEHOLDER',
        },
      },
    },
    PLACEHOLDER: {
      SEARCH: 'PLACEHOLDER.SEARCH',
    },
  },
  ACTIONS: {
    EDIT: 'ACTIONS.EDIT', // Editar / Edit
    DELETE: 'ACTIONS.DELETE', // Eliminar / Delete
  },
  PARAMETERS: {
    TITLE: {
      PARAMETERS: 'TREASURY.PARAMETERS.TITLE.PARAMETERS', // Parámetros de Tesorería / Treasury Parameters
      SUBTITLE: 'TREASURY.PARAMETERS.TITLE.SUBTITLE', // Configuración general de tesorería / General treasury configuration
    },

    LOADING: {
      MESSAGE: 'TREASURY.PARAMETERS.LOADING.MESSAGE', // Cargando Parámetros / Loading Parameters
      DESCRIPTION: 'TREASURY.PARAMETERS.LOADING.DESCRIPTION', // Espere Por favor... / Please wait...
    },

    CARDS: {
      INSTITUTIONAL: 'TREASURY.PARAMETERS.CARDS.INSTITUTIONAL', // Información Institucional & Control Temporal y Operativo / Institutional Information & Temporal and Operational Control
      OPERATION: 'TREASURY.PARAMETERS.CARDS.OPERATION', // Operación de Caja y PAC / Cash Operation and PAC
      TEMPORAL: 'TREASURY.PARAMETERS.CARDS.TEMPORAL', // Control temporal / Time control
      CASH_ACCOUNT: 'TREASURY.PARAMETERS.CARDS.CASH_ACCOUNT', // Cuenta contable de caja / Cash accounting account
      CONCEPTS: 'TREASURY.PARAMETERS.CARDS.CONCEPTS', // Gestión de Avances & Configuración de Conceptos Contables / Advance Management & Accounting Concepts Configuration
    },

    FIELDS: {
      IDENTIFICATION: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.LABEL', // No. Identificación / Identification No.
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.TOOLTIP', // Identidad legal de la empresa / Legal identity of the company
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.PLACEHOLDER', // No. Identificación / Identification No.
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.REQUIRED', // El número de identificación es requerido / Identification number is required
      },
      ENTITY: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.ENTITY.LABEL', // Entidad / Entity
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ENTITY.TOOLTIP', // Razón social institucional / Institutional business name
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.ENTITY.PLACEHOLDER', // Entidad / Entity
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.ENTITY.REQUIRED', // La entidad es requerida / Entity is required
      },
      VIGENCY: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.VIGENCY.LABEL', // Vigencia Activa / Active Validity
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.VIGENCY.TOOLTIP', // Año fiscal de trabajo actual / Current fiscal year
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.VIGENCY.PLACEHOLDER', // Vigencia activa / Active validity
        NOT_DEFINED: 'COMMON.NA', // No definida / Not defined
      },

      SYSTEM_DATE: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.LABEL', // Fecha del Sistema / System Date
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.TOOLTIP', // Fecha actual del sistema para operaciones contables / Current system date for accounting operations
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.REQUIRED', // La fecha del Sistema es requerida / System date is required
        AUTOMATIC: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.AUTOMATIC', // Automático / Automatic
        RESTORE: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.RESTORE', // Restaurar / Restore
        NOT_AVAILABLE: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.NOT_AVAILABLE', // No disponible / Not available
      },

      OPERATES_CASH: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.OPERATES_CASH.LABEL', // ¿La entidad opera caja? / Does the entity operate cash?
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.OPERATES_CASH.TOOLTIP', // Indica si la entidad opera con caja / Indicates if the entity operates with cash
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.OPERATES_CASH.REQUIRED', // Debe indicar si la entidad opera caja / You must indicate if the entity operates cash
        CONTEXT: 'TREASURY.PARAMETERS.FIELDS.OPERATES_CASH.CONTEXT', // Ayuda (i): para que lo usa Tesoreria (R3-14)
      },

      CONTROLS_PAC: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.CONTROLS_PAC.LABEL', // ¿Controla PAC? / Controls PAC?
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONTROLS_PAC.TOOLTIP', // Control de Plan Anual de Caja / Annual Cash Plan Control
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONTROLS_PAC.REQUIRED', // Debe indicar si controla PAC / You must indicate if controls PAC
        CONTEXT: 'TREASURY.PARAMETERS.FIELDS.CONTROLS_PAC.CONTEXT', // Ayuda (i): para que lo usa Tesoreria (R3-14)
      },

      ACCOUNT: {
        CODE: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.LABEL', // Código Cuenta / Account Code
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.TOOLTIP', // Cuenta contable para operaciones de caja / Accounting account for cash operations
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.PLACEHOLDER', // Buscar cuenta... / Search account...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.REQUIRED', // La cuenta contable es requerida cuando Opera Caja es Sí / Accounting account is required when Cash Operation is Yes
          SEARCH_TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.SEARCH_TOOLTIP', // Buscar cuenta contable / Search accounting account
        },
        NAME: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.LABEL', // Nombre Cuenta / Account Name
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.TOOLTIP', // Nombre de la cuenta contable seleccionada / Name of the selected accounting account
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.PLACEHOLDER', // Nombre cuenta... / Account name...
        },
      },

      LEGALIZATION_DAYS: {
        LABEL: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.LABEL', // Días Legalización de Avances / Advance Legalization Days
        TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.TOOLTIP', // Días para legalización de gastos en avances / Days for expense legalization in advances
        PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.PLACEHOLDER', // Ingrese días... / Enter days...
        REQUIRED: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.REQUIRED', // Los días de legalización son requeridos / Legalization days are required
        HINT: 'TREASURY.PARAMETERS.FIELDS.LEGALIZATION_DAYS.HINT', // Número de días hábiles para legalizar los avances de gastos (1-999) / Number of business days to legalize expense advances (1-999)
      },

      CONCEPTS: {
        INCOME: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.LABEL', // Ingresos / Income
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.TOOLTIP', // Concepto para ingresos / Concept for income
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.PLACEHOLDER', // Seleccionar concepto... / Select concept...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.REQUIRED', // El concepto de ingresos es requerido / Income concept is required
        },
        EXPENSE: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.LABEL', // Egresos / Expenses
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.TOOLTIP', // Concepto para egresos / Concept for expenses
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.PLACEHOLDER', // Seleccionar concepto... / Select concept...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.REQUIRED', // El concepto de egresos es requerido / Expense concept is required
        },
        TRANSFER: {
          LABEL: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.LABEL', // Traslados Bancarios / Bank Transfers
          TOOLTIP: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.TOOLTIP', // Concepto para traslados bancarios / Concept for bank transfers
          PLACEHOLDER: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.PLACEHOLDER', // Seleccionar concepto... / Select concept...
          REQUIRED: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.TRANSFER.REQUIRED', // El concepto de traslados es requerido / Transfer concept is required
        },
        DUPLICATE_ERROR: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.DUPLICATE_ERROR', // El Código no se puede asociar a mas de un concepto / The Code cannot be associated with more than one concept
      },
    },

    HINTS: {
      OPERATION: 'TREASURY.PARAMETERS.HINTS.OPERATION', // Que decide el bloque de caja y PAC
      CONCEPTS: 'TREASURY.PARAMETERS.HINTS.CONCEPTS', // Con que concepto se contabiliza cada movimiento
      NO_CASH: 'TREASURY.PARAMETERS.HINTS.NO_CASH', // Que pasa cuando la entidad no opera caja
      INSTITUTIONAL: 'TREASURY.PARAMETERS.HINTS.INSTITUTIONAL', // Datos cargados de configuración institucional / Data loaded from institutional configuration
    },

    OPTIONS: {
      YES: 'TREASURY.PARAMETERS.OPTIONS.YES', // Sí / Yes
      NO: 'TREASURY.PARAMETERS.OPTIONS.NO', // No / No
    },

    ALERTS: {
      LOAD_ERROR: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.LOAD_ERROR.TITLE', // Error al cargar datos / Error loading data
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.LOAD_ERROR.MESSAGE', // Ocurrió un error al cargar los datos / An error occurred while loading data
      },
      SAVE_SUCCESS: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.SAVE_SUCCESS.TITLE', // Parámetros guardados / Parameters saved
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.SAVE_SUCCESS.MESSAGE', // La configuración ha sido guardada exitosamente / Configuration has been saved successfully
      },
      SAVE_ERROR: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.SAVE_ERROR.TITLE', // Error al guardar / Error saving
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.SAVE_ERROR.MESSAGE', // Ocurrió un error al guardar los parámetros / An error occurred while saving parameters
      },
      RESTORE_SUCCESS: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_SUCCESS.TITLE', // Fecha restaurada / Date restored
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_SUCCESS.MESSAGE', // La fecha del sistema ha sido restaurada / System date has been restored
      },
      RESTORE_ERROR: {
        TITLE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_ERROR.TITLE', // Error al restaurar fecha / Error restoring date
        MESSAGE: 'TREASURY.PARAMETERS.ALERTS.RESTORE_ERROR.MESSAGE', // Error al restaurar la fecha del sistema / Error restoring system date
      },
    },

    ACTIONS: {
      REFRESH: 'ACTIONS.REFRESH', // Refrescar / Refresh
      CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
      SAVE: 'ACTIONS.SAVE', // Guardar / Save
      SAVING: 'UTIL.SAVING', // Guardando... / Saving...
      RESTORE: 'TREASURY.PARAMETERS.FIELDS.SYSTEM_DATE.RESTORE', // Restaurar / Restore
    },

    VALIDATIONS: {
      DATE_INVALID: 'TREASURY.PARAMETERS.VALIDATIONS.DATE_INVALID', // La fecha es inválida / The date is invalid
      REQUIRED_FIELD: 'TREASURY.PARAMETERS.VALIDATIONS.REQUIRED_FIELD', // Este campo es requerido / This field is required
      MIN_DAYS: 'TREASURY.PARAMETERS.VALIDATIONS.MIN_DAYS', // El número mínimo de días es 1 / The minimum number of days is 1
      MAX_DAYS: 'TREASURY.PARAMETERS.VALIDATIONS.MAX_DAYS', // El número máximo de días es 999 / The maximum number of days is 999
    },

    ACCOUNT_SEARCH: {
      TITLE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.TITLE', // Buscar Cuenta Contable / Search Accounting Account
      SEARCH_PLACEHOLDER: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.SEARCH_PLACEHOLDER', // Buscar por código o nombre... / Search by code or name...
      EMPTY_MESSAGE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.EMPTY_MESSAGE', // No se encontraron cuentas / No accounts found
      EMPTY_DESCRIPTION: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.EMPTY_DESCRIPTION', // Intente con otro término de búsqueda / Try another search term
      SELECT: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.SELECT', // Seleccionar / Select
      CLEAR: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.CLEAR', // Limpiar / Clear
      CLOSE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.CLOSE', // Cerrar / Close
    },

    FIELD_ERRORS: {
      ACCOUNT_REQUIRED: 'TREASURY.PARAMETERS.FIELD_ERRORS.ACCOUNT_REQUIRED', // La cuenta contable es requerida cuando Opera Caja es Sí / Accounting account is required when Cash Operation is Yes
      CONCEPT_DUPLICATE: 'TREASURY.PARAMETERS.FIELD_ERRORS.CONCEPT_DUPLICATE', // El Código no se puede asociar a mas de un concepto / The Code cannot be associated with more than one concept
      LEGALIZATION_DAYS_INVALID: 'TREASURY.PARAMETERS.FIELD_ERRORS.LEGALIZATION_DAYS_INVALID', // Los días de legalización deben ser un número entre 1 y 999 / Legalization days must be a number between 1 and 999
      DATE_INVALID: 'TREASURY.PARAMETERS.FIELD_ERRORS.DATE_INVALID', // La fecha del sistema no puede ser anterior al último mes cerrado / System date cannot be earlier than the last closed month
    },

    CONFIRM_DIALOGS: {
      CANCEL: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.TITLE', // Cancelar cambios / Cancel changes
        MESSAGE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.MESSAGE', // ¿Está seguro de que desea cancelar los cambios? Se perderán todas las modificaciones no guardadas. / Are you sure you want to cancel the changes? All unsaved modifications will be lost.
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.CONFIRM_LABEL', // Sí, cancelar / Yes, cancel
        CANCEL_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CANCEL.CANCEL_LABEL', // Continuar editando    / Continue editing
      },
      REFRESH: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.REFRESH.TITLE', // Cambios sin guardar / Unsaved changes
        MESSAGE: '', // Tiene cambios sin guardar. Si refresca, perderá los cambios. ¿Está seguro de que desea continuar? / You have unsaved changes. If you refresh, you will lose the changes. Are you sure you want to continue?
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.REFRESH.CONFIRM_LABEL', // Sí, refrescar / Yes, refresh
      },
      RESTORE_DATE: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.RESTORE_DATE.TITLE', // Restaurar fecha del sistema / Restore system date
        MESSAGE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.RESTORE_DATE.MESSAGE', // ¿Está seguro de que desea restaurar la fecha del sistema a la fecha del servidor? Esto puede afectar las operaciones contables. / Are you sure you want to restore the system date to the server date? This may affect accounting operations.
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.RESTORE_DATE.CONFIRM_LABEL', // Sí, restaurar / Yes, restore
      },
      CLEAR_ACCOUNT: {
        TITLE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CLEAR_ACCOUNT.TITLE', // Limpiar cuenta contable / Clear accounting account
        MESSAGE: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CLEAR_ACCOUNT.MESSAGE', // ¿Está seguro de que desea eliminar la cuenta contable seleccionada? / Are you sure you want to delete the selected accounting account?
        CONFIRM_LABEL: 'TREASURY.PARAMETERS.CONFIRM_DIALOGS.CLEAR_ACCOUNT.CONFIRM_LABEL', // Cancelar cuenta / Clear account
      },
    },

    // Mensajes de permiso denegado
    PERMISSION: {
      DENIED_RESTORE_DATE: 'TREASURY.PARAMETERS.PERMISSION.DENIED_RESTORE_DATE', // No tiene permisos para restaurar la fecha del sistema / You do not have permission to restore the system date
      DENIED_SELECT_ACCOUNT: 'TREASURY.PARAMETERS.PERMISSION.DENIED_SELECT_ACCOUNT', // No tiene permisos para seleccionar cuentas /  You do not have permission to select accounts.
      DENIED_CLEAR_ACCOUNT: 'TREASURY.PARAMETERS.PERMISSION.DENIED_CLEAR_ACCOUNT', // No tiene permisos para limpiar cuentas /  You do not have permission to clear accounts.
    },

    // Mensajes de éxito/información
    MESSAGES: {
      ACCOUNT_SELECTED: 'TREASURY.PARAMETERS.MESSAGES.ACCOUNT_SELECTED', // Cuenta seleccionada: / Selected account:
      ACCOUNT_CLEARED: 'TREASURY.PARAMETERS.MESSAGES.ACCOUNT_CLEARED', // Cuenta contable eliminada / Accounting account deleted
      ERROR_SEARCH_ACCOUNT: 'TREASURY.PARAMETERS.MESSAGES.ERROR_SEARCH_ACCOUNT', // Error al buscar cuenta contable / Error searching for accounting account
    },

    ACCOUNT_MODAL: {
      TITLE: 'TREASURY.PARAMETERS.ACCOUNT_MODAL.TITLE', // Seleccionar Cuenta Contable para Caja /  Select Accounting Account for Cash
    },
  },
  // Cuentas Bancarias - Bank Accounts
  BANK_ACCOUNTS: {
    TITLE: {
      LIST: 'TREASURY.BANK_ACCOUNTS.TITLE.LIST', // Cuentas Bancarias / Bank Accounts
      CREATE: 'TREASURY.BANK_ACCOUNTS.TITLE.CREATE', // Crear Cuenta de Banco / Create Bank Account
      EDIT: 'TREASURY.BANK_ACCOUNTS.TITLE.EDIT', // Editar Cuenta de Banco / Edit Bank Account
      VIEW: 'TREASURY.BANK_ACCOUNTS.TITLE.VIEW', // Consultar Cuenta de Banco / View Bank Account
    },

    SUBTITLE: {
      LIST: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.LIST', // Maestro de cuentas bancarias de la entidad / Bank accounts master for the entity
      CREATE: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.CREATE', // Complete los datos de la nueva cuenta de banco / Complete the new bank account details
      EDIT: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.EDIT', // Actualice los datos permitidos de la cuenta bancaria / Update the allowed bank account data
      VIEW: 'TREASURY.BANK_ACCOUNTS.SUBTITLE.VIEW', // Detalle de la cuenta de banco / Bank account detail
    },

    SECTION: {
      ACCOUNT_DATA: 'TREASURY.BANK_ACCOUNTS.SECTION.ACCOUNT_DATA', // Datos de la cuenta / Account details
      CONTACT: 'TREASURY.BANK_ACCOUNTS.SECTION.CONTACT', // Contacto / Contact
      ACCOUNTING_ACCOUNT: 'TREASURY.BANK_ACCOUNTS.SECTION.ACCOUNTING_ACCOUNT', // Cuenta contable / GL Account
    },

    LABEL: {
      BANK: 'TREASURY.BANK_ACCOUNTS.LABEL.BANK', // Banco / Bank
      IDENTIFICATION: 'TREASURY.BANK_ACCOUNTS.LABEL.IDENTIFICATION', // No. Identificación / ID Number
      NATIONAL_CODE: 'TREASURY.BANK_ACCOUNTS.LABEL.NATIONAL_CODE', // Cód. Nacional / National Code
      ACCOUNT_TYPE: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_TYPE', // Tipo de cuenta / Account Type
      ACCOUNT_NUMBER: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_NUMBER', // # Cuenta bancaria / Bank Account Number
      ACCOUNT_CODE: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_CODE', // Cod. Cuenta / Account Code
      ACCOUNT_NAME: 'TREASURY.BANK_ACCOUNTS.LABEL.ACCOUNT_NAME', // Nombre de la cuenta / Account Name
      STATUS: 'TREASURY.BANK_ACCOUNTS.LABEL.STATUS', // Estado / Status
      OVERDRAFT: 'TREASURY.BANK_ACCOUNTS.LABEL.OVERDRAFT', // Sobregiro / Overdraft
      CHECKBOOK: 'TREASURY.BANK_ACCOUNTS.LABEL.CHECKBOOK', // Opera chequera / Checkbook
      CHECK_CONSECUTIVE: 'TREASURY.BANK_ACCOUNTS.LABEL.CHECK_CONSECUTIVE', // Consecutivo chequera / Checkbook consecutive
      CLOSING_DATE: 'TREASURY.BANK_ACCOUNTS.LABEL.CLOSING_DATE', // Fecha de cierre / Closing Date
      MIN_BALANCE: 'TREASURY.BANK_ACCOUNTS.LABEL.MIN_BALANCE', // Saldo mínimo / Minimum Balance
      FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.LABEL.FUNDING_SOURCE', // Fuente financiación / Funding Source
      CONTACT_NAME: 'TREASURY.BANK_ACCOUNTS.LABEL.CONTACT_NAME', // Nombre contacto / Contact Name
      POSITION: 'TREASURY.BANK_ACCOUNTS.LABEL.POSITION', // Cargo / Position
      PHONE: 'COMMON.PHONE', // Teléfono / Phone (common_keys)
      EMAIL: 'COMMON.EMAIL', // Email (common_keys)
      GL_ACCOUNT: 'TREASURY.BANK_ACCOUNTS.LABEL.GL_ACCOUNT', // Cuenta contable / GL Account
      GL_ACCOUNT_TOOLTIP: 'TREASURY.BANK_ACCOUNTS.LABEL.GL_ACCOUNT_TOOLTIP', // Cuenta de movimiento asociada / Associated movement account
    },

    COLUMN: {
      BANK_CODE: 'TREASURY.BANK_ACCOUNTS.COLUMN.BANK_CODE', // Cod. Banco / Bank Code
      ACCOUNT_NUMBER: 'TREASURY.BANK_ACCOUNTS.COLUMN.ACCOUNT_NUMBER', // # Cuenta / Account #
      NAME: 'TREASURY.BANK_ACCOUNTS.COLUMN.NAME', // Nombre / Name
      STATUS: 'TREASURY.BANK_ACCOUNTS.COLUMN.STATUS', // Estado / Status
      IDENTIFICATION: 'TREASURY.BANK_ACCOUNTS.COLUMN.IDENTIFICATION', // No. Identificación / ID Number
      BANK: 'TREASURY.BANK_ACCOUNTS.COLUMN.BANK', // Banco / Bank
      FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.COLUMN.FUNDING_SOURCE', // Fuente Financiación / Funding Source
      ACTIONS: 'COMMON.ACTIONS', // Acciones / Actions (common_keys)
    },

    ACTION: {
      CREATE: 'TREASURY.BANK_ACCOUNTS.ACTION.CREATE', // Crear Cuenta de Banco / Create Bank Account (específico HU)
      VIEW: 'ACTIONS.VIEW', // Consultar / View (common_keys)
      EDIT: 'ACTIONS.EDIT', // Editar / Edit (common_keys)
      DELETE: 'ACTIONS.DELETE', // Eliminar / Delete (common_keys)
      SEARCH: 'ACTIONS.SEARCH', // Buscar / Search (common_keys)
      UNLINK_GL: 'TREASURY.BANK_ACCOUNTS.ACTION.UNLINK_GL', // Desasociar cuenta contable / Unlink GL account
    },

    COUNTER: {
      SINGULAR: 'TREASURY.BANK_ACCOUNTS.COUNTER.SINGULAR', // cuenta bancaria / bank account
      PLURAL: 'TREASURY.BANK_ACCOUNTS.COUNTER.PLURAL', // cuentas bancarias / bank accounts
    },

    OPTION: {
      SAVINGS: 'TREASURY.BANK_ACCOUNTS.OPTION.SAVINGS', // Ahorros / Savings
      CHECKING: 'TREASURY.BANK_ACCOUNTS.OPTION.CHECKING', // Corriente / Checking
      INVESTMENT: 'TREASURY.BANK_ACCOUNTS.OPTION.INVESTMENT', // Inversión / Investment
      DIGITAL: 'TREASURY.BANK_ACCOUNTS.OPTION.DIGITAL', // Digital / Digital
      CROSS: 'TREASURY.BANK_ACCOUNTS.OPTION.CROSS', // Cruce / Cross
      ACTIVE: 'COMMON.ACTIVE', // Activo / Active (common_keys)
      INACTIVE: 'TREASURY.BANK_ACCOUNTS.OPTION.INACTIVE', // Inactivo / Inactive (no hay COMMON.INACTIVE)
    },

    MODAL: {
      SELECT_BANK: 'TREASURY.BANK_ACCOUNTS.MODAL.SELECT_BANK', // Seleccionar Banco / Select Bank
      SELECT_GL: 'TREASURY.BANK_ACCOUNTS.MODAL.SELECT_GL', // Seleccionar Cuenta Contable / Select GL Account
      COL_SUP_CODE: 'ACCOUNTING.THIRD_PARTY.VINCULOS.FORM.CONTRALORIA_CODE', // Cód. Sup. Bancaria / Banking Superintendency Code
      COL_IDENTIFICATION: 'TREASURY.BANK_ACCOUNTS.LABEL.IDENTIFICATION', // No. Identificación (reusa label)
      COL_FULL_NAME: 'TREASURY.BANK_ACCOUNTS.MODAL.COL_FULL_NAME', // Nombre o Razón Social / Name or Business Name
      SEARCH_PLACEHOLDER: 'TREASURY.BANK_ACCOUNTS.MODAL.SEARCH_PLACEHOLDER', // Buscar por código, documento o nombre... / Search by code, document or name...
    },

    PLACEHOLDER: {
      SEARCH: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.SEARCH', // Buscar por código, nombre, identificación o banco / Search by code, name, ID or bank
      SELECT_BANK: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.SELECT_BANK', // Seleccione el banco / Select bank
      SELECT_GL: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.SELECT_GL', // Seleccione la cuenta contable / Select GL account
      FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.PLACEHOLDER.FUNDING_SOURCE', // Código / nombre de fuente / Source code / name
    },

    EMPTY: {
      SEARCH: 'TREASURY.BANK_ACCOUNTS.EMPTY.SEARCH', // No se encontraron cuentas bancarias que coincidan con los criterios de búsqueda. / No bank accounts matched the search criteria.
      DEFAULT: 'TREASURY.BANK_ACCOUNTS.EMPTY.DEFAULT', // No se encontraron cuentas bancarias / No bank accounts found
      DESCRIPTION: 'TREASURY.BANK_ACCOUNTS.EMPTY.DESCRIPTION', // Intenta con otro término o registra una nueva cuenta de banco. / Try another term or register a new bank account.
    },

    MESSAGE: {
      CREATED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.CREATED', // La cuenta de banco se creó exitosamente / Bank account created successfully
      UPDATED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.UPDATED', // La cuenta de banco se actualizó exitosamente / Bank account updated successfully
      DELETED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETED', // La cuenta de banco se eliminó exitosamente / Bank account deleted successfully
      ALREADY_DELETED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.ALREADY_DELETED', // Esta cuenta bancaria ya fue eliminada. / This bank account was already deleted.
      DELETE_ONLY_INACTIVE: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETE_ONLY_INACTIVE', // Solo se pueden eliminar cuentas bancarias en estado Inactivo. / Only inactive bank accounts can be deleted.
      DELETE_HAS_GL: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETE_HAS_GL', // No se puede eliminar la cuenta bancaria porque tiene una cuenta contable asociada. / Cannot delete the bank account because it has an associated GL account.
      DELETE_NOT_ALLOWED: 'TREASURY.BANK_ACCOUNTS.MESSAGE.DELETE_NOT_ALLOWED', // No se puede eliminar la cuenta bancaria con las condiciones actuales. / Cannot delete the bank account under the current conditions.
      OVERDRAFT_NEGATIVE: 'TREASURY.BANK_ACCOUNTS.MESSAGE.OVERDRAFT_NEGATIVE', // No se puede cambiar el sobregiro a No porque el saldo de la cuenta es negativo. / Cannot change overdraft to No because the account balance is negative.
      HAS_ASSOCIATIONS: 'TREASURY.BANK_ACCOUNTS.MESSAGE.HAS_ASSOCIATIONS', // No se puede eliminar la cuenta bancaria porque tiene transacciones o registros asociados. / Cannot delete the bank account because it has associated transactions or records.
      MISSING_NATIONAL_CODE: 'TREASURY.BANK_ACCOUNTS.MESSAGE.MISSING_NATIONAL_CODE', // El banco seleccionado no tiene código sup. bancaria. Complételo en Maestro Terceros. / The selected bank does not have a banking superintendency code. Complete it in Third Party Master.
    },

    CONFIRM: {
      DELETE_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.DELETE_TITLE', // Confirmar eliminación / Confirm deletion
      DELETE_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.DELETE_MESSAGE', // Se va a eliminar la cuenta de banco seleccionada. ¿Desea continuar? / The selected bank account will be deleted. Do you want to continue?
      DELETE_CONFIRM: 'ACTIONS.ACCEPT', // Aceptar / Accept (common_keys)
      DELETE_CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      CANCEL_EDIT_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_TITLE', // Cancelar modificaciones / Cancel changes
      CANCEL_EDIT_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_MESSAGE', // Se cancelarán las modificaciones a la cuenta bancaria / Changes to the bank account will be discarded
      CANCEL_EDIT_CONFIRM: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_CONFIRM', // Sí, cancelar / Yes, cancel (contexto específico)
      CANCEL_EDIT_CONTINUE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_EDIT_CONTINUE', // Continuar editando / Continue editing (texto específico HU)
      CANCEL_CREATE_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_CREATE_TITLE', // Cancelar creación / Cancel creation
      CANCEL_CREATE_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.CANCEL_CREATE_MESSAGE', // Se cancelará la creación de la cuenta bancaria / Bank account creation will be cancelled
      CANCEL_CREATE_CONFIRM: 'ACTIONS.ACCEPT', // Aceptar / Accept (common_keys)
      CANCEL_CREATE_CONTINUE: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      UNLINK_GL_TITLE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.UNLINK_GL_TITLE', // Desasociar cuenta contable / Unlink GL account
      UNLINK_GL_MESSAGE: 'TREASURY.BANK_ACCOUNTS.CONFIRM.UNLINK_GL_MESSAGE', // Se va a desasociar la cuenta contable a la cuenta de banco / The GL account will be unlinked from the bank account
    },

    TOOLTIP: {
      BANK: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.BANK', // Entidad bancaria (tercero con vínculo Entidad Bancaria). Use la lupa para seleccionar. / Bank entity (third party with Bank Entity link). Use the magnifying glass to select.
      IDENTIFICATION: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.IDENTIFICATION', // Número de identificación del tercero bancario (se completa al elegir el banco). / Bank third party identification number (completed when selecting the bank).
      NATIONAL_CODE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.NATIONAL_CODE', // Código de la Superintendencia Bancaria (máx. 3). Se toma del vínculo Entidad Bancaria. / Banking Superintendency code (max. 3). Taken from Bank Entity link.
      ACCOUNT_TYPE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.ACCOUNT_TYPE', // Tipo de cuenta bancaria de la entidad (Ahorros, Corriente, etc.). / Entity bank account type (Savings, Checking, etc.).
      ACCOUNT_NUMBER: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.ACCOUNT_NUMBER', // Número de la cuenta bancaria en la entidad financiera. / Bank account number at the financial institution.
      ACCOUNT_CODE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.ACCOUNT_CODE', // Código interno de la cuenta (se genera automáticamente al crear). / Internal account code (automatically generated on creation).
      ACCOUNT_NAME: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.ACCOUNT_NAME', // Nombre descriptivo de la cuenta bancaria en el ERP. / Descriptive name of the bank account in the ERP.
      STATUS: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.STATUS', // Estado de la cuenta: Activo o Inactivo. / Account status: Active or Inactive.
      OVERDRAFT: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.OVERDRAFT', // Indica si la cuenta permite sobregiro. / Indicates if the account allows overdraft.
      CHECKBOOK: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.CHECKBOOK', // Indica si la cuenta opera con chequera (solo Ahorros/Corriente). / Indicates if the account operates with checkbook (only Savings/Checking).
      CHECK_CONSECUTIVE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.CHECK_CONSECUTIVE', // Consecutivo actual de chequera (si opera chequera). / Current checkbook consecutive (if operates checkbook).
      CLOSING_DATE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.CLOSING_DATE', // Fecha de cierre de la cuenta (si aplica). / Account closing date (if applicable).
      MIN_BALANCE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.MIN_BALANCE', // Saldo mínimo configurado para la cuenta. / Minimum balance configured for the account.
      FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.FUNDING_SOURCE', // Fuente de financiación (cuando aplica presupuesto público). / Funding source (when public budget applies).
      CONTACT_NAME: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.CONTACT_NAME', // Nombre del contacto en la entidad bancaria. / Contact name at the bank entity.
      POSITION: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.POSITION', // Cargo del contacto en la entidad bancaria. / Position of the contact at the bank entity.
      PHONE: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.PHONE', // Teléfono de contacto. / Contact phone.
      EMAIL: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.EMAIL', // Correo electrónico de contacto. / Contact email.
      GL_ACCOUNT: 'TREASURY.BANK_ACCOUNTS.TOOLTIP.GL_ACCOUNT', // Cuenta contable de movimiento asociada (requerida para Cod. Banco en asientos). / Associated movement accounting account (required for Bank Code in entries).
    },
    /** Panel lateral del formulario: resumen, lo que falta y la nota de uso. */
    PANEL: {
      SUMMARY: 'TREASURY.BANK_ACCOUNTS.PANEL.SUMMARY', // Resumen / Summary
      SUMMARY_TITLE_EMPTY: 'TREASURY.BANK_ACCOUNTS.PANEL.SUMMARY_TITLE_EMPTY', // Cuenta sin nombre / Unnamed account
      SUMMARY_CODE_EMPTY: 'TREASURY.BANK_ACCOUNTS.PANEL.SUMMARY_CODE_EMPTY', // Sin código / No code
      CHECKLIST: 'TREASURY.BANK_ACCOUNTS.PANEL.CHECKLIST', // Antes de guardar / Before saving
      USAGE: 'TREASURY.BANK_ACCOUNTS.PANEL.USAGE', // Cómo se usa / How to use
      USAGE_HINT: 'TREASURY.BANK_ACCOUNTS.PANEL.USAGE_HINT', // El código de la cuenta se arma con... / The account code is built from...
    },
  },

  DEDUCTIONS: {
    TITLE: {
      LIST: 'TREASURY.DEDUCTIONS.TITLE.LIST', // Otras Deducciones / Other Deductions
      CREATE: 'TREASURY.DEDUCTIONS.TITLE.CREATE', // Registrar Deducción / Register Deduction
      EDIT: 'TREASURY.DEDUCTIONS.TITLE.EDIT', // Editar Deducción / Edit Deduction
      VIEW: 'TREASURY.DEDUCTIONS.TITLE.VIEW', // Consultar Deducción / View Deduction
      FINALIZE: 'TREASURY.DEDUCTIONS.TITLE.FINALIZE', // Finalizar Deducción / Finalize Deduction
      SUBTITLE: {
        LIST: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.LIST', // Maestro de otras deducciones de Tesorería / Treasury other deductions master
        CREATE: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.CREATE', // Complete los datos de la nueva deducción / Complete the data for the new deduction
        EDIT: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.EDIT', // Solo campos permitidos son editables (RN-ALC3-01) / Only allowed fields are editable (RN-ALC3-01)
        VIEW: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.VIEW', // Detalle completo de la deducción / Complete deduction details
        FINALIZE: 'TREASURY.DEDUCTIONS.TITLE.SUBTITLE.FINALIZE', // Complete los datos para finalizar la deducción / Complete the data to finalize the deduction
      },
    },

    LOADING: {
      MESSAGE: 'TREASURY.DEDUCTIONS.LOADING.MESSAGE', // Cargando deducciones / Loading deductions
      DESCRIPTION: 'TREASURY.DEDUCTIONS.LOADING.DESCRIPTION', // Espere Por favor... / Please wait...
    },

    RESULTS_COUNTER: {
      SINGULAR: 'TREASURY.DEDUCTIONS.RESULTS_COUNTER.SINGULAR', // deducción / deduction
      PLURAL: 'TREASURY.DEDUCTIONS.RESULTS_COUNTER.PLURAL', // deducciones / deductions
    },

    FILTERS: {
      ESTADO: {
        LABEL: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.LABEL', // Estado / Status
        PLACEHOLDER: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.PLACEHOLDER', // Seleccionar estado / Select status
        OPTIONS: {
          ACTIVO: 'COMMON.ACTIVE', // Activo / Active (common_keys)
          INACTIVO: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.OPTIONS.INACTIVO', // Inactivo / Inactive
          FINALIZADO: 'TREASURY.DEDUCTIONS.FILTERS.ESTADO.OPTIONS.FINALIZADO', // Finalizado / Finalized
        },
      },
      SEARCH: {
        PLACEHOLDER: 'TREASURY.DEDUCTIONS.FILTERS.SEARCH.PLACEHOLDER', // Buscar por deudor, acreedor o documento... / Search by debtor, creditor or document...
      },
    },

    EMPTY: {
      MESSAGE: 'TREASURY.DEDUCTIONS.EMPTY.MESSAGE', // No se encontraron deducciones / No deductions found
      DESCRIPTION: 'TREASURY.DEDUCTIONS.EMPTY.DESCRIPTION', // Intenta con otro término o registra una nueva deducción. / Try another term or register a new deduction.
    },

    TABLE: {
      COLUMNS: {
        CONSECUTIVO: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.CONSECUTIVO', // Consecutivo / Consecutive
        TIPO_DEDUCCION: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.TIPO_DEDUCCION', // Tipo Deducción / Deduction Type
        ID_DEUDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.ID_DEUDOR', // ID Deudor / Debtor ID
        NOMBRE_DEUDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.NOMBRE_DEUDOR', // Nombre Deudor / Debtor Name
        ID_ACREEDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.ID_ACREEDOR', // ID Acreedor / Creditor ID
        NOMBRE_ACREEDOR: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.NOMBRE_ACREEDOR', // Nombre Acreedor / Creditor Name
        FECHA_INICIO: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.FECHA_INICIO', // Fecha Inicio / Start Date
        SALDO_DEDUCCION: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.SALDO_DEDUCCION', // Saldo Deducción / Deduction Balance
        ESTADO: 'TREASURY.DEDUCTIONS.TABLE.COLUMNS.ESTADO', // Estado / Status
      },
      ACTIONS: {
        LABEL: 'COMMON.ACTIONS', // Acciones / Actions (common_keys)
        VIEW: 'ACTIONS.VIEW', // Consultar / View (common_keys)
        EDIT: 'ACTIONS.EDIT', // Editar / Edit (common_keys)
        FINALIZE: 'TREASURY.DEDUCTIONS.TABLE.ACTIONS.FINALIZE', // Finalizar / Finalize (específico HU)
        DELETE: 'ACTIONS.DELETE', // Eliminar / Delete (common_keys)
      },
    },

    FORM: {
      FIELDS: {
        CONSECUTIVO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CONSECUTIVO.LABEL', // Consecutivo / Consecutive
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CONSECUTIVO.TOOLTIP', // Se asigna automáticamente al guardar / Automatically assigned when saving
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CONSECUTIVO.PLACEHOLDER', // Se asigna al guardar / Assigned when saving
        },
        DEUDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.LABEL', // ID Deudor / Debtor ID
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.TOOLTIP', // Máximo 12 dígitos / Maximum 12 digits
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.PLACEHOLDER', // Seleccione el deudor / Select the debtor
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.REQUIRED', // El deudor es requerido / Debtor is required
          SEARCH_TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DEUDOR.SEARCH_TOOLTIP', // Buscar deudor / Search debtor
        },
        NOMBRE_DEUDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_DEUDOR.LABEL', // Nombre Deudor / Debtor Name
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_DEUDOR.TOOLTIP', // Se autocompleta al seleccionar el ID Deudor / Auto-completes when selecting Debtor ID
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_DEUDOR.PLACEHOLDER', // Se autocompleta / Auto-completes
        },
        TIPO_DEDUCCION: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.LABEL', // Tipo Deducción / Deduction Type
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.TOOLTIP', // Define el tipo de descuento (RN-ALC2-07) / Defines the discount type (RN-ALC2-07)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.PLACEHOLDER', // Seleccionar tipo / Select type
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.REQUIRED', // El tipo de deducción es requerido / Deduction type is required
          OPTIONS: {
            CREDITO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.CREDITO', // Crédito / Credit
            SANCION: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.SANCION', // Sanción / Sanction
            APORTE_VOLUNTARIO:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.APORTE_VOLUNTARIO', // Aportes Voluntarios / Voluntary Contributions
            OTROS: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.OPTIONS.OTROS', // Otros / Others
          },
        },
        DOCUMENTO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.LABEL', // Documento / Document
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.TOOLTIP', // Número de documento (único por deudor) / Document number (unique per debtor)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.PLACEHOLDER', // Máximo 20 caracteres / Maximum 20 characters
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.REQUIRED', // El documento es requerido / Document is required
          MAX_LENGTH: 'TREASURY.DEDUCTIONS.FORM.FIELDS.DOCUMENTO.MAX_LENGTH', // Máximo 20 caracteres / Maximum 20 characters
        },
        FECHA_INICIO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.LABEL', // Fecha Inicio / Start Date
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.TOOLTIP', // Inicio de la deducción (RN-ALC2-06) / Deduction start (RN-ALC2-06)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.PLACEHOLDER', // dd/MM/yyyy
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_INICIO.REQUIRED', // La fecha de inicio es requerida / Start date is required
        },
        PERIODICIDAD: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.LABEL', // Periodicidad / Frequency
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.TOOLTIP', // Frecuencia de la deducción (RN-ALC2-07) / Deduction frequency (RN-ALC2-07)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.PLACEHOLDER', // Seleccionar periodicidad / Select frequency
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.REQUIRED', // La periodicidad es requerida / Frequency is required
          OPTIONS: {
            POR_CUOTA: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.POR_CUOTA', // Por Cuota / By Installment
            UNICA: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.UNICA', // Única / One-time
            MENSUAL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.MENSUAL', // Mensual / Monthly
            POR_PAGO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PERIODICIDAD.OPTIONS.POR_PAGO', // Por Pago / By Payment
          },
        },
        NO_CUOTA: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.LABEL', // No. de Cuota / Installment Number
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.TOOLTIP', // Número de cuotas (1-999) / Number of installments (1-999)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.PLACEHOLDER', // Ej: 12 / E.g.: 12
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NO_CUOTA.REQUIRED', // El número de cuota es requerido / Installment number is required
        },
        FECHA_FINAL: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINAL.LABEL', // Fecha Final / End Date
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINAL.TOOLTIP', // Fecha de finalización de la deducción / Deduction end date
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINAL.PLACEHOLDER', // dd/MM/yyyy
        },
        TIPO_CALCULO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.LABEL', // Tipo de Cálculo / Calculation Type
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.TOOLTIP', // Valor fijo o porcentaje (RN-ALC2-10) / Fixed value or percentage (RN-ALC2-10)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.PLACEHOLDER', // Seleccionar tipo / Select type
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.REQUIRED', // El tipo de cálculo es requerido / Calculation type is required
          OPTIONS: {
            VALOR: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.OPTIONS.VALOR', // Valor / Value
            PORCENTAJE: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_CALCULO.OPTIONS.PORCENTAJE', // % / %
          },
        },
        VALOR_TOTAL_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.LABEL', // Valor Total a Deducir / Total Amount to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.TOOLTIP', // Monto total a deducir (RN-ALC2-11) / Total amount to deduct (RN-ALC2-11)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.PLACEHOLDER', // 0.00
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.REQUIRED', // El valor total a deducir es requerido para Crédito y Sanción / Total amount to deduct is required for Credit and Sanction
          MUST_BE_GREATER_THAN_ZERO:
            'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIR.MUST_BE_GREATER_THAN_ZERO', // Debe ser mayor a 0 para Crédito y Sanción / Must be greater than 0 for Credit and Sanction
        },
        VALOR_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.LABEL', // Valor a Deducir / Amount to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.TOOLTIP', // Valor por período (editable) / Amount per period (editable)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.PLACEHOLDER', // 0.00
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_DEDUCIR.REQUIRED', // El valor a deducir es requerido / Amount to deduct is required
        },
        PORCENTAJE_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.LABEL', // % a Deducir / % to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.TOOLTIP', // Porcentaje a deducir (0.01 - 100) / Percentage to deduct (0.01 - 100)
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.PLACEHOLDER', // 5.00
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.PORCENTAJE_DEDUCIR.REQUIRED', // El porcentaje a deducir es requerido / Percentage to deduct is required
        },
        ACREEDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.LABEL', // ID Acreedor / Creditor ID
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.TOOLTIP', // Máximo 12 dígitos / Maximum 12 digits
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.PLACEHOLDER', // Seleccione el acreedor / Select the creditor
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.REQUIRED', // El acreedor es requerido / Creditor is required
          SEARCH_TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ACREEDOR.SEARCH_TOOLTIP', // Buscar acreedor / Search creditor
        },
        NOMBRE_ACREEDOR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.LABEL', // Nombre Acreedor / Creditor Name
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.TOOLTIP', // Se autocompleta al seleccionar el ID Acreedor / Auto-completes when selecting Creditor ID
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.PLACEHOLDER', // Se autocompleta / Auto-completes
        },
        CUENTA_CONTABLE: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.LABEL', // Cód. Cuenta Contable / Accounting Account Code
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.TOOLTIP', // Cuenta de movimiento  / Movement account
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.PLACEHOLDER', // Seleccione la cuenta / Select the account
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.REQUIRED', // La cuenta contable es requerida / Accounting account is required
          SEARCH_TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.SEARCH_TOOLTIP', // Buscar cuenta contable / Search accounting account
          NOT_FOUND: 'TREASURY.DEDUCTIONS.FORM.FIELDS.CUENTA_CONTABLE.NOT_FOUND', // Cuenta no existe o no es de movimiento / Account does not exist or is not a movement account
        },
        ESTADO: {
          LABEL: 'COMMON.STATUS', // Estado / Status
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.TOOLTIP', // Activo o Inactivo / Active or Inactive
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.PLACEHOLDER', // Seleccionar estado / Select status
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.REQUIRED', // El estado es requerido / Status is required
          OPTIONS: {
            ACTIVO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.OPTIONS.ACTIVO', // Activo / Active
            INACTIVO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.OPTIONS.INACTIVO',
            FINALIZADO: 'TREASURY.DEDUCTIONS.FORM.FIELDS.ESTADO.OPTIONS.FINALIZADO', // Finalizado / Finalized // Inactivo / Inactive
          },
        },
        VALOR_TOTAL_DEDUCIDO: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIDO.LABEL', // Valor Total Deducido / Total Deducted Amount
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.VALOR_TOTAL_DEDUCIDO.TOOLTIP', // Suma de egresos aplicados / Sum of applied expenses
        },
        SALDO_POR_DEDUCIR: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.SALDO_POR_DEDUCIR.LABEL', // Saldo Por Deducir / Balance to Deduct
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.SALDO_POR_DEDUCIR.TOOLTIP', // Saldo pendiente / Pending balance
        },
        FECHA_FINALIZACION: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINALIZACION.LABEL', // Fecha Finalización / Finalization Date
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINALIZACION.TOOLTIP', // Fecha en que se finaliza la deducción / Date when the deduction is finalized
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.FECHA_FINALIZACION.REQUIRED', // La fecha de finalización es requerida / Finalization date is required
        },
        MOTIVO_FINALIZACION: {
          LABEL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.LABEL', // Motivo Finalización / Finalization Reason
          TOOLTIP: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.TOOLTIP', // Motivo por el cual se finaliza la deducción / Reason why the deduction is finalized
          PLACEHOLDER: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.PLACEHOLDER', // Seleccionar motivo / Select reason
          REQUIRED: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.REQUIRED', // El motivo de finalización es requerido / Finalization reason is required
          OPTIONS: {
            PAGO_TOTAL: 'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.PAGO_TOTAL', // Pago total / Total payment
            CANCELACION_ANTICIPADA:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.CANCELACION_ANTICIPADA', // Cancelación anticipada / Early cancellation
            AJUSTE_POR_ENTIDAD:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.AJUSTE_POR_ENTIDAD', // Ajuste por entidad / Entity adjustment
            ERROR_EN_REGISTRO:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.ERROR_EN_REGISTRO', // Error en registro / Registration error
            RETIRO_DEL_TRABAJADOR:
              'TREASURY.DEDUCTIONS.FORM.FIELDS.MOTIVO_FINALIZACION.OPTIONS.RETIRO_DEL_TRABAJADOR', // Retiro del trabajador / Worker withdrawal
          },
        },
      },

      VALIDATIONS: {
        REQUIRED_FIELD: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.REQUIRED_FIELD', // Campo requerido / This field is required
        MAX_LENGTH: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.MAX_LENGTH', // Máximo {max} caracteres / Maximum {max} characters
        MUST_BE_GREATER_THAN: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.MUST_BE_GREATER_THAN', // Debe ser mayor a {min} / Must be greater than {min}
        FECHA_MENOR_MES_CERRADO: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.FECHA_MENOR_MES_CERRADO', // No puede ser menor al mes cerrado / Cannot be earlier than the closed month
        FECHA_FINAL_MENOR_UN_MES: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.FECHA_FINAL_MENOR_UN_MES', // Debe ser al menos un mes superior / Must be at least one month later
        CUOTA_MAYOR_CERO: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.CUOTA_MAYOR_CERO', // Debe ser >0 / Must be >0
        CUOTA_VALID_RANGE: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.CUOTA_VALID_RANGE', // Número de cuotas válido (1-999) / Valid installment number (1-999)
        PORCENTAJE_VALID_RANGE: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.PORCENTAJE_VALID_RANGE', // Porcentaje debe estar entre 0.01 y 100 / Percentage must be between 0.01 and 100
        DOCUMENTO_UNIQUE: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.DOCUMENTO_UNIQUE', // El documento ya existe para este deudor / Document already exists for this debtor
        FECHA_FINALIZACION_FUTURA: 'TREASURY.DEDUCTIONS.FORM.VALIDATIONS.FECHA_FINALIZACION_FUTURA',
      },
    },

    MODALS: {
      DEUDOR: {
        TITLE: 'TREASURY.DEDUCTIONS.MODALS.DEUDOR.TITLE', // Seleccionar Deudor / Select Debtor
      },
      ACREEDOR: {
        TITLE: 'TREASURY.DEDUCTIONS.MODALS.ACREEDOR.TITLE', // Seleccionar Acreedor / Select Creditor
      },
      CUENTA_CONTABLE: {
        TITLE: 'TREASURY.DEDUCTIONS.MODALS.CUENTA_CONTABLE.TITLE', // Seleccionar Cuenta Contable / Select Accounting Account
      },
    },

    ALERTS: {
      LOAD_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.LOAD_ERROR.TITLE', // Error al cargar datos / Error loading data
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.LOAD_ERROR.MESSAGE', // Ocurrió un error al cargar los datos / An error occurred while loading data
      },
      SAVE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_SUCCESS.TITLE', // Deducción guardada / Deduction saved
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_SUCCESS.MESSAGE', // La deducción ha sido guardada exitosamente / The deduction has been saved successfully
      },
      SAVE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_ERROR.TITLE', // Error al guardar / Error saving
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SAVE_ERROR.MESSAGE', // Ocurrió un error al guardar la deducción / An error occurred while saving the deduction
      },
      UPDATE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_SUCCESS.TITLE', // Deducción actualizada / Deduction updated
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_SUCCESS.MESSAGE', // La deducción ha sido actualizada exitosamente / The deduction has been updated successfully
      },
      UPDATE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_ERROR.TITLE', // Error al actualizar / Error updating
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.UPDATE_ERROR.MESSAGE', // Ocurrió un error al actualizar la deducción / An error occurred while updating the deduction
      },
      DELETE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_SUCCESS.TITLE', // Deducción eliminada / Deduction deleted
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_SUCCESS.MESSAGE', // La deducción ha sido eliminada exitosamente / The deduction has been deleted successfully
      },
      DELETE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_ERROR.TITLE', // Error al eliminar / Error deleting
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.DELETE_ERROR.MESSAGE', // Ocurrió un error al eliminar la deducción / An error occurred while deleting the deduction
      },
      FINALIZE_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_SUCCESS.TITLE', // Deducción finalizada / Deduction finalized
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_SUCCESS.MESSAGE', // La deducción ha sido finalizada exitosamente / The deduction has been finalized successfully
      },
      FINALIZE_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_ERROR.TITLE', // Error al finalizar / Error finalizing
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.FINALIZE_ERROR.MESSAGE', // Ocurrió un error al finalizar la deducción / An error occurred while finalizing the deduction
      },
      SELECTION_SUCCESS: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_SUCCESS.TITLE', // Selección exitosa / Selection successful
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_SUCCESS.MESSAGE', // {type} seleccionado: {value} / {type} selected: {value}
      },
      SELECTION_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_ERROR.TITLE', // Error en la selección / Selection error
        MESSAGE: 'TREASURY.DEDUCTIONS.ALERTS.SELECTION_ERROR.MESSAGE', // {type} no existe o no está activo / {type} does not exist or is not active
      },
      PERMISSION_ERROR: {
        TITLE: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.TITLE', // Permiso denegado / Permission denied
        EDIT_DENIED: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.EDIT_DENIED', // Solo se puede editar una deducción en estado Activo o Inactivo (RN-ALC1-08) / Only a deduction in Active or Inactive status can be edited (RN-ALC1-08)
        FINALIZE_DENIED: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.FINALIZE_DENIED', // Solo se puede finalizar una deducción Activa o Inactiva (RN-ALC1-08) / Only an Active or Inactive deduction can be finalized (RN-ALC1-08)
        DELETE_DENIED: 'TREASURY.DEDUCTIONS.ALERTS.PERMISSION_ERROR.DELETE_DENIED', // Solo se puede eliminar una deducción Inactiva y sin egresos asociados (RN-ALC5-01/02) / Only an Inactive deduction with no associated expenses can be deleted (RN-ALC5-01/02)
      },
    },

    CONFIRM_DIALOGS: {
      CANCEL: {
        TITLE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.TITLE', // Cancelar cambios / Cancel changes
        MESSAGE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.MESSAGE', // ¿Está seguro de que desea cancelar los cambios? Se perderán todas las modificaciones no guardadas. / Are you sure you want to cancel the changes? All unsaved modifications will be lost.
        CONFIRM_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.CONFIRM_LABEL', // Sí, cancelar / Yes, cancel
        CANCEL_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.CANCEL.CANCEL_LABEL', // Continuar editando / Continue editing
      },
      DELETE: {
        TITLE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.DELETE.TITLE', // Eliminar deducción / Delete deduction
        MESSAGE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.DELETE.MESSAGE', // Se va a eliminar la deducción {consecutivo} (MSG-18)\n¿Está seguro? / The deduction {consecutivo} is going to be deleted (MSG-18)\nAre you sure?
        CONFIRM_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.DELETE.CONFIRM_LABEL', // Sí, eliminar / Yes, delete
        CANCEL_LABEL: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      },
      FINALIZE: {
        TITLE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.FINALIZE.TITLE', // Confirmar finalización / Confirm finalization
        MESSAGE: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.FINALIZE.MESSAGE', // ¿Está seguro que desea finalizar la deducción {consecutivo}? / Are you sure you want to finalize deduction {consecutivo}?
        CONFIRM_LABEL: 'TREASURY.DEDUCTIONS.CONFIRM_DIALOGS.FINALIZE.CONFIRM_LABEL', // Finalizar / Finalize
        CANCEL_LABEL: 'ACTIONS.CANCEL', // Cancelar / Cancel (common_keys)
      },
    },

    ACTIONS: {
      CREATE: 'ACTIONS.CREATE', // Crear / Create (common / abstract CRUD)
      REFRESH: 'ACTIONS.REFRESH', // Refrescar / Refresh
      CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
      SAVE: 'ACTIONS.SAVE', // Guardar / Save
      BACK: 'ACTIONS.BACK', // Volver / Back
      SAVING: 'ACTIONS.SAVING', // Guardando... / Saving... (common_keys)
      FINALIZE: 'TREASURY.DEDUCTIONS.ACTIONS.FINALIZE', // Finalizar / Finalize (específico HU)
      FINALIZING: 'TREASURY.DEDUCTIONS.ACTIONS.FINALIZING', // Finalizando... / Finalizing...
      DELETE: 'ACTIONS.DELETE', // Eliminar / Delete (common_keys)
      EDIT: 'ACTIONS.EDIT', // Editar / Edit (common_keys)
      VIEW: 'ACTIONS.VIEW', // Consultar / View (common_keys)
      ACCEPT: 'ACTIONS.ACCEPT', // Aceptar / Accept (common_keys)
      ANNUL: 'ACTION.ANNUL', // Anular / Annul (common_keys)
    },

    ACTION: {
      ANNUL: 'ACTION.ANNUL', // Anular / Annul (common_keys)
    },

    ERROR_MESSAGES: {
      REQUIRED_FIELD: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.REQUIRED_FIELD', // Campo requerido / This field is required
      INVALID_FORM: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.INVALID_FORM', // Existen campos obligatorios por diligenciar (MSG-14) / There are required fields to fill (MSG-14)
      VALOR_TOTAL_INVALID: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.VALOR_TOTAL_INVALID', // Valor Total a Deducir debe ser mayor a 0 para Crédito y Sanción / Total Amount to Deduct must be greater than 0 for Credit and Sanction
      VALOR_TOTAL_REQUERIDO: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.VALOR_TOTAL_REQUERIDO', // El Valor Total a Deducir es obligatorio para Crédito y Sanción / Total Amount to Deduct is required for Credit and Penalty
      CUENTA_INVALIDA: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.CUENTA_INVALIDA', // La cuenta no existe o no es de movimiento / The account does not exist or is not a movement account
      TERCERO_INVALIDO: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.TERCERO_INVALIDO', // El tercero no existe o no está activo / The third party does not exist or is not active
      CUOTAS_MENOR_PAGADA: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.CUOTAS_MENOR_PAGADA', // No puede reducir el número de cuotas por debajo de la cuota ya pagada / The number of installments cannot be reduced below the installment already paid
      CON_EGRESOS: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.CON_EGRESOS', // No se puede eliminar la deducción porque tiene egresos asociados / The deduction cannot be deleted because it has associated expenses
      DOCUMENTO_EXISTS: 'TREASURY.DEDUCTIONS.ERROR_MESSAGES.DOCUMENTO_EXISTS', // El documento ya existe para este deudor / The document already exists for this debtor
    },

    INFO_MESSAGES: {
      DEUDOR_SELECTED: 'TREASURY.DEDUCTIONS.INFO_MESSAGES.DEUDOR_SELECTED', // Deudor seleccionado: {value} / Debtor selected: {value}
      ACREEDOR_SELECTED: 'TREASURY.DEDUCTIONS.INFO_MESSAGES.ACREEDOR_SELECTED', // Acreedor seleccionado: {value} / Creditor selected: {value}
      CUENTA_SELECTED: 'TREASURY.DEDUCTIONS.INFO_MESSAGES.CUENTA_SELECTED', // Cuenta contable seleccionada: {value} / Accounting account selected: {value}
    },

    // Convencion de la grilla declarativa: la base compone estas claves con el prefijo de la
    // pantalla, de modo que buscador, contador y vacio se resuelven sin declararlos en cada uso.
    SEARCH_PLACEHOLDER: 'TREASURY.DEDUCTIONS.SEARCH_PLACEHOLDER', // Buscar deducciones... / Search deductions...
    COUNTER: {
      SINGULAR: 'TREASURY.DEDUCTIONS.COUNTER.SINGULAR', // deducción / deduction
      PLURAL: 'TREASURY.DEDUCTIONS.COUNTER.PLURAL', // deducciones / deductions
    },

    SECTIONS: {
      DATOS: 'TREASURY.DEDUCTIONS.SECTIONS.DATOS', // Datos de la Deducción / Deduction Data
      VALORES_DEDUCIDOS: 'TREASURY.DEDUCTIONS.SECTIONS.VALORES_DEDUCIDOS', // Valores Deducidos / Deducted Amounts
      FINALIZACION: 'TREASURY.DEDUCTIONS.SECTIONS.FINALIZACION', // Finalización / Finalization
      DETALLE: 'TREASURY.DEDUCTIONS.SECTIONS.DETALLE', // Detalle Deducción / Deduction Detail
    },

    DETAIL: {
      COLUMNS: {
        CUOTA: 'TREASURY.DEDUCTIONS.DETAIL.COLUMNS.CUOTA', // Cuota / Installment
        FECHA_CUOTA: 'TREASURY.DEDUCTIONS.DETAIL.COLUMNS.FECHA_CUOTA', // Fecha Cuota / Installment Date
        VALOR: 'TREASURY.DEDUCTIONS.DETAIL.COLUMNS.VALOR', // Valor Deducción / Deduction Amount
        ESTADO: 'TREASURY.DEDUCTIONS.DETAIL.COLUMNS.ESTADO', // Estado / Status
      },
      EMPTY: 'TREASURY.DEDUCTIONS.DETAIL.EMPTY', // No hay cuotas o egresos asociados a esta deducción / There are no installments or expenses associated with this deduction
    },

    BADGE: {
      VARIANTS: {
        ACTIVO: 'TREASURY.DEDUCTIONS.BADGE.VARIANTS.ACTIVO', // success
        INACTIVO: 'TREASURY.DEDUCTIONS.BADGE.VARIANTS.INACTIVO', // warning
        FINALIZADO: 'TREASURY.DEDUCTIONS.BADGE.VARIANTS.FINALIZADO', // neutral
      },
    },

    PANEL: {
      SUMMARY: 'TREASURY.DEDUCTIONS.PANEL.SUMMARY', // Resumen / Summary
      SUMMARY_TITLE_EMPTY: 'TREASURY.DEDUCTIONS.PANEL.SUMMARY_TITLE_EMPTY', // Sin documento / No document
      CHECKLIST: 'TREASURY.DEDUCTIONS.PANEL.CHECKLIST', // Antes de guardar / Before saving
      USAGE: 'TREASURY.DEDUCTIONS.PANEL.USAGE', // Cómo se usa / How to use
      USAGE_HINT: 'TREASURY.DEDUCTIONS.PANEL.USAGE_HINT', // Por cuota, el valor de cada cuota y la fecha final se calculan... / By installment, the value of each installment and the end date are calculated...
    },
  },
  EXPENSES: {
    COLUMN: {
      COST_CENTER_CODE: 'TREASURY.EXPENSES.COLUMN.COST_CENTER_CODE',
      REFERENCE_DOCUMENT: 'TREASURY.EXPENSES.COLUMN.REFERENCE_DOCUMENT',
    },
    MESSAGES: {
      MAXIMUM_20_CHARACTERS_AND_2_DECIMALS:
        'TREASURY.EXPENSES.MESSAGES.MAXIMUM_20_CHARACTERS_AND_2_DECIMALS',
      THIRD_PARTY_SEARCH_ERROR: 'TREASURY.EXPENSES.MESSAGES.THIRD_PARTY_SEARCH_ERROR',
      EMPTY_ROWS_BEFORE_ADD: 'TREASURY.EXPENSES.MESSAGES.EMPTY_ROWS_BEFORE_ADD',
      SELECT_COST_CENTER: 'TREASURY.EXPENSES.MESSAGES.SELECT_COST_CENTER',
      COST_CENTER_SELECTED: 'TREASURY.EXPENSES.MESSAGES.COST_CENTER_SELECTED',
      COST_CENTER_SEARCH_ERROR: 'TREASURY.EXPENSES.MESSAGES.COST_CENTER_SEARCH_ERROR',
    },
    // La grilla declarativa compone estas tres por convencion, a partir del prefijo de la pantalla.
    SEARCH_PLACEHOLDER: 'TREASURY.EXPENSES.SEARCH_PLACEHOLDER', // Buscar por consecutivo, identificación o nombre del tercero...
    COUNTER: {
      LABEL_SINGULAR: 'TREASURY.EXPENSES.COUNTER.LABEL_SINGULAR', // Comprobante de egreso
      LABEL_PLURAL: 'TREASURY.EXPENSES.COUNTER.LABEL_PLURAL', // Comprobantes de egreso
      SINGULAR: 'TREASURY.EXPENSES.COUNTER.SINGULAR', // comprobante de egreso
      PLURAL: 'TREASURY.EXPENSES.COUNTER.PLURAL', // comprobantes de egreso
    },

    ACTION: {
      SCHEDULE: 'TREASURY.EXPENSES.ACTION.SCHEDULE', // Programar
      SEARCH_COST_CENTER: 'TREASURY.EXPENSES.ACTION.SEARCH_COST_CENTER', // Buscar Centro de Costosin
    },

    SCHEDULE: {
      TITLE: 'TREASURY.EXPENSES.SCHEDULE.TITLE', // Programar comprobante(s)
      DESCRIPTION: 'TREASURY.EXPENSES.SCHEDULE.DESCRIPTION', // ¿Está seguro que desea programar los documentos seleccionados?
      PAYMENT_DATE_PLACEHOLDER: 'TREASURY.EXPENSES.SCHEDULE.PAYMENT_DATE_PLACEHOLDER', // Seleccione la fecha de pago
      PAYMENT_DATE_REQUIRED: 'TREASURY.EXPENSES.SCHEDULE.PAYMENT_DATE_REQUIRED', // Debe seleccionar una fecha de pago
    },

    ALERTS: {
      SCHEDULE_SUCCESS: {
        MESSAGE: 'TREASURY.EXPENSES.ALERTS.SCHEDULE_SUCCESS.MESSAGE', // Comprobantes programados
      },
      SCHEDULE_ERROR: {
        MESSAGE: 'TREASURY.EXPENSES.ALERTS.SCHEDULE_ERROR.MESSAGE', // No fue posible programar los comprobantes
      },
      SCHEDULE_EXCLUDED: 'TREASURY.EXPENSES.ALERTS.SCHEDULE_EXCLUDED', // Excluidos: {{documentos}}
    },

    EMPTY: {
      MESSAGE: 'TREASURY.EXPENSES.EMPTY.MESSAGE', // No hay comprobantes de egreso para mostrar
      DESCRIPTION: 'TREASURY.EXPENSES.EMPTY.DESCRIPTION', // Ajuste el rango de fechas o el término de búsqueda.
      PAYMENT_ORDERS: {
        MESSAGE: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.PAYMENT_ORDERS',
        DESCRIPTION: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.PAYMENT_ORDERS_DESC',
      },
      STATUS_HISTORY: {
        MESSAGE: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.STATUS_LOG',
        DESCRIPTION: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.STATUS_LOG_DESC',
      },
      DETAILS: {
        MESSAGE: 'TREASURY.EXPENSE.EMPTY.DETAILS', //No hay Detalles
        DESCRIPTION: 'TREASURY.EXPENSE.EMPTY.DETAILS_DESC', //Este comprobante no tiene detalles registrados
      },
    },

    TITLE: {
      LIST: 'TREASURY.EXPENSES.TITLE.LIST', // Comprobantes de egreso
      CREATE: 'TREASURY.EXPENSES.TITLE.CREATE', // Crear comprobante de egreso
      VIEW: 'TREASURY.EXPENSES.TITLE.VIEW', // Consultar comprobante de egreso
    },
    SUBTITLE: {
      LIST: 'TREASURY.EXPENSES.SUBTITLE.LIST', // Gestión de comprobantes de egreso
      CREATE: 'TREASURY.EXPENSES.SUBTITLE.CREATE', // Registre la información del comprobante de egreso
      VIEW: 'TREASURY.EXPENSES.SUBTITLE.VIEW', // Consulte la información del comprobante de egreso
    },
    COLUMNS: {
      EXPENSE_TYPE: 'TREASURY.EXPENSES.COLUMNS.EXPENSE_TYPE', // Tipo de egreso
      SEQUENCE: 'TREASURY.EXPENSES.COLUMNS.SEQUENCE', // Consecutivo
      IDENTIFICATION_NUMBER: 'TREASURY.PARAMETERS.FIELDS.IDENTIFICATION.LABEL', // No. Identificación
      NAME_OR_BUSINESS_NAME:
        'ACCOUNTING.ENTRY_DEFERRED.DEFERRED_MONTH_TABLE.COLUMN.NAME_OR_BUSINESS_NAME', // Nombre o razón social
      EXPENSE_DATE: 'TREASURY.EXPENSES.COLUMNS.EXPENSE_DATE', // Fecha del comprobante de egreso
      PAYMENT_DATE: 'TREASURY.EXPENSES.COLUMNS.PAYMENT_DATE', // Fecha de pago
      TOTAL_AMOUNT: 'ACCOUNTING.CAUSACION.COLUMNS_NAMES.VALOR_TOTAL', // Valor total
    },
    LABEL: {
      EXPENSE_TYPE: 'TREASURY.EXPENSES.LABEL.EXPENSE_TYPE', // Tipo de egreso
      VOUCHER_NET_AMOUNT: 'TREASURY.EXPENSES.LABEL.VOUCHER_NET_AMOUNT', // Valor neto del comprobante de egreso
      ENTRY_TYPE: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.LABEL', // Tipo de asiento
      BENEFICIARY_IS_OTHER_THIRD_PARTY: 'TREASURY.EXPENSES.LABEL.BENEFICIARY_IS_OTHER_THIRD_PARTY', // ¿El beneficiario es otro tercero?
      BENEFICIARY_IDENTIFICATION: 'TREASURY.EXPENSES.LABEL.BENEFICIARY_IDENTIFICATION', // No. identificación del beneficiario
      BENEFICIARY_NAME: 'TREASURY.EXPENSES.LABEL.BENEFICIARY_NAME', // Nombre del beneficiario
      CREATED_BY: 'TREASURY.EXPENSES.LABEL.CREATED_BY', // Elaboró
      APPROVED_BY: 'TREASURY.EXPENSES.LABEL.APPROVED_BY', // Aprobó
      MONTH: 'ACCOUNTING.ENTRY_DEFERRED.LABEL.MES', // Mes
      MUNICIPALITY: 'OPTIONS.MUNICIPALITY', // Municipio
      VALIDITY: 'PLACEHOLDER.VALIDITY', // Vigencia
      ACCOUNT_OD: 'TREASURY.EXPENSES.LABEL.ACCOUNT_OD', // Cód. cuenta (OD)
      PAYMENT_ORDERS: {
        NO_OP: 'TREASURY.EXPENSES.LABEL.PAYMENT_ORDERS.NO_OP', // No. orden de pago
      },
    },
    DEDUCTIONS: {
      VOUCHER_NUMBER: 'TREASURY.EXPENSES.DEDUCTIONS.VOUCHER_NUMBER', // No. comprobante de egreso
    },
    TAB: {
      PAYMENT_ORDERS: 'TREASURY.EXPENSES.TAB.PAYMENT_ORDERS', //Ordenes de pago
      STATUS_LOG: 'TREASURY.EXPENSES.TAB.STATUS_LOG', //Bitácora de estados
      DEDUCTIONS: 'TREASURY.EXPENSES.TAB.DEDUCTIONS', //Deducciones Aplicadas
      TITLE: {
        GENERAL_INFO: 'TREASURY.EXPENSES.TAB.TITLE.GENERAL_INFO',
        VOUCHER_DATA: 'TREASURY.EXPENSES.TAB.TITLE.VOUCHER_DATA',
        PAYMENT_ORDERS: 'TREASURY.EXPENSES.TAB.TITLE.PAYMENT_ORDERS',
        STATUS_LOG: 'TREASURY.EXPENSES.TAB.TITLE.STATUS_LOG',
        DEDUCTIONS: 'TREASURY.EXPENSES.TAB.TITLE.DEDUCTIONS',
      },
      SUBTITLE: {
        GENERAL_INFO: 'TREASURY.EXPENSES.TAB.SUBTITLE.GENERAL_INFO',
        VOUCHER_DATA: 'TREASURY.EXPENSES.TAB.SUBTITLE.VOUCHER_DATA',
        PAYMENT_ORDERS: 'TREASURY.EXPENSES.TAB.SUBTITLE.PAYMENT_ORDERS',
        STATUS_LOG: 'TREASURY.EXPENSES.TAB.SUBTITLE.STATUS_LOG',
        DEDUCTIONS: 'TREASURY.EXPENSES.TAB.SUBTITLE.DEDUCTIONS',
      },
    },

    PLACEHOLDER: {
      EXPENSE_TYPE: 'TREASURY.EXPENSES.PLACEHOLDER.EXPENSE_TYPE', // Seleccione el tipo de egreso
      BENEFICIARY_IS_OTHER_THIRD_PARTY:
        'TREASURY.EXPENSES.PLACEHOLDER.BENEFICIARY_IS_OTHER_THIRD_PARTY', // Seleccione una opción
      ENTRY_TYPE: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.PLACEHOLDER', // Seleccione el tipo de asiento
      SEARCH_COST_CENTER: 'TREASURY.EXPENSES.PLACEHOLDER.SEARCH_COST_CENTER',
      COST_CENTER_EXAMPLE: 'TREASURY.EXPENSES.PLACEHOLDER.COST_CENTER_EXAMPLE',
      REFERENCE_DOCUMENT_EXAMPLE: 'TREASURY.EXPENSES.PLACEHOLDER.REFERENCE_DOCUMENT_EXAMPLE',
      SELECT_APPROVER: 'TREASURY.EXPENSES.PLACEHOLDER.SELECT_APPROVER', // Seleccione un aprobador
    },
    TOOLTIP: {
      BENEFICIARY_IDENTIFICATION: 'TREASURY.EXPENSES.TOOLTIP.BENEFICIARY_IDENTIFICATION', // Identificación del tercero que recibirá el pago
      BENEFICIARY_NAME: 'TREASURY.EXPENSES.TOOLTIP.BENEFICIARY_NAME', // Nombre o razón social del beneficiario
      BENEFICIARY_IS_OTHER_THIRD_PARTY:
        'TREASURY.EXPENSES.TOOLTIP.BENEFICIARY_IS_OTHER_THIRD_PARTY', // Indique si el pago se realizará a un tercero diferente
      CONCEPT: 'TREASURY.EXPENSES.TOOLTIP.CONCEPT', // Concepto configurado en parámetros de tesorería
      EXPENSE_TYPE: 'TREASURY.EXPENSES.TOOLTIP.EXPENSE_TYPE', // Seleccione el tipo de comprobante de egreso
      ENTRY_TYPE: 'TREASURY.EXPENSES.TOOLTIP.ENTRY_TYPE', // Tipos de asiento asociados al concepto
      DEDUCTIONS_TYPE: 'TREASURY.EXPENSES.TOOLTIP.DEDUCTIONS_TYPE', // Tipo de deducción aplicable al comprobante
      MONTH: 'TREASURY.EXPENSES.TOOLTIP.MONTH', // Mes al que corresponde la deducción
      MUNICIPALITY: 'TREASURY.EXPENSES.TOOLTIP.MUNICIPALITY', // Municipio asociado a la deducción
      ACCOUNT_OD: 'TREASURY.EXPENSES.TOOLTIP.ACCOUNT_OD', // Código de la cuenta OD asociada
      ACCOUNT_OD_NAME: 'TREASURY.EXPENSES.TOOLTIP.ACCOUNT_OD_NAME', // Nombre de la cuenta OD asociada
      CREATED_BY: 'TREASURY.EXPENSES.TOOLTIP.CREATED_BY', // Usuario que elaboró el comprobante
      APPROVED_BY: 'TREASURY.EXPENSES.TOOLTIP.APPROVED_BY', // Usuario responsable de aprobar el comprobante
      TOTAL_AMOUNT: 'TREASURY.EXPENSES.TOOLTIP.TOTAL_AMOUNT', // Valor total del comprobante de egreso
      DESCRIPTION: 'TREASURY.EXPENSES.TOOLTIP.DESCRIPTION', // Descripción del detalle contable
      VALIDITY: 'TREASURY.EXPENSES.TOOLTIP.VALIDITY', // Mes al que corresponde la deducción
    },
    // El bundle guarda estos valores bajo el prefijo TREASURY.EXPENSE —en SINGULAR—, que es el que
    // usan las opciones del formulario. Aqui figuraban en plural, de modo que quien tomara la
    // etiqueta de este catalogo pintaba la clave cruda en pantalla.
    TYPE: {
      WITH_PO: 'TREASURY.EXPENSE.TYPE.WITH_PO', // Egreso con orden de pago
      WITHOUT_PO: 'TREASURY.EXPENSE.TYPE.WITHOUT_PO', // Egreso sin orden de pago
      DEDUCTIONS: 'TREASURY.EXPENSE.TYPE.DEDUCTIONS', // Deducciones
      EMBARGOES: 'TREASURY.EXPENSE.TYPE.EMBARGOES', // Embargos
    },
    STATUS: {
      FOR_PAYMENT: 'TREASURY.EXPENSE.STATUS.FOR_PAYMENT', // Para pago
      TO_BE_SCHEDULED: 'TREASURY.EXPENSE.STATUS.TO_BE_SCHEDULED', // Por programar
      ISSUED: 'TREASURY.EXPENSE.STATUS.ISSUED', // Girado
      TO_TRANSFER: 'TREASURY.EXPENSE.STATUS.TO_TRANSFER', // Por transferir
      TRANSFERRED: 'TREASURY.EXPENSE.STATUS.TRANSFERRED', // Transferido
      CONFIRMED: 'TREASURY.EXPENSE.STATUS.CONFIRMED', // Confirmado
      CANCELED: 'TREASURY.EXPENSE.STATUS.CANCELED', // Anulado
      REJECTED: 'TREASURY.EXPENSE.STATUS.REJECTED', // Rechazado
    },
    STATUS_LOG: {
      DATE_TIME: 'TREASURY.EXPENSES.STATUS_LOG.DATE_TIME', // Fecha y hora
      USER: 'TREASURY.EXPENSES.STATUS_LOG.USER', // Usuario
      PREVIOUS_STATUS: 'TREASURY.EXPENSES.STATUS_LOG.PREVIOUS_STATUS', // Estado anterior
      NEW_STATUS: 'TREASURY.EXPENSES.STATUS_LOG.NEW_STATUS', // Estado nuevo
      OBSERVATIONS: 'TREASURY.EXPENSES.STATUS_LOG.OBSERVATIONS', // Observaciones
    },

    SECTION: {
      HEADER: 'TREASURY.EXPENSES.SECTION.HEADER', // Encabezado
      GENERAL: 'ACCOUNTING.THIRD_PARTY.FORM.GENERAL_DATA', // General
      THIRD_PARTY_DATA: 'TREASURY.EXPENSES.SECTION.THIRD_PARTY_DATA', // Datos del tercero
      ACCOUNT_DETAILS: 'TREASURY.EXPENSES.SECTION.ACCOUNT_DETAILS', // Detalle de cuentas
      BUDGET_INFORMATION: 'TREASURY.EXPENSES.SECTION.BUDGET_INFORMATION', // Información presupuestal
      APPROVAL_AND_ACTIONS: 'TREASURY.EXPENSES.SECTION.APPROVAL_AND_ACTIONS', // Aprobación y acciones
      DEDUCTION_SETTINGS: 'TREASURY.EXPENSES.SECTION.DEDUCTION_SETTINGS', // Parámetros de deducción
      STATUS_HISTORY: 'TREASURY.EXPENSES.TAB.STATUS_LOG', // Bitácora de estados
      SUBTITLE: {
        GENERAL: 'ACCOUNTING.THIRD_PARTY.FORM.GENERAL_DATA', // Configuración general del comprobante.
        THIRD_PARTY_DATA: 'TREASURY.EXPENSES.SECTION.SUBTITLE.THIRD_PARTY_DATA', // Identifique el tercero relacionado con el comprobante.
        ACCOUNT_DETAILS: 'TREASURY.EXPENSES.SECTION.SUBTITLE.ACCOUNT_DETAILS', // Configure las cuentas contables y los valores asociados al comprobante.
        BUDGET_INFORMATION: 'TREASURY.EXPENSES.SECTION.SUBTITLE.BUDGET_INFORMATION', // Registre la información presupuestal asociada al comprobante.
        APPROVAL_AND_ACTIONS: 'TREASURY.EXPENSES.SECTION.SUBTITLE.APPROVAL_AND_ACTIONS', // Gestione la aprobación y las acciones disponibles para el comprobante.
        PAYMENT_ORDER: 'TREASURY.EXPENSES.SECTION.SUBTITLE.PAYMENT_ORDER', // Seleccione la orden de pago y registre la información correspondiente al beneficiario y los valores a pagar.
        DEDUCTION_SETTINGS: 'TREASURY.EXPENSES.SECTION.SUBTITLE.DEDUCTION_SETTINGS', // Configure los parámetros y valores aplicables a las deducciones del comprobante.
        STATUS_HISTORY: 'TREASURY.EXPENSES.TAB.SUBTITLE.STATUS_LOG', //  Historial de cambios de estado del comprobante
      },
    },
    /** Panel lateral del formulario: resumen, pendientes y nota de uso. */
    PANEL: {
      SUMMARY: 'TREASURY.EXPENSES.PANEL.SUMMARY', // Resumen / Summary
      SUMMARY_TITLE_EMPTY: 'TREASURY.EXPENSES.PANEL.SUMMARY_TITLE_EMPTY', // Comprobante sin tercero / Voucher without third party
      CHECKLIST: 'TREASURY.EXPENSES.PANEL.CHECKLIST', // Pendientes / Pending
      USAGE: 'TREASURY.EXPENSES.PANEL.USAGE', // Cómo se usa / How to use
      USAGE_HINT: 'TREASURY.EXPENSES.PANEL.USAGE_HINT', // Elija primero el tipo de egreso: con orden de pago se pagan las órdenes del tercero; sin orden de pago se registran las cuentas; en deducciones las cuentas salen del tipo de deducción. La programación del pago se hace desde el listado. / Choose the expense type first: with a payment order, the third party's orders are paid; without a payment order, the accounts are entered; for deductions, the accounts come from the deduction type. Payment scheduling is done from the list.
    },
    MODAL: {
      ACCOUNTS: {
        TITLE: 'TREASURY.EXPENSES.MODAL.ACCOUNTS.TITLE', // Seleccione una cuenta OD
      },
    },
    TABLE: {
      COLUMNS: {
        PAYMENT_ORDER_BALANCE: 'TREASURY.EXPENSES.TABLE.COLUMNS.PAYMENT_ORDER_BALANCE', // Saldo de la orden de pago
        PAID_AMOUNT: 'TREASURY.EXPENSES.TABLE.COLUMNS.PAID_AMOUNT', // Valor pagado en el comprobante de egreso
      },
    },
  },

  /** HU-TES-010 — Banco / Pagos (giro de comprobantes de egreso). */
  BANK_PAYMENTS: {
    // La grilla declarativa compone estas por convencion, a partir del prefijo de la pantalla. El
    // contador y la descripcion de la tabla vacia ya existian con este mismo prefijo.
    SEARCH_PLACEHOLDER: 'TREASURY.BANK_PAYMENTS.SEARCH_PLACEHOLDER', // Buscar por identificación o nombre del tercero...
    TITLE: {
      LIST: 'TREASURY.BANK_PAYMENTS.TITLE.LIST', // Pagos Bancarios / Banco Pagos
      VIEW: 'TREASURY.BANK_PAYMENTS.TITLE.VIEW', // Consultar comprobante para pago
    },
    SUBTITLE: {
      LIST: 'TREASURY.BANK_PAYMENTS.SUBTITLE.LIST', // Comprobantes de egreso programados para pago
      VIEW: 'TREASURY.BANK_PAYMENTS.SUBTITLE.VIEW', // Detalle del comprobante de egreso
    },
    SECTION: {
      LIST: 'TREASURY.BANK_PAYMENTS.SECTION.LIST', // Listado de Egresos para Pago
      PAYMENT: 'TREASURY.BANK_PAYMENTS.SECTION.PAYMENT', // Datos para el Pago
      VOUCHER: 'TREASURY.BANK_PAYMENTS.SECTION.VOUCHER', // Datos Comprobante de Egresos
    },
    /**
     * Tabs de consultar: reutiliza keys ya en BD.
     * GENERAL → Accounting terceros; STATUS_LOG/DEDUCTIONS/labels → Egresos (TES).
     */
    TAB: {
      GENERAL: 'TREASURY.EXPENSES.TAB.TITLE.GENERAL_INFO', // Información general
      GENERAL_SUB: 'TREASURY.EXPENSES.TAB.SUBTITLE.GENERAL_INFO',
      VOUCHER: 'TREASURY.BANK_PAYMENTS.SECTION.VOUCHER', // Datos Comprobante de Egresos
      VOUCHER_SUB: 'TREASURY.BANK_PAYMENTS.SUBTITLE.VIEW',
      PAYMENT_ORDERS: 'ACCOUNTING.CAUSACION.TAB.ORDEN_PAGO', // Orden de Pago
      PAYMENT_ORDERS_SUB: 'TREASURY.BANK_PAYMENTS.COLUMN.OP_ANTICIPO', // No. O.P. o Anticipo
      STATUS_LOG: 'TREASURY.EXPENSES.TAB.STATUS_LOG', // Bitácora de estados
      STATUS_LOG_SUB: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION',
      DEDUCTIONS: 'TREASURY.EXPENSES.TAB.DEDUCTIONS', // Deducciones aplicadas
      DEDUCTIONS_SUB: 'TREASURY.INCOME.INFO_MESSAGES.NO_DEDUCTIONS',
    },
    COLUMN: {
      PAY: 'TREASURY.BANK_PAYMENTS.ACTION.PAY', // Pagar (reusa ACTION.PAY)
      REJECT: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT', // Rechazar (reusa ACTION.REJECT)
      TIPO_CE: 'TREASURY.BANK_PAYMENTS.COLUMN.TIPO_CE', // Tipo CE
      VOUCHER: 'TREASURY.BANK_PAYMENTS.COLUMN.VOUCHER', // Comprobante
      IDENTIFICATION: 'TREASURY.BANK_PAYMENTS.COLUMN.IDENTIFICATION', // No. Identificación
      NAME: 'TREASURY.BANK_PAYMENTS.COLUMN.NAME', // Nombre o Razón Social
      PAYMENT_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.PAYMENT_DATE', // Fecha de pago
      VOUCHER_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.VOUCHER_DATE', // Fecha Comprobante Egreso
      VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VALUE', // Valor
      VOUCHER_VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VOUCHER_VALUE', // Valor Comprobante de Egreso
      STATUS: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado
      OP_ANTICIPO: 'TREASURY.BANK_PAYMENTS.COLUMN.OP_ANTICIPO', // No. O.P. o Anticipo
      APPROVAL_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.APPROVAL_DATE', // Fecha Aprobación
      TOTAL: 'TREASURY.BANK_PAYMENTS.COLUMN.TOTAL', // Valor Total
      PAY_VALUE: 'TREASURY.BANK_PAYMENTS.LABEL.PAY_VALUE', // Valor a Pagar (reusa LABEL)
      DESCRIPTION: 'TREASURY.BANK_PAYMENTS.COLUMN.DESCRIPTION', // Descripción
      ACTIONS: 'COMMON.ACTIONS', // Acciones / Actions (common_keys)
      LOG_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.PAYMENT_DATE', // Fecha (reusa)
      LOG_USER: 'COLUMNS.USER', // Usuario
      LOG_PREV: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado (reusa)
      LOG_NEXT: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado (reusa)
      LOG_NOTE: 'ACCOUNTING.DEPRECIATION.LABEL.OBSERVATIONS', // Observaciones
      DED_TYPE: 'TREASURY.DEDUCTIONS.FORM.FIELDS.TIPO_DEDUCCION.LABEL', // Tipo Deducción
      DED_BENEFICIARY: 'TREASURY.DEDUCTIONS.FORM.FIELDS.NOMBRE_ACREEDOR.LABEL', // Beneficiario / acreedor
    },
    PLACEHOLDER: {
      SEARCH: 'ACTIONS.SEARCH', // Buscar
      SELECT_TYPE: 'TREASURY.BANK_PAYMENTS.PLACEHOLDER.SELECT_TYPE', // Seleccione tipo
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.ACTION.SELECT_ACCOUNT', // Seleccionar cuenta (reusa ACTION)
    },
    EMPTY: {
      MESSAGE: 'TREASURY.BANK_PAYMENTS.EMPTY.MESSAGE', // No se encontraron comprobantes para pago
      DEFAULT: 'TREASURY.BANK_PAYMENTS.EMPTY.DEFAULT', // No hay comprobantes programados para pago el día de hoy
      SEARCH: 'TREASURY.BANK_PAYMENTS.EMPTY.SEARCH', // No se encontraron comprobantes que coincidan con la búsqueda
      DESCRIPTION: 'TREASURY.BANK_PAYMENTS.EMPTY.DESCRIPTION', // Intente con otro criterio o verifique la programación de egresos
      DETAIL: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL', // Seleccione un comprobante con Pagar para ver el detalle
      DETAIL_DESCRIPTION: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION', // La información de O.P. / anticipo se muestra al seleccionar filas
      /** Reutiliza empties ya existentes (no nuevas keys en BD). */
      ORDERS: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL',
      ORDERS_DESC: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION',
      LOG: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL',
      LOG_DESC: 'TREASURY.BANK_PAYMENTS.EMPTY.DETAIL_DESCRIPTION',
      DEDUCTIONS: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.MESSAGE',
      DEDUCTIONS_DESC: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.DESCRIPTION',
    },
    COUNTER: {
      SINGULAR: 'TREASURY.BANK_PAYMENTS.COUNTER.SINGULAR', // comprobante
      PLURAL: 'TREASURY.BANK_PAYMENTS.COUNTER.PLURAL', // comprobantes
    },
    ACTION: {
      PAY: 'TREASURY.BANK_PAYMENTS.ACTION.PAY', // Pagar
      REJECT: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT', // Rechazar
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.ACTION.SELECT_ACCOUNT', // Seleccionar cuenta
      PAY_ALL: 'TREASURY.BANK_PAYMENTS.ACTION.PAY_ALL', // Pagar todos (legacy)
      REJECT_ALL: 'TREASURY.BANK_PAYMENTS.ACTION.REJECT_ALL', // Rechazar todos (legacy)
      REFRESH: 'ACTIONS.REFRESH', // Refrescar (common_keys) — header como Aprobar Causación
      SAVE: 'ACTIONS.SAVE', // Guardar (common_keys)
      ACCEPT: 'ACTIONS.ACCEPT', // Aceptar (common_keys) — modal rechazo
      BACK: 'ACTIONS.BACK', // Volver (common_keys) — detalle consultar
      CANCEL: 'ACTIONS.CANCEL', // Cancelar (common_keys)
      VIEW: 'ACTIONS.VIEW', // Consultar (common_keys)
      CLOSE: 'TREASURY.PARAMETERS.ACCOUNT_SEARCH.CLOSE', // Cerrar / Close
    },
    MODAL: {
      SELECT_ACCOUNT: 'TREASURY.BANK_PAYMENTS.MODAL.SELECT_ACCOUNT', // Seleccionar cuenta bancaria
      REJECT_TITLE: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_TITLE', // Rechazar Documento(s) — alineado a Aprobar Causación
      REJECT_LABEL: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_LABEL', // Motivo de rechazo
      REJECT_PLACEHOLDER: 'TREASURY.BANK_PAYMENTS.MODAL.REJECT_PLACEHOLDER', // Ingrese el motivo del rechazo
      COL_CODE: 'TREASURY.BANK_PAYMENTS.MODAL.COL_CODE', // Código
      COL_NAME: 'TREASURY.BANK_PAYMENTS.MODAL.COL_NAME', // Nombre
      COL_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.BALANCE', // Saldo (reusa LABEL.BALANCE)
      SEARCH_ACCOUNT: 'TREASURY.BANK_PAYMENTS.MODAL.SEARCH_ACCOUNT', // Buscar por código o nombre...
      CONFIRM_PAY_TITLE: 'TREASURY.BANK_PAYMENTS.MODAL.CONFIRM_PAY_TITLE', // Confirmar pago
    },
    LABEL: {
      METHOD: 'TREASURY.BANK_PAYMENTS.LABEL.METHOD', // Método de pago
      ACCOUNT: 'TREASURY.BANK_PAYMENTS.LABEL.ACCOUNT', // Cuenta bancaria
      ACCOUNT_CODE: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.CODE.LABEL', // Código Cuenta (reusa parámetros)
      ACCOUNT_NAME: 'TREASURY.PARAMETERS.FIELDS.ACCOUNT.NAME.LABEL', // Nombre Cuenta (reusa parámetros)
      BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.BALANCE', // Saldo
      ACCOUNT_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.ACCOUNT_BALANCE', // Saldo de la Cuenta
      PAY_VALUE: 'TREASURY.BANK_PAYMENTS.LABEL.PAY_VALUE', // Valor a pagar
      FINAL_BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.FINAL_BALANCE', // Saldo final
      CHECK_NUMBER: 'TREASURY.BANK_PAYMENTS.LABEL.CHECK_NUMBER', // Número de cheque
      TIPO_CE: 'TREASURY.BANK_PAYMENTS.LABEL.TIPO_CE', // Tipo de Comprobante de Egreso
      SEARCH: 'LABELS.SEARCH', // Búsqueda (common_keys)
      PAYMENT_DATE: 'TREASURY.BANK_PAYMENTS.COLUMN.PAYMENT_DATE', // Fecha de pago (reusa COLUMN)
      TOTAL: 'TREASURY.BANK_PAYMENTS.COLUMN.TOTAL', // Valor Total (reusa COLUMN)
      CREATED_BY: 'TREASURY.EXPENSES.LABEL.CREATED_BY', // Elaboró
      APPROVED_BY: 'TREASURY.EXPENSES.LABEL.APPROVED_BY', // Aprueba
      NET_VALUE: 'TREASURY.BANK_PAYMENTS.LABEL.PAY_VALUE', // Valor a pagar (reusa)
    },
    OPTION: {
      GIRAR: 'TREASURY.BANK_PAYMENTS.OPTION.GIRAR', // Girar
      TRANSFERIR: 'TREASURY.BANK_PAYMENTS.OPTION.TRANSFERIR', // Transferir
      SIN_OP: 'TREASURY.BANK_PAYMENTS.OPTION.SIN_OP', // Sin orden de pago
      CON_OP: 'TREASURY.BANK_PAYMENTS.OPTION.CON_OP', // Con orden de pago
    },
    MESSAGE: {
      PAY_SUCCESS: 'TREASURY.BANK_PAYMENTS.MESSAGE.PAY_SUCCESS', // El pago/giro se ha registrado correctamente
      REJECT_SUCCESS: 'TREASURY.BANK_PAYMENTS.MESSAGE.REJECT_SUCCESS', // Comprobante(s) rechazado(s) correctamente
      SELECTION_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.SELECTION_REQUIRED', // Elige al menos un documento para el pago o rechazo
      ACCOUNT_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.ACCOUNT_REQUIRED', // Debe seleccionar al menos una cuenta
      ACCOUNT_ID_MISSING: 'TREASURY.BANK_PAYMENTS.MESSAGE.ACCOUNT_ID_MISSING', // La cuenta no trae cuentaBancariaId; pendiente backend
      METHOD_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.METHOD_REQUIRED', // Debe indicar Girar (cheque) o Transferir
      CHECK_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.CHECK_REQUIRED', // Al girar debe indicar el número de cheque
      MOTIVO_MIN: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_MIN', // El motivo de rechazo debe tener al menos {min} caracteres
      MOTIVO_MAX: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_MAX', // El motivo de rechazo no puede exceder {max} caracteres
      MOTIVO_REQUIRED: 'TREASURY.BANK_PAYMENTS.MESSAGE.MOTIVO_REQUIRED', // El motivo de rechazo es obligatorio
      CONFIRM_REJECT: 'TREASURY.BANK_PAYMENTS.MESSAGE.CONFIRM_REJECT', // Se realizará el rechazo del documento, ¿desea continuar?
      CONFIRM_PAY: 'TREASURY.BANK_PAYMENTS.MESSAGE.CONFIRM_PAY', // ¿Está seguro de procesar el pago de {count} comprobante(s)?
      LOAD_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.LOAD_ERROR', // No se pudo cargar el listado de comprobantes para pago
      READ_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.READ_ERROR', // No se pudo consultar el comprobante
      PAY_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.PAY_ERROR', // No se pudo procesar el pago. Intente nuevamente.
      REJECT_ERROR: 'TREASURY.BANK_PAYMENTS.MESSAGE.REJECT_ERROR', // No se pudo rechazar el/los comprobante(s).
      SEARCH_HINT_MIN: 'TREASURY.BANK_PAYMENTS.MESSAGE.SEARCH_HINT_MIN', // Debe ingresar entre {min} y {max} caracteres
      SEARCH_HINT_MAX: 'TREASURY.BANK_PAYMENTS.MESSAGE.SEARCH_HINT_MAX', // Máximo {max} caracteres
      PERMISSION_DENIED: 'TREASURY.BANK_PAYMENTS.MESSAGE.PERMISSION_DENIED', // No tiene permisos para realizar esta acción
    },
    PERMISSION: {
      DENIED_SAVE: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_SAVE', // No tiene permisos para guardar / pagar
      DENIED_REJECT: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_REJECT', // No tiene permisos para rechazar
      DENIED_VIEW: 'TREASURY.BANK_PAYMENTS.PERMISSION.DENIED_VIEW', // No tiene permisos para consultar
    },
    PANEL: {
      SUMMARY: 'TREASURY.BANK_PAYMENTS.PANEL.SUMMARY', // Resumen / Summary
      SUMMARY_TITLE_EMPTY: 'TREASURY.BANK_PAYMENTS.PANEL.SUMMARY_TITLE_EMPTY', // Comprobante sin número / Voucher without number
      CHECKLIST: 'TREASURY.BANK_PAYMENTS.PANEL.CHECKLIST', // Pendientes / Pending
      USAGE: 'TREASURY.BANK_PAYMENTS.PANEL.USAGE', // Cómo se usa / How to use
      USAGE_HINT: 'TREASURY.BANK_PAYMENTS.PANEL.USAGE_HINT', // Aquí se consulta el comprobante de egreso... El pago y el rechazo se hacen desde el listado. / The expense voucher is consulted here... Payment and rejection are done from the list.
    },
  },

  // ==================== ANULACIÓN DE PAGOS (HU-TES-011) ====================
  PAYMENT_ANNULMENT: {
    // La grilla declarativa compone estas cuatro por convencion, a partir del prefijo de la
    // pantalla. La quinta, EMPTY.DESCRIPTION, ya existia.
    SEARCH_PLACEHOLDER: 'TREASURY.PAYMENT_ANNULMENT.SEARCH_PLACEHOLDER', // Buscar por comprobante, identificación o nombre del tercero...
    COUNTER: {
      SINGULAR: 'TREASURY.PAYMENT_ANNULMENT.COUNTER.SINGULAR', // comprobante por anular
      PLURAL: 'TREASURY.PAYMENT_ANNULMENT.COUNTER.PLURAL', // comprobantes por anular
    },
    TITLE: {
      LIST: 'TREASURY.PAYMENT_ANNULMENT.TITLE.LIST', // Anulación de Pagos / Payment Annulment
      VIEW: 'TREASURY.PAYMENT_ANNULMENT.TITLE.VIEW', // Consulta de Comprobante / Voucher Inquiry
    },
    SUBTITLE: {
      LIST: 'TREASURY.PAYMENT_ANNULMENT.SUBTITLE.LIST', // Anulación de comprobantes de egreso girados o transferidos / Annulment of issued or transferred disbursement vouchers
    },
    TABLE: {
      VOUCHER_NUMBER: 'TREASURY.PAYMENT_ANNULMENT.TABLE.VOUCHER_NUMBER', // No. Comprobante / Voucher No.
    },
    PANEL: {
      SUMMARY: 'TREASURY.PAYMENT_ANNULMENT.PANEL.SUMMARY', // Resumen / Summary
      SUMMARY_TITLE_EMPTY: 'TREASURY.PAYMENT_ANNULMENT.PANEL.SUMMARY_TITLE_EMPTY', // Comprobante sin número / Voucher without number
      CHECKLIST: 'TREASURY.PAYMENT_ANNULMENT.PANEL.CHECKLIST', // Pendientes / Pending
      USAGE: 'TREASURY.PAYMENT_ANNULMENT.PANEL.USAGE', // Cómo se usa / How to use
      USAGE_HINT: 'TREASURY.PAYMENT_ANNULMENT.PANEL.USAGE_HINT', // Aquí se consulta el comprobante de egreso girado o transferido. La anulación se hace desde el listado, seleccionando los comprobantes y escribiendo el motivo. / The issued or transferred expense voucher is consulted here. Annulment is done from the list, by selecting the vouchers and entering the reason.
    },
    VALIDATION: {
      MIN_SEARCH_LENGTH: 'TREASURY.PAYMENT_ANNULMENT.VALIDATION.MIN_SEARCH_LENGTH', // El término de búsqueda debe tener al menos 3 caracteres / Search term must have at least 3 characters
      INVALID_DATE_RANGE: 'TREASURY.PAYMENT_ANNULMENT.VALIDATION.INVALID_DATE_RANGE', // La fecha inicial no puede ser mayor a la fecha final / Start date cannot be greater than end date
      NO_SELECTION: 'TREASURY.PAYMENT_ANNULMENT.VALIDATION.NO_SELECTION', // Debe seleccionar al menos un comprobante para anular / At least one voucher must be selected for annulment
      REASON_REQUIRED: 'TREASURY.PAYMENT_ANNULMENT.VALIDATION.REASON_REQUIRED', // El motivo de anulación es obligatorio / Annulment reason is required
      REASON_MAX_LENGTH: 'TREASURY.PAYMENT_ANNULMENT.VALIDATION.REASON_MAX_LENGTH', // El motivo no puede exceder 250 caracteres / Reason cannot exceed 250 characters
      INVALID_STATUS: 'TREASURY.PAYMENT_ANNULMENT.VALIDATION.INVALID_STATUS', // No se pueden anular comprobantes en estado {{estado}}. Solo se permiten estados GIRADO o TRANSFERIDO / Cannot annul vouchers in {{estado}} status. Only ISSUED or TRANSFERRED statuses are allowed
    },
    SUCCESS: {
      ANNULLED: 'TREASURY.PAYMENT_ANNULMENT.SUCCESS.ANNULLED', // Comprobantes anulados exitosamente / Vouchers annulled successfully
    },
    ERROR: {
      PERIOD_CLOSED: 'TREASURY.PAYMENT_ANNULMENT.ERROR.PERIOD_CLOSED', // No se puede anular en periodo contable cerrado. El periodo actual está cerrado por contabilidad / Cannot annul: the accounting period is closed
      OP_NOT_FOUND: 'TREASURY.PAYMENT_ANNULMENT.ERROR.OP_NOT_FOUND', // No se encontró la Orden de Pago asociada al comprobante. No se puede proceder con la anulación / The related Payment Order was not found. Operation cancelled
      CE_NOT_FOUND: 'TREASURY.PAYMENT_ANNULMENT.ERROR.CE_NOT_FOUND', // No se encontró el Comprobante de Egreso seleccionado / The selected Disbursement Voucher was not found
      PAYMENT_NOT_FOUND: 'TREASURY.PAYMENT_ANNULMENT.ERROR.PAYMENT_NOT_FOUND', // No se encontró el pago asociado al comprobante / The payment associated with the voucher was not found
      VALIDATION_ERROR: 'TREASURY.PAYMENT_ANNULMENT.ERROR.VALIDATION_ERROR', // Error de validación: {{message}} / Validation error: {{message}}
      NO_PERMISSION: 'TREASURY.PAYMENT_ANNULMENT.ERROR.NO_PERMISSION', // No tiene permisos para realizar esta operación / You don't have permission to perform this operation
      NOT_FOUND: 'TREASURY.PAYMENT_ANNULMENT.ERROR.NOT_FOUND', // El recurso solicitado no fue encontrado / The requested resource was not found
      CONFLICT: 'TREASURY.PAYMENT_ANNULMENT.ERROR.CONFLICT', // Conflicto: {{message}} / Conflict: {{message}}
      SERVER_ERROR: 'TREASURY.PAYMENT_ANNULMENT.ERROR.SERVER_ERROR', // Error interno del servidor. Por favor contacte al administrador / Internal server error. Please contact the administrator
    },
    MODAL: {
      TITLE: 'TREASURY.PAYMENT_ANNULMENT.MODAL.TITLE', // Anular {{count}} comprobante(s) / Annul {{count}} voucher(s)
      DESCRIPTION: 'TREASURY.PAYMENT_ANNULMENT.MODAL.DESCRIPTION', // Está a punto de anular {{count}} comprobante(s). Esta operación no se puede revertir.\n\nFecha de anulación: {{fecha}} / You are about to annul {{count}} voucher(s). This operation cannot be reversed.\n\nAnnulment date: {{fecha}}
      LABEL: 'TREASURY.PAYMENT_ANNULMENT.MODAL.LABEL', // Motivo de anulación / Annulment reason
      PLACEHOLDER: 'TREASURY.PAYMENT_ANNULMENT.MODAL.PLACEHOLDER', // Ingrese el motivo de anulación (obligatorio, máximo 250 caracteres) / Enter the annulment reason (required, maximum 250 characters)
    },
    SELECTION: {
      SINGULAR: 'TREASURY.PAYMENT_ANNULMENT.SELECTION.SINGULAR', // documento seleccionado / document selected
      PLURAL: 'TREASURY.PAYMENT_ANNULMENT.SELECTION.PLURAL', // documentos seleccionados / documents selected
    },
    EMPTY: {
      MESSAGE: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.MESSAGE', // No se encontraron comprobantes por anular
      TITLE: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.TITLE', // No hay comprobantes para anular / No vouchers to annul
      DESCRIPTION: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.DESCRIPTION', // No se encontraron comprobantes de egreso en estado GIRADO o TRANSFERIDO para el periodo actual / No disbursement vouchers in ISSUED or TRANSFERRED status were found for the current period
      SEARCH_NO_RESULTS: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.SEARCH_NO_RESULTS', // No se encontraron resultados / No results found
      SEARCH_NO_RESULTS_DESC: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.SEARCH_NO_RESULTS_DESC', // No se encontraron comprobantes que coincidan con los criterios de búsqueda / No vouchers matching the search criteria were found
      PAYMENT_ORDERS: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.PAYMENT_ORDERS', // No hay órdenes de pago / No payment orders
      PAYMENT_ORDERS_DESC: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.PAYMENT_ORDERS_DESC', // Este comprobante no tiene órdenes de pago asociadas / This voucher has no associated payment orders
      STATUS_LOG: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.STATUS_LOG', // No hay historial de estados / No status log
      STATUS_LOG_DESC: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.STATUS_LOG_DESC', // Este comprobante no tiene cambios de estado registrados / This voucher has no recorded status changes
      DEDUCTIONS: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.DEDUCTIONS', // No hay deducciones aplicadas / No applied deductions
      DEDUCTIONS_DESC: 'TREASURY.PAYMENT_ANNULMENT.EMPTY.DEDUCTIONS_DESC', // Este comprobante no tiene deducciones aplicadas / This voucher has no applied deductions
    },
    TAB: {
      GENERAL_INFO: 'TREASURY.PAYMENT_ANNULMENT.TAB.GENERAL_INFO', // Información General / General Information
      GENERAL_INFO_DESC: 'TREASURY.PAYMENT_ANNULMENT.TAB.GENERAL_INFO_DESC', // Datos generales del comprobante de egreso / General voucher information
      VOUCHER_DATA: 'TREASURY.PAYMENT_ANNULMENT.TAB.VOUCHER_DATA', // Datos Comprobante de Egreso / Voucher Data
      VOUCHER_DATA_DESC: 'TREASURY.PAYMENT_ANNULMENT.TAB.VOUCHER_DATA_DESC', // Información del tercero y valores del comprobante / Third party information and voucher values
      PAYMENT_ORDERS: 'TREASURY.PAYMENT_ANNULMENT.TAB.PAYMENT_ORDERS', // Órdenes de Pago / Payment Orders
      PAYMENT_ORDERS_DESC: 'TREASURY.PAYMENT_ANNULMENT.TAB.PAYMENT_ORDERS_DESC', // Listado de órdenes de pago asociadas al comprobante / List of payment orders associated with the voucher
      STATUS_LOG: 'TREASURY.PAYMENT_ANNULMENT.TAB.STATUS_LOG', // Bitácora de Estados / Status Log
      STATUS_LOG_DESC: 'TREASURY.PAYMENT_ANNULMENT.TAB.STATUS_LOG_DESC', // Historial de cambios de estado del comprobante / Voucher status change history
      DEDUCTIONS: 'TREASURY.PAYMENT_ANNULMENT.TAB.DEDUCTIONS', // Deducciones Aplicadas / Applied Deductions
      DEDUCTIONS_DESC: 'TREASURY.PAYMENT_ANNULMENT.TAB.DEDUCTIONS_DESC', // Deducciones automáticas generadas por el sistema / Automatic deductions generated by the system
    },
    PAYMENT_ORDERS: {
      NO_OP: 'TREASURY.PAYMENT_ANNULMENT.PAYMENT_ORDERS.NO_OP', // No. OP / OP No.
      APPROVAL_DATE: 'TREASURY.PAYMENT_ANNULMENT.PAYMENT_ORDERS.APPROVAL_DATE', // Fecha Aprobación / Approval Date
      PAYMENT_DATE: 'TREASURY.PAYMENT_ANNULMENT.PAYMENT_ORDERS.PAYMENT_DATE', // Fecha Pago / Payment Date
      TOTAL_VALUE: 'TREASURY.PAYMENT_ANNULMENT.PAYMENT_ORDERS.TOTAL_VALUE', // Valor Total / Total Value
      VOUCHER_VALUE: 'TREASURY.PAYMENT_ANNULMENT.PAYMENT_ORDERS.VOUCHER_VALUE', // Valor Comprobante de Egreso / Voucher Value
    },
    STATUS_LOG: {
      DATE_TIME: 'TREASURY.PAYMENT_ANNULMENT.STATUS_LOG.DATE_TIME', // Fecha/Hora / Date/Time
      USER: 'TREASURY.PAYMENT_ANNULMENT.STATUS_LOG.USER', // Usuario / User
      PREVIOUS_STATUS: 'TREASURY.PAYMENT_ANNULMENT.STATUS_LOG.PREVIOUS_STATUS', // Estado Anterior / Previous Status
      NEW_STATUS: 'TREASURY.PAYMENT_ANNULMENT.STATUS_LOG.NEW_STATUS', // Estado Nuevo / New Status
      OBSERVATION: 'TREASURY.PAYMENT_ANNULMENT.STATUS_LOG.OBSERVATION', // Observación / Observation
    },
    DEDUCTIONS: {
      VOUCHER_NUMBER: 'TREASURY.PAYMENT_ANNULMENT.DEDUCTIONS.VOUCHER_NUMBER', // Consecutivo Comprobante de Egreso / Voucher Consecutive Number
      TYPE: 'TREASURY.PAYMENT_ANNULMENT.DEDUCTIONS.TYPE', // Tipo Deducción / Deduction Type
      BENEFICIARY: 'TREASURY.PAYMENT_ANNULMENT.DEDUCTIONS.BENEFICIARY', // Beneficiario / Beneficiary
      VALUE: 'TREASURY.PAYMENT_ANNULMENT.DEDUCTIONS.VALUE', // Valor / Value
      STATUS: 'TREASURY.PAYMENT_ANNULMENT.DEDUCTIONS.STATUS', // Estado / Status
    },
  },

  INCOME: {
    // ==================== TÍTULOS DE PÁGINA ====================
    HEADER: {
      CONCEPTO: {
        SEARCH_TOOLTIP: 'TREASURY.INCOME.HEADER.CONCEPTO.SEARCH_TOOLTIP',
      },
    },
    TITLE: {
      LIST: 'TREASURY.INCOME.TITLE.LIST',
      CREATE: 'TREASURY.INCOME.TITLE.CREATE',
      EDIT: 'TREASURY.INCOME.TITLE.EDIT',
      VIEW: 'TREASURY.INCOME.TITLE.VIEW',
      SUBTITLE: {
        LIST: 'TREASURY.INCOME.TITLE.SUBTITLE.LIST',
        CREATE: 'TREASURY.INCOME.TITLE.SUBTITLE.CREATE',
        EDIT: 'TREASURY.INCOME.TITLE.SUBTITLE.EDIT',
        VIEW: 'TREASURY.INCOME.TITLE.SUBTITLE.VIEW',
      },
    },

    // ==================== CONTADOR DE RESULTADOS ====================
    // La grilla declarativa compone estas cinco por convencion, a partir del prefijo de la
    // pantalla: SEARCH_PLACEHOLDER, COUNTER.SINGULAR/PLURAL y EMPTY.MESSAGE/DESCRIPTION.
    SEARCH_PLACEHOLDER: 'TREASURY.INCOME.SEARCH_PLACEHOLDER', // Buscar por consecutivo, identificación o nombre del tercero...
    COUNTER: {
      SINGULAR: 'TREASURY.INCOME.COUNTER.SINGULAR', // comprobante de ingreso
      PLURAL: 'TREASURY.INCOME.COUNTER.PLURAL', // comprobantes de ingreso
    },
    EMPTY: {
      MESSAGE: 'TREASURY.INCOME.EMPTY.MESSAGE', // No se encontraron comprobantes de ingreso
      DESCRIPTION: 'TREASURY.INCOME.EMPTY.DESCRIPTION', // Ajuste el rango de fechas o el término de búsqueda.
    },
    RESULTS_COUNTER: {
      SHOWING: 'TREASURY.INCOME.RESULTS_COUNTER.SHOWING', // Mostrando / Showing
      OF: 'TREASURY.INCOME.RESULTS_COUNTER.OF', // de / of
      SINGULAR: 'TREASURY.INCOME.RESULTS_COUNTER.SINGULAR',
      PLURAL: 'TREASURY.INCOME.RESULTS_COUNTER.PLURAL',
    },

    // ==================== FILTROS (FN-ALC1-02) ====================
    FILTERS: {
      SEARCH: {
        PLACEHOLDER: 'TREASURY.INCOME.FILTERS.SEARCH.PLACEHOLDER',
      },
      DATE_RANGE: {
        START_LABEL: 'TREASURY.INCOME.FILTERS.DATE_RANGE.START_LABEL',
        END_LABEL: 'TREASURY.INCOME.FILTERS.DATE_RANGE.END_LABEL',
        PLACEHOLDER: 'TREASURY.INCOME.FILTERS.DATE_RANGE.PLACEHOLDER',
      },
      ESTADO: {
        LABEL: 'TREASURY.INCOME.FILTERS.ESTADO.LABEL',
        PLACEHOLDER: 'TREASURY.INCOME.FILTERS.ESTADO.PLACEHOLDER',
        OPTIONS: {
          APROBADO: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.APROBADO',
          // Es uno de los DOS unicos valores que define EstadoComprobanteIngresoEnum, y hasta
          // ahora no figuraba: un comprobante anulado se presentaba con el badge en blanco.
          ANULADO: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.ANULADO',
          PENDIENTE: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.PENDIENTE',
          RECHAZADO: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.RECHAZADO',
        },
      },
    },

    // ==================== TABLA (FN-ALC1-04) ====================
    TABLE: {
      COLUMNS: {
        CONSECUTIVO: 'TREASURY.INCOME.TABLE.COLUMNS.CONSECUTIVO',
        IDENTIFICACION: 'TREASURY.INCOME.TABLE.COLUMNS.IDENTIFICACION',
        NOMBRE: 'TREASURY.INCOME.TABLE.COLUMNS.NOMBRE',
        FECHA_INGRESO: 'TREASURY.INCOME.TABLE.COLUMNS.FECHA_INGRESO',
        VALOR_TOTAL: 'TREASURY.INCOME.TABLE.COLUMNS.VALOR_TOTAL',
        ESTADO: 'TREASURY.INCOME.TABLE.COLUMNS.ESTADO',
      },
      ACTIONS: {
        LABEL: 'COMMON.ACTIONS',
        VIEW: 'ACTIONS.VIEW',
        EDIT: 'ACTIONS.EDIT',
        DELETE: 'ACTIONS.DELETE',
      },
      EMPTY: {
        MESSAGE: 'TREASURY.INCOME.TABLE.EMPTY.MESSAGE',
        DESCRIPTION: 'TREASURY.INCOME.TABLE.EMPTY.DESCRIPTION',
      },
    },

    // ==================== FORMULARIO (FN-ALC2) ====================
    FORM: {
      // ----- Encabezado del comprobante (FN-ALC2-01) -----
      HEADER: {
        TITLE: 'TREASURY.INCOME.TITLE.HEADER',

        CONSECUTIVO: {
          LABEL: 'TREASURY.INCOME.HEADER.CONSECUTIVO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.CONSECUTIVO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.CONSECUTIVO.PLACEHOLDER',
        },

        TERCERO: {
          LABEL: 'TREASURY.INCOME.HEADER.TERCERO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.TERCERO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.TERCERO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.TERCERO.REQUIRED',
          SEARCH_TOOLTIP: 'TREASURY.INCOME.HEADER.TERCERO.SEARCH_TOOLTIP',
          NOT_SELECTED: 'TREASURY.INCOME.HEADER.TERCERO.NOT_SELECTED',
        },

        NOMBRE_TERCERO: {
          LABEL: 'TREASURY.INCOME.HEADER.NOMBRE_TERCERO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.NOMBRE_TERCERO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.NOMBRE_TERCERO.PLACEHOLDER',
        },

        FECHA_REGISTRO: {
          LABEL: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.REQUIRED',
          AUTOMATIC: 'TREASURY.INCOME.HEADER.FECHA_REGISTRO.AUTOMATIC',
        },

        FECHA_INGRESO: {
          LABEL: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.REQUIRED',
          ERROR_FUTURA: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.ERROR_FUTURA',
          ERROR_MENOR_MES: 'TREASURY.INCOME.HEADER.FECHA_INGRESO.ERROR_MENOR_MES',
        },

        VALOR_TOTAL: {
          LABEL: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.REQUIRED',
          MIN: 'TREASURY.INCOME.HEADER.VALOR_TOTAL.MIN',
        },

        CONCEPTO: {
          LABEL: 'TREASURY.INCOME.HEADER.CONCEPTO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.CONCEPTO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.CONCEPTO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.CONCEPTO.REQUIRED',
          SEARCH_TOOLTIP: 'TREASURY.INCOME.HEADER.CONCEPTO.SEARCH_TOOLTIP',
        },

        TIPO_ASIENTO: {
          LABEL: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.REQUIRED',
          SEARCH_TOOLTIP: 'TREASURY.INCOME.HEADER.TIPO_ASIENTO.SEARCH_TOOLTIP',
        },

        TIPO_COMPROBANTE: {
          LABEL: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.REQUIRED',
          OPTIONS: {
            FACTURA: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.OPTIONS.FACTURA',
            CONCEPTO_DIRECTO: 'TREASURY.INCOME.HEADER.TIPO_COMPROBANTE.OPTIONS.CONCEPTO_DIRECTO',
          },
        },

        DESCRIPCION: {
          LABEL: 'TREASURY.INCOME.HEADER.DESCRIPCION.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.DESCRIPCION.TOOLTIP',
          PLACEHOLDER: 'TREASURY.INCOME.HEADER.DESCRIPCION.PLACEHOLDER',
          REQUIRED: 'TREASURY.INCOME.HEADER.DESCRIPCION.REQUIRED',
          MAX_LENGTH: 'TREASURY.INCOME.HEADER.DESCRIPCION.MAX_LENGTH',
          MIN_LENGTH: 'TREASURY.INCOME.HEADER.DESCRIPCION.MIN_LENGTH',
        },

        ESTADO: {
          LABEL: 'TREASURY.INCOME.HEADER.ESTADO.LABEL',
          TOOLTIP: 'TREASURY.INCOME.HEADER.ESTADO.TOOLTIP',
          OPTIONS: {
            APROBADO: 'TREASURY.INCOME.HEADER.ESTADO.OPTIONS.APROBADO',
            PENDIENTE: 'TREASURY.INCOME.HEADER.ESTADO.OPTIONS.PENDIENTE',
            RECHAZADO: 'TREASURY.INCOME.HEADER.ESTADO.OPTIONS.RECHAZADO',
          },
        },

        BUTTONS: {
          AGREGAR_FACTURA: 'TREASURY.INCOME.HEADER.BUTTONS.AGREGAR_FACTURA',
          AGREGAR_CONCEPTO_DIRECTO: 'TREASURY.INCOME.HEADER.BUTTONS.AGREGAR_CONCEPTO_DIRECTO',
          NO_FACTURAS: 'TREASURY.INCOME.HEADER.BUTTONS.NO_FACTURAS',
        },
      },

      // ----- Detalle del Registro (FN-ALC2-02) -----
      REGISTER_DETAIL: {
        TITLE: 'TREASURY.INCOME.REGISTER_DETAIL.TITLE',

        TABLE: {
          COLUMNS: {
            NUMERO_FACTURA: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.NUMERO_FACTURA',
            CODIGO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CODIGO',
            NOMBRE_CONCEPTO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.NOMBRE_CONCEPTO',
            CODIGO_ARTICULO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CODIGO_ARTICULO',
            DESCRIPCION_ARTICULO:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.DESCRIPCION_ARTICULO',
            CANTIDAD: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CANTIDAD',
            VALOR_UNITARIO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.VALOR_UNITARIO',
            SUBTOTAL_ARTICULO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.SUBTOTAL_ARTICULO',
            VALOR_TOTAL_FACTURA:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.VALOR_TOTAL_FACTURA',
            SALDO_ARTICULO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.SALDO_ARTICULO',
            VALOR_RECAUDO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.VALOR_RECAUDO',
            CENTRO_COSTO_CODIGO:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CENTRO_COSTO_CODIGO',
            CENTRO_COSTO_NOMBRE:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.COLUMNS.CENTRO_COSTO_NOMBRE',
            ACCIONES: 'COMMON.ACTIONS',
          },

          VALIDATIONS: {
            CODIGO_REQUIRED: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.CODIGO_REQUIRED',
            DESCRIPCION_MAX_LENGTH:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.DESCRIPCION_MAX_LENGTH',
            VALOR_RECAUDO_REQUIRED:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_REQUIRED',
            VALOR_RECAUDO_MIN:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_MIN',
            VALOR_RECAUDO_EXCEEDS:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_EXCEEDS',
            CENTRO_COSTO_REQUIRED:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.CENTRO_COSTO_REQUIRED',
            CENTRO_COSTO_MAX_LENGTH:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.VALIDATIONS.CENTRO_COSTO_MAX_LENGTH',
          },

          ACTIONS: {
            ADD_LINE: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.ACTIONS.ADD_LINE',
            SEARCH_CENTRO_COSTO:
              'TREASURY.INCOME.REGISTER_DETAIL.TABLE.ACTIONS.SEARCH_CENTRO_COSTO',
          },

          SUMMARIES: {
            TOTALS: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.SUMMARIES.TOTALS',
          },

          TYPES: {
            FACTURA: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.TYPES.FACTURA',
            CONCEPTO_DIRECTO: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.TYPES.CONCEPTO_DIRECTO',
          },

          EMPTY: {
            MESSAGE: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.EMPTY.MESSAGE',
            DESCRIPTION: 'TREASURY.INCOME.REGISTER_DETAIL.TABLE.EMPTY.DESCRIPTION',
          },
        },

        BUTTONS: {
          ADD_FACTURA: 'TREASURY.INCOME.REGISTER_DETAIL.BUTTONS.ADD_FACTURA',
          ADD_CONCEPTO_DIRECTO: 'TREASURY.INCOME.REGISTER_DETAIL.BUTTONS.ADD_CONCEPTO_DIRECTO',
        },
      },

      // ----- Cuenta de Bancos (FN-ALC2-03) -----
      BANK_DETAIL: {
        TITLE: 'TREASURY.INCOME.BANK_DETAIL.TITLE',

        TABLE: {
          COLUMNS: {
            CODIGO_BANCO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.CODIGO_BANCO',
            NUMERO_CUENTA: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.NUMERO_CUENTA',
            NOMBRE_CUENTA: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.NOMBRE_CUENTA',
            MEDIO_PAGO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.MEDIO_PAGO',
            VALOR_RECAUDO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.VALOR_RECAUDO',
            NUMERO_DOCUMENTO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.COLUMNS.NUMERO_DOCUMENTO',
            ACCIONES: 'COMMON.ACTIONS',
          },

          VALIDATIONS: {
            CODIGO_BANCO_REQUIRED:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.CODIGO_BANCO_REQUIRED',
            CODIGO_BANCO_MAX_LENGTH:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.CODIGO_BANCO_MAX_LENGTH',
            MEDIO_PAGO_REQUIRED:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.MEDIO_PAGO_REQUIRED',
            VALOR_RECAUDO_REQUIRED:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_REQUIRED',
            VALOR_RECAUDO_MIN: 'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_MIN',
            VALOR_RECAUDO_EXCEEDS:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.VALOR_RECAUDO_EXCEEDS',
            NUMERO_DOCUMENTO_MAX_LENGTH:
              'TREASURY.INCOME.BANK_DETAIL.TABLE.VALIDATIONS.NUMERO_DOCUMENTO_MAX_LENGTH',
          },

          ACTIONS: {
            ADD_BANCO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.ACTIONS.ADD_BANCO',
            SEARCH_BANCO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.ACTIONS.SEARCH_BANCO',
          },

          SUMMARIES: {
            TOTALS: 'TREASURY.INCOME.BANK_DETAIL.TABLE.SUMMARIES.TOTALS',
          },

          MEDIO_PAGO_OPTIONS: {
            TRANSFERENCIA: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.TRANSFERENCIA',
            TARJETA_DEBITO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.TARJETA_DEBITO',
            TARJETA_CREDITO: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.TARJETA_CREDITO',
            CONSIGNACION: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.CONSIGNACION',
            BRE_B: 'TREASURY.INCOME.BANK_DETAIL.TABLE.MEDIO_PAGO_OPTIONS.BRE_B',
          },

          EMPTY: {
            MESSAGE: 'TREASURY.INCOME.BANK_DETAIL.TABLE.EMPTY.MESSAGE',
            DESCRIPTION: 'TREASURY.INCOME.BANK_DETAIL.TABLE.EMPTY.DESCRIPTION',
          },
        },
      },

      // ----- Cuenta de Deducción (FN-ALC2-04) -----
      DEDUCTIONS: {
        TITLE: 'TREASURY.INCOME.DEDUCTIONS.TITLE',

        TABLE: {
          COLUMNS: {
            CUENTA: 'TREASURY.INCOME.DEDUCTIONS.TABLE.COLUMNS.CUENTA',
            NOMBRE_CUENTA: 'TREASURY.INCOME.DEDUCTIONS.TABLE.COLUMNS.NOMBRE_CUENTA',
            VALOR: 'TREASURY.INCOME.DEDUCTIONS.TABLE.COLUMNS.VALOR',
            ACCIONES: 'COMMON.ACTIONS',
          },

          VALIDATIONS: {
            CUENTA_REQUIRED: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.CUENTA_REQUIRED',
            CUENTA_MAX_LENGTH: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.CUENTA_MAX_LENGTH',
            VALOR_REQUIRED: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.VALOR_REQUIRED',
            VALOR_MIN: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.VALOR_MIN',
            VALOR_EXCEEDS: 'TREASURY.INCOME.DEDUCTIONS.TABLE.VALIDATIONS.VALOR_EXCEEDS',
          },

          ACTIONS: {
            ADD_DEDUCCION: 'TREASURY.INCOME.DEDUCTIONS.TABLE.ACTIONS.ADD_DEDUCCION',
            SEARCH_DEDUCCION: 'TREASURY.INCOME.DEDUCTIONS.TABLE.ACTIONS.SEARCH_DEDUCCION',
          },

          SUMMARIES: {
            TOTALS: 'TREASURY.INCOME.DEDUCTIONS.TABLE.SUMMARIES.TOTALS',
          },

          EMPTY: {
            MESSAGE: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.MESSAGE',
            DESCRIPTION: 'TREASURY.INCOME.DEDUCTIONS.TABLE.EMPTY.DESCRIPTION',
          },
        },
      },
    },

    // ==================== ACCIONES DEL HEADER ====================
    ACTIONS: {
      CREATE: 'ACTIONS.CREATE',
      REFRESH: 'ACTIONS.REFRESH',
      CANCEL: 'ACTIONS.CANCEL',
      SAVE: 'ACTIONS.SAVE',
      SAVING: 'ACTIONS.SAVING',
      VIEW: 'ACTIONS.VIEW',
      EDIT: 'ACTIONS.EDIT',
      DELETE: 'ACTIONS.DELETE',
    },

    // ==================== ALERTAS ====================
    ALERTS: {
      LOAD_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.LOAD_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.LOAD_ERROR.MESSAGE',
      },
      SAVE_SUCCESS: {
        TITLE: 'TREASURY.INCOME.ALERTS.SAVE_SUCCESS.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.SAVE_SUCCESS.MESSAGE',
      },
      SAVE_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.SAVE_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.SAVE_ERROR.MESSAGE',
      },
      UPDATE_SUCCESS: {
        TITLE: 'TREASURY.INCOME.ALERTS.UPDATE_SUCCESS.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.UPDATE_SUCCESS.MESSAGE',
      },
      UPDATE_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.UPDATE_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.UPDATE_ERROR.MESSAGE',
      },
      DELETE_SUCCESS: {
        TITLE: 'TREASURY.INCOME.ALERTS.DELETE_SUCCESS.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.DELETE_SUCCESS.MESSAGE',
      },
      DELETE_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.DELETE_ERROR.TITLE',
        MESSAGE: 'TREASURY.INCOME.ALERTS.DELETE_ERROR.MESSAGE',
      },
      PERMISSION_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.TITLE',
        CREATE_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.CREATE_DENIED',
        EDIT_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.EDIT_DENIED',
        DELETE_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.DELETE_DENIED',
        VIEW_DENIED: 'TREASURY.INCOME.ALERTS.PERMISSION_ERROR.VIEW_DENIED',
      },
      SELECTION_ERROR: {
        TITLE: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.TITLE',
        TERCERO_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.TERCERO_ERROR',
        CONCEPTO_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.CONCEPTO_ERROR',
        CONCEPTO_FACTURACION_ERROR:
          'TREASURY.INCOME.ALERTS.SELECTION_ERROR.CONCEPTO_FACTURACION_ERROR',
        TIPO_ASIENTO_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.TIPO_ASIENTO_ERROR',
        FACTURAS_ERROR: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.FACTURAS_ERROR',
        FACTURAS_503: 'TREASURY.INCOME.ALERTS.SELECTION_ERROR.FACTURAS_503',
      },
    },

    // ==================== CONFIRMACIONES ====================
    CONFIRM_DIALOGS: {
      CANCEL: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.CONFIRM_LABEL',
        CANCEL_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.CANCEL.CANCEL_LABEL',
      },
      DELETE: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DELETE.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DELETE.MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      REGISTER_DETAIL_DELETE: {
        FACTURA: {
          TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.FACTURA.TITLE',
          MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.FACTURA.MESSAGE',
        },
        CONCEPTO: {
          TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.CONCEPTO.TITLE',
          MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.CONCEPTO.MESSAGE',
        },
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.REGISTER_DETAIL_DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      BANK_DETAIL_DELETE: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.MESSAGE',
        SINGLE_LINE_MESSAGE:
          'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.SINGLE_LINE_MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.BANK_DETAIL_DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      DEDUCTIONS_DELETE: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.TITLE',
        MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.MESSAGE',
        SINGLE_LINE_MESSAGE:
          'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.SINGLE_LINE_MESSAGE',
        CONFIRM_LABEL: 'TREASURY.INCOME.CONFIRM_DIALOGS.DEDUCTIONS_DELETE.CONFIRM_LABEL',
        CANCEL_LABEL: 'ACTIONS.CANCEL',
      },
      NO_SALDO: {
        TITLE: 'TREASURY.INCOME.CONFIRM_DIALOGS.NO_SALDO.TITLE',
        BANK_MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.NO_SALDO.BANK_MESSAGE',
        DEDUCTION_MESSAGE: 'TREASURY.INCOME.CONFIRM_DIALOGS.NO_SALDO.DEDUCTION_MESSAGE',
        CONFIRM_LABEL: 'ACTIONS.ACCEPT',
      },
    },

    // ==================== MODALES ====================
    MODALS: {
      TERCERO: {
        TITLE: 'TREASURY.INCOME.MODALS.TERCERO.TITLE',
      },
      CENTRO_COSTO: {
        TITLE: 'TREASURY.INCOME.MODALS.CENTRO_COSTO.TITLE',
      },
      BANCO: {
        TITLE: 'TREASURY.INCOME.MODALS.BANCO.TITLE',
      },
      CUENTA_CONTABLE: {
        TITLE: 'TREASURY.INCOME.MODALS.CUENTA_CONTABLE.TITLE',
      },
    },

    // ==================== ERRORES ====================
    ERROR_MESSAGES: {
      REQUIRED_FIELD: 'TREASURY.INCOME.ERROR_MESSAGES.REQUIRED_FIELD',
      INVALID_FORM: 'TREASURY.INCOME.ERROR_MESSAGES.INVALID_FORM',
      TERCERO_INVALIDO: 'TREASURY.INCOME.ERROR_MESSAGES.TERCERO_INVALIDO',
      FECHA_FUTURA: 'TREASURY.INCOME.ERROR_MESSAGES.FECHA_FUTURA',
      FECHA_MENOR_MES_CERRADO: 'TREASURY.INCOME.ERROR_MESSAGES.FECHA_MENOR_MES_CERRADO',
      VALOR_TOTAL_INVALID: 'TREASURY.INCOME.ERROR_MESSAGES.VALOR_TOTAL_INVALID',
      CONCEPTO_NOT_FOUND: 'TREASURY.INCOME.ERROR_MESSAGES.CONCEPTO_NOT_FOUND',
      FACTURA_NO_SALDO: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_NO_SALDO',
      FACTURA_YA_AGREGADA: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_YA_AGREGADA',
      FACTURA_INVALIDA: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_INVALIDA',
      FACTURA_NO_ENCONTRADA: 'TREASURY.INCOME.ERROR_MESSAGES.FACTURA_NO_ENCONTRADA',
      CENTRO_COSTO_OBLIGATORIO: 'TREASURY.INCOME.ERROR_MESSAGES.CENTRO_COSTO_OBLIGATORIO',
      NO_FACTURAS_DISPONIBLES: 'TREASURY.INCOME.ERROR_MESSAGES.NO_FACTURAS_DISPONIBLES',
      DETALLE_CARGA_ERROR: 'TREASURY.INCOME.ERROR_MESSAGES.DETALLE_CARGA_ERROR',
      SALDO_POR_RECAUDAR: 'TREASURY.INCOME.ERROR_MESSAGES.SALDO_POR_RECAUDAR',
      TIPO_ASIENTO_INVALIDO: 'TREASURY.INCOME.ERROR_MESSAGES.TIPO_ASIENTO_INVALIDO',
    },

    // ==================== INFORMACIÓN ====================
    INFO_MESSAGES: {
      TERCERO_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.TERCERO_SELECTED',
      BANCO_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.BANCO_SELECTED',
      CUENTA_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.CUENTA_SELECTED',
      CENTRO_COSTO_SELECTED: 'TREASURY.INCOME.INFO_MESSAGES.CENTRO_COSTO_SELECTED',
      NO_DEDUCTIONS: 'TREASURY.INCOME.INFO_MESSAGES.NO_DEDUCTIONS',
    },

    // ==================== TABS ====================
    TABS: {
      DETAIL: 'TREASURY.INCOME.TABS.DETAIL',
      BANK_DETAIL: 'TREASURY.INCOME.TABS.BANK_DETAIL',
      DEDUCTIONS: 'TREASURY.INCOME.TABS.DEDUCTIONS',
      PRINCIPAL: 'TREASURY.INCOME.TABS.PRINCIPAL',
    },
  },
  LAYOUT: {
    SHOWING: 'LAYOUT.SHOWING', // Mostrando / Showing
    OF: 'LAYOUT.OF', // de / of
  },

  COLUMNS: {
    USER: 'COLUMNS.USER', // Usuario / User
  },

  EXPENSE: {
    STATUS: {
      ISSUED: 'TREASURY.EXPENSE.STATUS.ISSUED', // Girado / Issued
      TRANSFERRED: 'TREASURY.EXPENSE.STATUS.TRANSFERRED', // Transferido / Transferred
    },
    LAYOUT: {
      SHOWING: 'LAYOUT.SHOWING', // Mostrando / Showing
      OF: 'LAYOUT.OF', // de / of
    },

    COMMON: {
      STATUS: 'COMMON.STATUS', // Estado / Status
      ACTIONS: 'COMMON.ACTIONS', // Acciones / Actions
      ACCEPT: 'ACTIONS.ACCEPT', // Aceptar / Accept
      CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
      CONSULT: 'ACTIONS.CONSULT', // Consultar / Consult
    },

    COLUMNS: {
      USER: 'COLUMNS.USER', // Usuario / User
    },
  },

  THIRD_PARTY: {
    // Convencion de la grilla declarativa: la base compone estas claves con el prefijo de la
    // pantalla, de modo que buscador, contador y vacio se resuelven sin declararlos en cada uso.
    SEARCH_PLACEHOLDER: 'TREASURY.THIRD_PARTY.SEARCH_PLACEHOLDER', // Buscar por documento o nombre... / Search by document or name...
    COUNTER: {
      SINGULAR: 'TREASURY.THIRD_PARTY.COUNTER.SINGULAR', // tercero / third party
      PLURAL: 'TREASURY.THIRD_PARTY.COUNTER.PLURAL', // terceros / third parties
    },

    EMPTY: {
      MESSAGE: 'TREASURY.THIRD_PARTY.EMPTY.MESSAGE',
      DESCRIPTION: 'TREASURY.THIRD_PARTY.EMPTY.DESCRIPTION', // Ajuste la búsqueda para ver otros terceros / Adjust the search to see other third parties
    },
    TITLE: {
      LIST: 'TREASURY.THIRD_PARTY.TITLE.LIST', // Terceros de Tesorería / Treasury Third Parties
      VIEW: 'TREASURY.THIRD_PARTY.TITLE.VIEW', // Consultar Tercero / View Third Party
      EDIT: 'TREASURY.THIRD_PARTY.TITLE.EDIT', // Editar Cuentas Bancarias / Edit Bank Accounts
    },

    SUBTITLE: {
      LIST: 'TREASURY.THIRD_PARTY.SUBTITLE.LIST', // Gestión de terceros para operaciones de tesorería / Management of third parties for treasury operations
      CREATE: 'TREASURY.THIRD_PARTY.SUBTITLE.CREATE', // Crear nuevo tercero / Create new third party
      VIEW: 'TREASURY.THIRD_PARTY.SUBTITLE.VIEW', // Detalle del tercero / Third party detail
      EDIT: 'TREASURY.THIRD_PARTY.SUBTITLE.EDIT', // Modificar cuentas bancarias del tercero / Modify third party bank accounts
    },

    EDIT: {
      INACTIVE_THIRD_PARTY: 'TREASURY.THIRD_PARTY.EDIT.INACTIVE_THIRD_PARTY', // No se pueden editar cuentas de terceros inactivos / Cannot edit accounts of inactive third parties
      NO_PERMISSION: 'TREASURY.THIRD_PARTY.EDIT.NO_PERMISSION', // No tiene permisos para editar cuentas bancarias / You do not have permission to edit bank accounts
    },

    VIEW: {
      NO_PERMISSION: 'TREASURY.THIRD_PARTY.VIEW.NO_PERMISSION', // No tiene permisos para consultar terceros / You do not have permission to view third parties
    },

    PANEL: {
      USAGE_HINT: 'TREASURY.THIRD_PARTY.PANEL.USAGE_HINT', // Los datos del tercero se administran en Contabilidad. Aquí solo se gestionan sus cuentas bancarias... / The third party data is managed in Accounting. Only its bank accounts are managed here...
    },

    ACCOUNT: {
      REQUIRED_FIELDS: 'TREASURY.THIRD_PARTY.ACCOUNT.REQUIRED_FIELDS', // Complete todos los campos obligatorios / Complete all required fields
      DUPLICATE: 'TREASURY.THIRD_PARTY.ACCOUNT.DUPLICATE', // Ya existe una cuenta con este banco y número / An account with this bank and number already exists
      ACTIVE_EXISTS: 'TREASURY.THIRD_PARTY.ACCOUNT.ACTIVE_EXISTS', // Ya existe una cuenta activa para este tercero / An active account already exists for this third party
      REQUIRED_FIELD: 'TREASURY.THIRD_PARTY.ACCOUNT.REQUIRED_FIELD', // Este campo es obligatorio / This field is required
      INVALID_NUMBER: 'TREASURY.THIRD_PARTY.ACCOUNT.INVALID_NUMBER', // El número de cuenta debe tener 11 dígitos / Account number must have 11 digits
      INVALID_LENGTH: 'TREASURY.THIRD_PARTY.ACCOUNT.INVALID_LENGTH', // Longitud inválida / Invalid length
      DELETE_ONLY_INACTIVE: 'TREASURY.THIRD_PARTY.ACCOUNT.DELETE_ONLY_INACTIVE', // Solo se pueden eliminar cuentas inactivas / Only inactive accounts can be deleted
      SAVED_SUCCESS: 'TREASURY.THIRD_PARTY.ACCOUNT.SAVED_SUCCESS', // Cuenta bancaria guardada exitosamente / Bank account saved successfully
    },

    CONFIRM: {
      CANCEL_TITLE: 'TREASURY.THIRD_PARTY.CONFIRM.CANCEL_TITLE', // Cancelar edición / Cancel edition
      CANCEL_MESSAGE: 'TREASURY.THIRD_PARTY.CONFIRM.CANCEL_MESSAGE', // Se va a cancelar la edición la información de Cuentas / Bank account information edition will be cancelled
      SUCCESS: 'TREASURY.THIRD_PARTY.ALERT.UPDATE_SUCCESS',
      ERROR: 'TREASURY.THIRD_PARTY.ALERT.UPDATE_ERROR',
    },

    FILTER: {
      STATUS: 'TREASURY.THIRD_PARTY.FILTER.STATUS', // Filtrar por estado / Filter by status
      ALL: 'TREASURY.THIRD_PARTY.FILTER.ALL', // Todos / All
    },
  },
  CANCELLATION_INCOME: {
    // La grilla declarativa compone estas por convencion, a partir del prefijo de la pantalla. El
    // contador y la descripcion de la tabla vacia ya existian con este mismo prefijo.
    SEARCH_PLACEHOLDER: 'TREASURY.CANCELLATION_INCOME.SEARCH_PLACEHOLDER', // Buscar por consecutivo, identificación o nombre del tercero...
    TITLE: {
      LIST: 'TREASURY.CANCELLATION_INCOME.TITLE.LIST', // Anulación de Ingresos
      VIEW: 'TREASURY.CANCELLATION_INCOME.TITLE.VIEW', // Consultar comprobante de ingreso
    },
    SUBTITLE: {
      LIST: 'TREASURY.CANCELLATION_INCOME.SUBTITLE.LIST', // Comprobantes de ingreso aprobados de la vigencia activa
      VIEW: 'TREASURY.CANCELLATION_INCOME.SUBTITLE.VIEW', // Detalle del comprobante de ingreso
    },
    COLUMN: {
      CONSECUTIVE: 'TREASURY.CANCELLATION_INCOME.COLUMN.CONSECUTIVE', // Consecutivo
      IDENTIFICATION: 'TREASURY.BANK_PAYMENTS.COLUMN.IDENTIFICATION', // No. Identificación (reusa)
      NAME: 'TREASURY.BANK_PAYMENTS.COLUMN.NAME', // Nombre o Razón Social (reusa)
      DATE: 'TREASURY.CANCELLATION_INCOME.COLUMN.DATE', // Fecha CI
      VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VALUE', // Valor (reusa)
      STATUS: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS', // Estado (reusa)
      MOTIVO: 'TREASURY.CANCELLATION_INCOME.COLUMN.MOTIVO', // Motivo anulación
    },
    PLACEHOLDER: {
      SEARCH: 'TREASURY.CANCELLATION_INCOME.PLACEHOLDER.SEARCH', // Buscar por consecutivo, identificación o tercero
    },
    EMPTY: {
      MESSAGE: 'TREASURY.CANCELLATION_INCOME.EMPTY.MESSAGE', // No se encontraron comprobantes de ingreso anulables
      DEFAULT: 'TREASURY.CANCELLATION_INCOME.EMPTY.DEFAULT', // No hay comprobantes de ingreso anulables
      SEARCH: 'TREASURY.CANCELLATION_INCOME.EMPTY.SEARCH', // No se encontraron comprobantes que coincidan con la búsqueda
      DESCRIPTION: 'TREASURY.CANCELLATION_INCOME.EMPTY.DESCRIPTION', // Intente con otro criterio o verifique los CI en estado Aprobado
    },
    COUNTER: {
      SINGULAR: 'TREASURY.CANCELLATION_INCOME.COUNTER.SINGULAR', // comprobante
      PLURAL: 'TREASURY.CANCELLATION_INCOME.COUNTER.PLURAL', // comprobantes
    },
    PANEL: {
      USAGE_HINT: 'TREASURY.CANCELLATION_INCOME.PANEL.USAGE_HINT', // Aquí se consulta el comprobante de ingreso aprobado. La anulación se hace desde el listado, seleccionando los comprobantes y escribiendo el motivo. / The approved income voucher is consulted here. Annulment is done from the list, by selecting the vouchers and entering the reason.
    },
    OPTION: {
      APROBADO: 'TREASURY.INCOME.FILTERS.ESTADO.OPTIONS.APROBADO', // Aprobado (reusa Ingresos)
      ANULADO: 'TREASURY.CANCELLATION_INCOME.OPTION.ANULADO', // Anulado / Annulled
    },
    ACTION: {
      ANNUL: 'TREASURY.CANCELLATION_INCOME.ACTION.ANNUL', // Anular
      CANCEL: 'ACTIONS.BACK', // Cancelar (common_keys)
      VIEW: 'ACTIONS.VIEW', // Consultar (common_keys)
      REFRESH: 'ACTIONS.REFRESH', // Refrescar (common_keys)
    },
    MODAL: {
      ANNUL_TITLE: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_TITLE', // Motivo de anulación
      ANNUL_LABEL: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_LABEL', // Motivo
      ANNUL_PLACEHOLDER: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_PLACEHOLDER', // Ingrese el motivo (mínimo 5 caracteres)
      ANNUL_DESCRIPTION: 'TREASURY.CANCELLATION_INCOME.MODAL.ANNUL_DESCRIPTION', // ¿Está seguro de anular {count} comprobante(s)?
    },
    LABEL: {
      SEARCH: 'LABELS.SEARCH', // Buscar (common_keys)
      CONSECUTIVE: 'TREASURY.CANCELLATION_INCOME.COLUMN.CONSECUTIVE',
      IDENTIFICATION: 'TREASURY.BANK_PAYMENTS.COLUMN.IDENTIFICATION',
      NAME: 'TREASURY.BANK_PAYMENTS.COLUMN.NAME',
      DATE: 'TREASURY.CANCELLATION_INCOME.COLUMN.DATE',
      VALUE: 'TREASURY.BANK_PAYMENTS.COLUMN.VALUE',
      STATUS: 'TREASURY.BANK_PAYMENTS.COLUMN.STATUS',
      MOTIVO: 'TREASURY.CANCELLATION_INCOME.COLUMN.MOTIVO',
    },
    MESSAGE: {
      ANNUL_SUCCESS: 'TREASURY.CANCELLATION_INCOME.MESSAGE.ANNUL_SUCCESS', // Comprobante(s) anulado(s) correctamente
      ANNUL_PARTIAL: 'TREASURY.CANCELLATION_INCOME.MESSAGE.ANNUL_PARTIAL', // Anulación parcial: {ok} anulados; no anulados ({fail}): {consecutivos}
      SELECTION_REQUIRED: 'TREASURY.CANCELLATION_INCOME.MESSAGE.SELECTION_REQUIRED', // Seleccione al menos un comprobante para anular
      MOTIVO_MIN: 'TREASURY.CANCELLATION_INCOME.MESSAGE.MOTIVO_MIN', // El motivo debe tener al menos {min} caracteres
      MOTIVO_MAX: 'TREASURY.CANCELLATION_INCOME.MESSAGE.MOTIVO_MAX', // El motivo no puede exceder {max} caracteres
      MOTIVO_REQUIRED: 'TREASURY.CANCELLATION_INCOME.MESSAGE.MOTIVO_REQUIRED', // El motivo de anulación es obligatorio
      LOAD_ERROR: 'TREASURY.CANCELLATION_INCOME.MESSAGE.LOAD_ERROR', // No se pudo cargar el listado de comprobantes
      READ_ERROR: 'TREASURY.CANCELLATION_INCOME.MESSAGE.READ_ERROR', // No se pudo consultar el comprobante
      ANNUL_ERROR: 'TREASURY.CANCELLATION_INCOME.MESSAGE.ANNUL_ERROR', // No se pudo anular el/los comprobante(s)
      SEARCH_HINT_MIN: 'TREASURY.CANCELLATION_INCOME.MESSAGE.SEARCH_HINT_MIN', // Debe ingresar entre {min} y {max} caracteres
      SEARCH_HINT_MAX: 'TREASURY.CANCELLATION_INCOME.MESSAGE.SEARCH_HINT_MAX', // Máximo {max} caracteres
      PERMISSION_DENIED: 'TREASURY.CANCELLATION_INCOME.MESSAGE.PERMISSION_DENIED', // No tiene permisos para realizar esta acción
    },
    PERMISSION: {
      DENIED_ANNUL: 'TREASURY.CANCELLATION_INCOME.PERMISSION.DENIED_ANNUL', // No tiene permisos para anular
      DENIED_VIEW: 'TREASURY.CANCELLATION_INCOME.PERMISSION.DENIED_VIEW', // No tiene permisos para consultar
    },
  },

  BANK_OPERATIONS_CLOSING: {},

  /**
   * Archivos de Pago (HU-TES-014).
   *
   */
  PAYMENT_FILES: {
    TITLE: {
      LIST: 'TREASURY.PAYMENT_FILES.TITLE.LIST', // Archivos de Pago / Payment Files
      CREATE: 'TREASURY.PAYMENT_FILES.TITLE.CREATE', // Crear Archivo de Pago / Create Payment File
      EDIT: 'TREASURY.PAYMENT_FILES.TITLE.EDIT', // Editar Archivo de Pago / Edit Payment File
      VIEW: 'TREASURY.PAYMENT_FILES.TITLE.VIEW', // Consultar Archivo de Pago / View Payment File
    },
    SUBTITLE: {
      LIST: 'TREASURY.PAYMENT_FILES.SUBTITLE.LIST', // Gestión de archivos de dispersión de pagos / Payment dispersion files management
      CREATE: 'TREASURY.PAYMENT_FILES.SUBTITLE.CREATE', // Crear nuevo archivo de pago / Create a new payment file
      EDIT: 'TREASURY.PAYMENT_FILES.SUBTITLE.EDIT', // Editar archivo de pago / Edit payment file
      VIEW: 'TREASURY.PAYMENT_FILES.SUBTITLE.VIEW', // Detalle del archivo de pago / Payment file detail
    },
    SEARCH_PLACEHOLDER: 'TREASURY.PAYMENT_FILES.SEARCH_PLACEHOLDER', // Buscar por consecutivo, cuenta, nombre... / Search by number, account, name...
    COUNTER: {
      SINGULAR: 'TREASURY.PAYMENT_FILES.COUNTER.SINGULAR', // archivo / file
      PLURAL: 'TREASURY.PAYMENT_FILES.COUNTER.PLURAL', // archivos / files
    },

    // Pestañas de las secciones de crear, editar y consultar
    TABS: {
      PRINCIPAL: 'TREASURY.PAYMENT_FILES.TABS.PRINCIPAL', // Principal / Main
      EXPENSES: 'TREASURY.PAYMENT_FILES.TABS.EXPENSES', // Egresos / Expenses
      EGRESOS: 'TREASURY.PAYMENT_FILES.TABS.EGRESOS', // Egresos asociados / Associated expenses
    },

    // Línea de filtros del listado (FN-ALC1-02 a FN-ALC1-04)
    FILTERS: {
      SEARCH_PLACEHOLDER: 'TREASURY.PAYMENT_FILES.FILTERS.SEARCH_PLACEHOLDER', // Buscar por consecutivo, banco, cuenta o nombre del archivo / Search by number, bank, account or file name
      BENEFICIARY: {
        LABEL: 'TREASURY.PAYMENT_FILES.FILTERS.BENEFICIARY.LABEL', // No. Beneficiario / Beneficiary No.
        PLACEHOLDER: 'TREASURY.PAYMENT_FILES.FILTERS.BENEFICIARY.PLACEHOLDER', // Ingrese el número de identificación / Enter the identification number
        SEARCH: 'TREASURY.PAYMENT_FILES.FILTERS.BENEFICIARY.SEARCH', // Buscar en el Maestro de Terceros / Search in the Third Parties Master
        MODAL_TITLE: 'TREASURY.PAYMENT_FILES.FILTERS.BENEFICIARY.MODAL_TITLE', // Seleccionar Tercero / Select Third Party
      },
      BENEFICIARY_NAME: {
        LABEL: 'TREASURY.PAYMENT_FILES.FILTERS.BENEFICIARY_NAME.LABEL', // Nombre o Razón Social / Name or Business Name
        PLACEHOLDER: 'TREASURY.PAYMENT_FILES.FILTERS.BENEFICIARY_NAME.PLACEHOLDER', // Se autocompleta al seleccionar el beneficiario / Filled in when the beneficiary is selected
      },
    },

    // Columnas del listado y de las tablas de egresos
    TABLE: {
      FILE_NUMBER: 'TREASURY.PAYMENT_FILES.TABLE.FILE_NUMBER', // Consecutivo / Number
      ACCOUNT_CODE: 'TREASURY.PAYMENT_FILES.TABLE.ACCOUNT_CODE', // Cód. Cuenta / Account Code
      ACCOUNT_NAME: 'TREASURY.PAYMENT_FILES.TABLE.ACCOUNT_NAME', // Nombre de la Cuenta / Account Name
      FILE_NAME: 'TREASURY.PAYMENT_FILES.TABLE.FILE_NAME', // Nombre Archivo / File Name
      RECORD_COUNT: 'TREASURY.PAYMENT_FILES.TABLE.RECORD_COUNT', // No. Registros / Records
      TOTAL_VALUE: 'TREASURY.PAYMENT_FILES.TABLE.TOTAL_VALUE', // Valor Total / Total Amount
      EXPENSE_NUMBER: 'TREASURY.PAYMENT_FILES.TABLE.EXPENSE_NUMBER', // No. Egreso / Expense No.
      EGRESO_NUMBER: 'TREASURY.PAYMENT_FILES.TABLE.EGRESO_NUMBER', // No. Egreso / Expense No.
      PAYROLL_NUMBER: 'TREASURY.PAYMENT_FILES.TABLE.PAYROLL_NUMBER', // No. Nómina / Payroll No.
      PAYMENT_VALUE: 'TREASURY.PAYMENT_FILES.TABLE.PAYMENT_VALUE', // Valor Pago / Payment Amount
      IDENTIFICATION: 'TREASURY.PAYMENT_FILES.TABLE.IDENTIFICATION', // No. Identificación / Identification No.
      BENEFICIARY_NAME: 'TREASURY.PAYMENT_FILES.TABLE.BENEFICIARY_NAME', // Nombre Beneficiario / Beneficiary Name
      BANK_CODE: 'TREASURY.PAYMENT_FILES.TABLE.BANK_CODE', // Cód. Banco a Transferir / Transfer Bank Code
      ACCOUNT_NUMBER: 'TREASURY.PAYMENT_FILES.TABLE.ACCOUNT_NUMBER', // Cuenta a Transferir / Transfer Account
      TOTAL_EXPENSES: 'TREASURY.PAYMENT_FILES.TABLE.TOTAL_EXPENSES', // Total egresos seleccionados / Total selected expenses
      FILE_BANK_CODE: 'TREASURY.PAYMENT_FILES.TABLE.FILE_BANK_CODE', // Cód. Banco / Bank Code
      BANK_ACCOUNT_NUMBER: 'TREASURY.PAYMENT_FILES.TABLE.BANK_ACCOUNT_NUMBER', // No. Cuenta Bancaria / Bank Account No.
      ELABORATION_DATE: 'TREASURY.PAYMENT_FILES.TABLE.ELABORATION_DATE', // Fecha Elaboración / Created On
    },

    // Emergente de cuentas de banco elegibles (INT-ALC2-02)
    ACCOUNT_MODAL: {
      TITLE: 'TREASURY.PAYMENT_FILES.ACCOUNT_MODAL.TITLE', // Búsqueda de Cuentas de Banco / Bank Accounts Search
      SEARCH_PLACEHOLDER: 'TREASURY.PAYMENT_FILES.ACCOUNT_MODAL.SEARCH_PLACEHOLDER', // Buscar por código, número o nombre de la cuenta / Search by code, number or account name
      COL_CODE: 'TREASURY.PAYMENT_FILES.ACCOUNT_MODAL.COL_CODE', // Código Cuenta / Account Code
      COL_NUMBER: 'TREASURY.PAYMENT_FILES.ACCOUNT_MODAL.COL_NUMBER', // # Cuenta Banco / Bank Account #
      COL_NAME: 'TREASURY.PAYMENT_FILES.ACCOUNT_MODAL.COL_NAME', // Nombre Cuenta Banco / Bank Account Name
      COL_BANK: 'TREASURY.PAYMENT_FILES.ACCOUNT_MODAL.COL_BANK', // Banco / Bank
    },

    // Secciones de crear y editar (INT-ALC2-01 / INT-ALC3-01)
    CREATE: {
      HEADER_TITLE: 'TREASURY.PAYMENT_FILES.CREATE.HEADER_TITLE', // Datos del archivo / File data
      EXPENSES_TABLE_TITLE: 'TREASURY.PAYMENT_FILES.CREATE.EXPENSES_TABLE_TITLE', // Relación de egresos — Estado: Transferir / Expense list — Status: Transfer
      FIELDS: {
        COD_CUENTA: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.COD_CUENTA', // Cód. Cuenta / Account Code
        CUENTA_BANCO: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.CUENTA_BANCO', // # Cuenta Banco / Bank Account #
        NOMBRE_CUENTA: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.NOMBRE_CUENTA', // Nombre Cuenta / Account Name
        FECHA_ELABORACION: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.FECHA_ELABORACION', // Fecha Elaboración / Created On
        FECHA_GENERACION: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.FECHA_GENERACION', // Fecha Generación / Generated On
        FECHA_PAGO: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.FECHA_PAGO', // Fecha de Pago / Payment Date
        NOMBRE_ARCHIVO: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.NOMBRE_ARCHIVO', // Nombre Archivo / File Name
        USUARIO_ELABORADOR: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.USUARIO_ELABORADOR', // Usuario Elaborador / Created By
        DEFAULT_USER: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.DEFAULT_USER', // Usuario / User
        ESTADO: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.ESTADO', // Estado / Status
        GENERAR: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.GENERAR', // Generar archivo plano / Generate flat file
        GENERAR_HINT: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.GENERAR_HINT', // Al guardar con esta opción marcada el archivo pasa a Generado y no podrá editarse / Saving with this option checked turns the file into Generated and it can no longer be edited
        SEARCH_ACCOUNT: 'TREASURY.PAYMENT_FILES.CREATE.FIELDS.SEARCH_ACCOUNT', // Cuenta de banco / Bank account
      },
      PLACEHOLDERS: {
        COD_CUENTA: 'TREASURY.PAYMENT_FILES.CREATE.PLACEHOLDERS.COD_CUENTA', // Seleccione la cuenta con la lupa / Select the account with the search icon
        NOMBRE_ARCHIVO: 'TREASURY.PAYMENT_FILES.CREATE.PLACEHOLDERS.NOMBRE_ARCHIVO', // Mínimo 3 y máximo 50 caracteres / Minimum 3 and maximum 50 characters
        SEARCH_ACCOUNT: 'TREASURY.PAYMENT_FILES.CREATE.PLACEHOLDERS.SEARCH_ACCOUNT', // Buscar cuenta de banco / Search bank account
      },
      TOOLTIPS: {
        SEARCH_ACCOUNT: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.SEARCH_ACCOUNT', // Solo cuentas con estructura de archivo activa y egresos por transferir / Only accounts with an active file structure and expenses to transfer
        COD_CUENTA: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.COD_CUENTA', // Cuenta de banco desde la que se dispersan los pagos. Se valida que exista, que su banco tenga estructura de archivo activa y que tenga egresos por transferir / Bank account the payments are dispersed from. It is validated to exist, to have an active file structure for its bank and to have expenses to transfer
        CUENTA_BANCO: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.CUENTA_BANCO', // Número de la cuenta en el Maestro de Cuentas de Banco. Se autocompleta con el Cód. Cuenta / Account number from the Bank Accounts Master. Filled in from the account code
        NOMBRE_CUENTA: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.NOMBRE_CUENTA', // Nombre de la cuenta en el Maestro de Cuentas de Banco. Se autocompleta con el Cód. Cuenta / Account name from the Bank Accounts Master. Filled in from the account code
        FECHA_ELABORACION: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.FECHA_ELABORACION', // Fecha del sistema en la que se elabora el archivo. No es modificable / System date on which the file is created. It cannot be modified
        FECHA_GENERACION: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.FECHA_GENERACION', // Se diligencia automáticamente cuando el archivo se genera / Filled in automatically when the file is generated
        FECHA_PAGO: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.FECHA_PAGO', // Fecha programada de pago. Debe ser mayor o igual a la fecha del sistema / Scheduled payment date. It must be on or after the system date
        NOMBRE_ARCHIVO: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.NOMBRE_ARCHIVO', // Nombre del archivo plano a generar. Entre 3 y 50 caracteres, sin espacios al inicio ni al final / Name of the flat file to generate. Between 3 and 50 characters, with no leading or trailing spaces
        USUARIO_ELABORADOR: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.USUARIO_ELABORADOR', // Usuario de la sesión activa que elabora el archivo / User of the active session who creates the file
        GENERAR: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.GENERAR', // Genera el archivo plano con la estructura activa del banco y deja el archivo en estado Generado. Es irreversible / Generates the flat file with the active structure of the bank and leaves the file as Generated. It is irreversible
        ESTADO: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.ESTADO', // Estado actual del archivo: Borrador admite edición y eliminación, Generado solo consulta / Current file status: Draft allows editing and deletion, Generated only allows viewing
        RECORDS_COUNT: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.RECORDS_COUNT', // Cantidad de egresos incluidos en el archivo / Number of expenses included in the file
        TOTAL_VALUE: 'TREASURY.PAYMENT_FILES.CREATE.TOOLTIPS.TOTAL_VALUE', // Suma del valor de los egresos incluidos en el archivo / Sum of the amounts of the expenses included in the file
      },
      SUMMARY: {
        TITLE: 'TREASURY.PAYMENT_FILES.CREATE.SUMMARY.TITLE', // Resumen / Summary
        RECORDS_COUNT: 'TREASURY.PAYMENT_FILES.CREATE.SUMMARY.RECORDS_COUNT', // No. Registros / Records
        TOTAL_VALUE: 'TREASURY.PAYMENT_FILES.CREATE.SUMMARY.TOTAL_VALUE', // Valor Total / Total Amount
      },
    },

    // Sección de consulta (INT-ALC3-02)
    VIEW: {
      NO_EGRESOS: 'TREASURY.PAYMENT_FILES.VIEW.NO_EGRESOS', // El archivo no tiene egresos asociados / The file has no associated expenses
      TOTAL_EXPENSES: 'TREASURY.PAYMENT_FILES.VIEW.TOTAL_EXPENSES', // Total egresos / Total expenses
    },
    /** Panel del motor: resumen del archivo y, al capturar o editar, lo que falta. */
    PANEL: {
      SUMMARY: 'TREASURY.PAYMENT_FILES.PANEL.SUMMARY', // Archivo de pago / Payment file
      SUMMARY_TITLE_EMPTY: 'TREASURY.PAYMENT_FILES.PANEL.SUMMARY_TITLE_EMPTY', // Archivo sin nombre / Unnamed file
      CHECKLIST: 'TREASURY.PAYMENT_FILES.PANEL.CHECKLIST', // Antes de guardar / Before saving
    },

    STATUS: {
      BORRADOR: 'TREASURY.PAYMENT_FILES.STATUS.BORRADOR', // Borrador / Draft
      GENERADO: 'TREASURY.PAYMENT_FILES.STATUS.GENERADO', // Generado / Generated
    },

    ACTIONS: {
      CREATE: 'TREASURY.PAYMENT_FILES.ACTIONS.CREATE', // Crear / Create
      EDIT: 'TREASURY.PAYMENT_FILES.ACTIONS.EDIT', // Editar / Edit
      DELETE: 'TREASURY.PAYMENT_FILES.ACTIONS.DELETE', // Eliminar / Delete
      VIEW: 'TREASURY.PAYMENT_FILES.ACTIONS.VIEW', // Consultar / View
      GENERATE: 'TREASURY.PAYMENT_FILES.ACTIONS.GENERATE', // Sí, Generar / Yes, Generate
      REFRESH: 'TREASURY.PAYMENT_FILES.ACTIONS.REFRESH', // Refrescar / Refresh
      BACK: 'TREASURY.PAYMENT_FILES.ACTIONS.BACK', // Regresar / Back
      SELECT_ALL: 'TREASURY.PAYMENT_FILES.ACTIONS.SELECT_ALL', // Seleccionar todos / Select all
      CLEAR_SELECTION: 'TREASURY.PAYMENT_FILES.ACTIONS.CLEAR_SELECTION', // Limpiar selección / Clear selection
    },

    // Diálogos de confirmación (MSG-12, MSG-15 y mensaje de cancelación del ANX-03)
    CONFIRM: {
      DELETE_TITLE: 'TREASURY.PAYMENT_FILES.CONFIRM.DELETE_TITLE', // Confirmación de eliminación / Delete confirmation
      DELETE_MESSAGE: 'TREASURY.PAYMENT_FILES.CONFIRM.DELETE_MESSAGE', // Se va a eliminar el archivo de pago {{fileName}}. Esta acción es permanente y no se puede deshacer. / Payment file {{fileName}} will be deleted. This action is permanent and cannot be undone.
      CANCEL_TITLE: 'TREASURY.PAYMENT_FILES.CONFIRM.CANCEL_TITLE', // Confirmar Cancelación / Confirm Cancellation
      CANCEL_CREATE_MESSAGE: 'TREASURY.PAYMENT_FILES.CONFIRM.CANCEL_CREATE_MESSAGE', // Se va a cancelar la creación del archivo. Los datos ingresados no serán guardados. / The file creation will be cancelled. The entered data will not be saved.
      CANCEL_EDIT_MESSAGE: 'TREASURY.PAYMENT_FILES.CONFIRM.CANCEL_EDIT_MESSAGE', // Se va a cancelar la edición del archivo. Los datos ingresados no serán guardados. / The file edition will be cancelled. The entered data will not be saved.
      GENERATE_TITLE: 'TREASURY.PAYMENT_FILES.CONFIRM.GENERATE_TITLE', // Confirmar Generación / Confirm Generation
      GENERATE_MESSAGE: 'TREASURY.PAYMENT_FILES.CONFIRM.GENERATE_MESSAGE', // ¿Confirma que desea cambiar el estado del archivo {{fileName}} a Generado? Esta acción es irreversible y no podrá deshacerse. / Do you confirm changing file {{fileName}} to Generated? This action is irreversible and cannot be undone.
    },

    // Mensajes de resultado que muestra la pantalla
    MESSAGES: {
      CREATE_DRAFT_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGES.CREATE_DRAFT_SUCCESS', // El archivo de pago {{fileName}} fue creado en estado Borrador / Payment file {{fileName}} was created as Draft
      CREATE_GENERATED_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGES.CREATE_GENERATED_SUCCESS', // El archivo de pago {{fileName}} fue generado exitosamente / Payment file {{fileName}} was generated successfully
      UPDATE_DRAFT_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGES.UPDATE_DRAFT_SUCCESS', // Los cambios en el archivo de pago {{fileName}} fueron guardados correctamente / Changes to payment file {{fileName}} were saved successfully
      UPDATE_GENERATED_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGES.UPDATE_GENERATED_SUCCESS', // El archivo de pago {{fileName}} fue generado exitosamente y su estado cambió a Generado / Payment file {{fileName}} was generated successfully and its status changed to Generated
      DELETE_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGES.DELETE_SUCCESS', // El archivo de pago fue eliminado exitosamente del sistema / The payment file was successfully deleted from the system
      LOADING_EXPENSES: 'TREASURY.PAYMENT_FILES.MESSAGES.LOADING_EXPENSES', // Cargando egresos transferibles... / Loading transferable expenses...
      TOO_MANY_RECORDS: 'TREASURY.PAYMENT_FILES.MESSAGES.TOO_MANY_RECORDS', // Se encontraron más de {{max}} registros. Aplique filtros adicionales para refinar los resultados y mejorar el rendimiento de la consulta. / More than {{max}} records were found. Apply additional filters to refine the results and improve query performance.
    },

    // Errores y avisos de la pantalla
    ERRORS: {
      NOT_FOUND: 'TREASURY.PAYMENT_FILES.ERRORS.NOT_FOUND', // No se encontró el archivo de pago / Payment file not found
      CREATE_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.CREATE_FAILED', // No fue posible crear el archivo de pago / The payment file could not be created
      UPDATE_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.UPDATE_FAILED', // No fue posible actualizar el archivo de pago / The payment file could not be updated
      DELETE_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.DELETE_FAILED', // No fue posible eliminar el archivo de pago / The payment file could not be deleted
      LOAD_VIEW_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.LOAD_VIEW_FAILED', // No fue posible cargar el detalle del archivo de pago / The payment file detail could not be loaded
      LOAD_EDIT_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.LOAD_EDIT_FAILED', // No fue posible cargar el archivo de pago para edición / The payment file could not be loaded for editing
      LOAD_EXPENSES_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.LOAD_EXPENSES_FAILED', // No fue posible cargar los egresos transferibles de la cuenta / The transferable expenses for the account could not be loaded
      MISSING_ID: 'TREASURY.PAYMENT_FILES.ERRORS.MISSING_ID', // No se encontró el identificador del archivo de pago / The payment file identifier was not found
      MISSING_DETAIL: 'TREASURY.PAYMENT_FILES.ERRORS.MISSING_DETAIL', // No se encontró el detalle del archivo de pago / The payment file detail was not found
      COMPLETE_REQUIRED_FIELDS: 'TREASURY.PAYMENT_FILES.ERRORS.COMPLETE_REQUIRED_FIELDS', // Los campos obligatorios marcados con (*) no han sido diligenciados. Complete la información requerida antes de continuar. / The required fields marked with (*) are empty. Complete the required information before continuing.
      SELECT_AT_LEAST_ONE_EXPENSE: 'TREASURY.PAYMENT_FILES.ERRORS.SELECT_AT_LEAST_ONE_EXPENSE', // Debe seleccionar al menos un egreso para crear el archivo de pago / Select at least one expense to create the payment file
      INVALID_DATE_RANGE: 'TREASURY.PAYMENT_FILES.ERRORS.INVALID_DATE_RANGE', // El rango de fechas es inválido. La fecha inicial no puede ser posterior a la fecha final. / The date range is invalid. The start date cannot be later than the end date.
      FECHA_PAGO_ANTERIOR: 'TREASURY.PAYMENT_FILES.ERRORS.FECHA_PAGO_ANTERIOR', // La fecha de pago debe ser mayor o igual a la fecha del sistema / The payment date must be on or after the system date
      THIRD_PARTY_NOT_FOUND: 'TREASURY.PAYMENT_FILES.ERRORS.THIRD_PARTY_NOT_FOUND', // El tercero ingresado no existe en el Maestro de Terceros o no se encuentra Activo / The entered third party does not exist in the Third Parties Master or is not Active
      BENEFICIARY_LOOKUP_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.BENEFICIARY_LOOKUP_FAILED', // No fue posible validar el beneficiario. Intente nuevamente. / The beneficiary could not be validated. Please try again.
      ACCOUNT_NOT_FOUND: 'TREASURY.PAYMENT_FILES.ERRORS.ACCOUNT_NOT_FOUND', // El código del banco no existe o no está activo / The bank code does not exist or is not active
      ACCOUNT_WITHOUT_STRUCTURE: 'TREASURY.PAYMENT_FILES.ERRORS.ACCOUNT_WITHOUT_STRUCTURE', // Para el Banco {{bankName}} no existe una estructura de archivo de pago definida o no está activa / There is no payment file structure defined or active for bank {{bankName}}
      NO_TRANSFERABLE_EXPENSES: 'TREASURY.PAYMENT_FILES.ERRORS.NO_TRANSFERABLE_EXPENSES', // No existen Egresos para transferir o el tercero no tiene cuenta de banco activo / There are no expenses to transfer or the third party has no active bank account
      ACCOUNT_LOOKUP_FAILED: 'TREASURY.PAYMENT_FILES.ERRORS.ACCOUNT_LOOKUP_FAILED', // No fue posible validar la cuenta de banco. Intente nuevamente. / The bank account could not be validated. Please try again.
      FILE_NAME_SPACES: 'TREASURY.PAYMENT_FILES.ERRORS.FILE_NAME_SPACES', // El nombre del archivo no puede iniciar ni terminar con espacios / The file name cannot start or end with spaces
      EDIT_GENERATED_NOT_ALLOWED: 'TREASURY.PAYMENT_FILES.ERRORS.EDIT_GENERATED_NOT_ALLOWED', // El archivo de pago se encuentra en estado Generado. No es posible modificar su información. Solo se permite la consulta. / The payment file is Generated. Its information cannot be modified, it can only be viewed.
      DELETE_GENERATED_NOT_ALLOWED: 'TREASURY.PAYMENT_FILES.ERRORS.DELETE_GENERATED_NOT_ALLOWED', // No es posible eliminar el archivo de pago {{fileName}}. Los archivos en estado Generado no pueden ser eliminados del sistema. / Payment file {{fileName}} cannot be deleted. Generated files cannot be removed from the system.
      PERMISSION_DENIED: 'TREASURY.PAYMENT_FILES.ERRORS.PERMISSION_DENIED', // No cuenta con los permisos necesarios para ejecutar esta acción. Contacte al administrador del sistema. / You do not have the permissions required for this action. Contact the system administrator.
      SERVER_ERROR: 'TREASURY.PAYMENT_FILES.ERRORS.SERVER_ERROR', // Ocurrió un error al comunicarse con el servidor. Intente nuevamente en unos momentos. Si el problema persiste, contacte soporte técnico. (Código: {{code}}) / An error occurred while contacting the server. Try again in a few moments. If the problem persists, contact technical support. (Code: {{code}})
    },

    VALIDATION: {
      MIN_SEARCH_LENGTH: 'TREASURY.PAYMENT_FILES.VALIDATION.MIN_SEARCH_LENGTH', // Debe ingresar al menos {{min}} caracteres para buscar / Enter at least {{min}} characters to search
      INVALID_DATE_RANGE: 'TREASURY.PAYMENT_FILES.VALIDATION.INVALID_DATE_RANGE', // La fecha inicial no puede ser mayor a la fecha final / The start date cannot be later than the end date
      NO_CUENTA_SELECTED: 'TREASURY.PAYMENT_FILES.VALIDATION.NO_CUENTA_SELECTED', // Debe seleccionar una cuenta de banco / Select a bank account
      NO_EGRESOS_SELECTED: 'TREASURY.PAYMENT_FILES.VALIDATION.NO_EGRESOS_SELECTED', // Debe seleccionar al menos un egreso / Select at least one expense
      NOMBRE_ARCHIVO_REQUIRED: 'TREASURY.PAYMENT_FILES.VALIDATION.NOMBRE_ARCHIVO_REQUIRED', // Se debe ingresar un nombre válido / A valid name must be entered
      FECHA_PAGO_REQUIRED: 'TREASURY.PAYMENT_FILES.VALIDATION.FECHA_PAGO_REQUIRED', // Debe ingresar la fecha de pago / Enter the payment date
      FECHA_PAGO_INVALID: 'TREASURY.PAYMENT_FILES.VALIDATION.FECHA_PAGO_INVALID', // La fecha debe ser mayor o igual a la fecha del sistema / The date must be on or after the system date
    },

    // Estados vacíos de las grillas (MSG-01 y equivalentes)
    EMPTY: {
      MESSAGE: 'TREASURY.PAYMENT_FILES.EMPTY.MESSAGE', // No hay archivos de pago / There are no payment files
      DESCRIPTION: 'TREASURY.PAYMENT_FILES.EMPTY.DESCRIPTION', // Cree el primer archivo de pago para comenzar / Create the first payment file to get started
      NO_FILES: 'TREASURY.PAYMENT_FILES.EMPTY.NO_FILES', // No se encontraron archivos de pago en el período consultado / No payment files were found in the selected period
      NO_FILES_DESC: 'TREASURY.PAYMENT_FILES.EMPTY.NO_FILES_DESC', // Cambie el rango de fechas o cree un nuevo archivo de pago / Change the date range or create a new payment file
      NO_RESULTS: 'TREASURY.PAYMENT_FILES.EMPTY.NO_RESULTS', // No se encontraron registros que coincidan con el criterio de búsqueda aplicado / No records match the search criteria applied
      NO_RESULTS_DESC: 'TREASURY.PAYMENT_FILES.EMPTY.NO_RESULTS_DESC', // Intente con otros términos o verifique los filtros aplicados / Try other terms or check the filters applied
      NO_EGRESOS: 'TREASURY.PAYMENT_FILES.EMPTY.NO_EGRESOS', // No hay egresos transferibles disponibles / There are no transferable expenses available
      NO_EGRESOS_DESC: 'TREASURY.PAYMENT_FILES.EMPTY.NO_EGRESOS_DESC', // La cuenta bancaria seleccionada no tiene egresos en estado Transferir para agregar a este archivo de pago / The selected bank account has no expenses in Transfer status to add to this payment file
      SELECT_ACCOUNT: 'TREASURY.PAYMENT_FILES.EMPTY.SELECT_ACCOUNT', // Seleccione una cuenta bancaria para ver los egresos transferibles disponibles / Select a bank account to see the available transferable expenses
    },

    // Rótulos declarados en payment-files.constants.ts (PAYMENT_FILES_LABELS)
    LABEL: {
      COD_CUENTA: 'TREASURY.PAYMENT_FILES.LABEL.COD_CUENTA', // Cód. Cuenta / Account Code
      CUENTA_BANCO: 'TREASURY.PAYMENT_FILES.LABEL.CUENTA_BANCO', // # Cuenta Banco / Bank Account #
      NOMBRE_CUENTA: 'TREASURY.PAYMENT_FILES.LABEL.NOMBRE_CUENTA', // Nombre Cuenta / Account Name
      FECHA_ELABORACION: 'TREASURY.PAYMENT_FILES.LABEL.FECHA_ELABORACION', // Fecha Elaboración / Created On
      FECHA_GENERACION: 'TREASURY.PAYMENT_FILES.LABEL.FECHA_GENERACION', // Fecha Generación / Generated On
      FECHA_PAGO: 'TREASURY.PAYMENT_FILES.LABEL.FECHA_PAGO', // Fecha de Pago / Payment Date
      NOMBRE_ARCHIVO: 'TREASURY.PAYMENT_FILES.LABEL.NOMBRE_ARCHIVO', // Nombre Archivo / File Name
      USUARIO_ELABORADOR: 'TREASURY.PAYMENT_FILES.LABEL.USUARIO_ELABORADOR', // Usuario Elaborador / Created By
      ESTADO: 'TREASURY.PAYMENT_FILES.LABEL.ESTADO', // Estado / Status
      NO_REGISTROS: 'TREASURY.PAYMENT_FILES.LABEL.NO_REGISTROS', // No. Registros / Records
      VALOR_TOTAL: 'TREASURY.PAYMENT_FILES.LABEL.VALOR_TOTAL', // Valor Total / Total Amount
      EGRESOS_SELECCIONADOS: 'TREASURY.PAYMENT_FILES.LABEL.EGRESOS_SELECCIONADOS', // Egresos seleccionados / Selected expenses
      GENERAR_ARCHIVO: 'TREASURY.PAYMENT_FILES.LABEL.GENERAR_ARCHIVO', // Generar archivo / Generate file
    },

    // Mensajes declarados en payment-files.constants.ts (PAYMENT_FILES_MESSAGES)
    MESSAGE: {
      CREATE_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGE.CREATE_SUCCESS', // Archivo de pago creado correctamente / Payment file created successfully
      UPDATE_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGE.UPDATE_SUCCESS', // Archivo de pago actualizado correctamente / Payment file updated successfully
      DELETE_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGE.DELETE_SUCCESS', // Archivo de pago eliminado correctamente / Payment file deleted successfully
      GENERATE_SUCCESS: 'TREASURY.PAYMENT_FILES.MESSAGE.GENERATE_SUCCESS', // Se generó exitosamente el archivo de pago / The payment file was generated successfully
      DELETE_CONFIRM_TITLE: 'TREASURY.PAYMENT_FILES.MESSAGE.DELETE_CONFIRM_TITLE', // Confirmación de eliminación / Delete confirmation
      DELETE_CONFIRM_MESSAGE: 'TREASURY.PAYMENT_FILES.MESSAGE.DELETE_CONFIRM_MESSAGE', // ¿Está seguro de eliminar el archivo de pago {{fileName}}? / Are you sure you want to delete payment file {{fileName}}?
      DELETE_ERROR: 'TREASURY.PAYMENT_FILES.MESSAGE.DELETE_ERROR', // No se pudo eliminar el archivo de pago / The payment file could not be deleted
      CANCEL_CONFIRM_TITLE: 'TREASURY.PAYMENT_FILES.MESSAGE.CANCEL_CONFIRM_TITLE', // Confirmar Cancelación / Confirm Cancellation
      CANCEL_CONFIRM_MESSAGE: 'TREASURY.PAYMENT_FILES.MESSAGE.CANCEL_CONFIRM_MESSAGE', // Se va a cancelar la operación. Los datos ingresados no serán guardados. / The operation will be cancelled. The entered data will not be saved.
    },
  },

  TRANSFER_CANCELLATION: {},

  BANK_TRANSFER: {
    TITLE: {
      LIST: 'TREASURY.BANK_TRANSFER.TITLE.LIST', // Traslados Bancarios / Bank Transfers
      CREATE: 'TREASURY.BANK_TRANSFER.TITLE.CREATE', // Crear Traslado Bancario / Create Bank Transfer
      EDIT: 'TREASURY.BANK_TRANSFER.TITLE.EDIT', // Editar Traslado Bancario / Edit Bank Transfer
      VIEW: 'TREASURY.BANK_TRANSFER.TITLE.VIEW', // Ver Traslado Bancario / View Bank Transfer
      SUBTITLE: {
        LIST: 'TREASURY.BANK_TRANSFER.TITLE.SUBTITLE.LIST', // Gestión de traslados entre cuentas / Bank transfer management
        CREATE: 'TREASURY.BANK_TRANSFER.TITLE.SUBTITLE.CREATE', // Registre un nuevo traslado / Register a new transfer
        EDIT: 'TREASURY.BANK_TRANSFER.TITLE.SUBTITLE.EDIT', // Modifique el traslado / Modify the transfer
        VIEW: 'TREASURY.BANK_TRANSFER.TITLE.SUBTITLE.VIEW', // Consulte los detalles del traslado / View transfer details
      },
    },
    STATUS: {
      RECHAZADO: 'TREASURY.BANK_TRANSFER.STATUS.RECHAZADO', // Rechazado / Rejected
    },

    RESULTS_COUNTER: {
      SINGULAR: 'TREASURY.BANK_TRANSFER.RESULTS_COUNTER.SINGULAR', // traslado / transfer
      PLURAL: 'TREASURY.BANK_TRANSFER.RESULTS_COUNTER.PLURAL', // traslados / transfers
    },

    EMPTY: {
      MESSAGE: 'TREASURY.BANK_TRANSFER.EMPTY.MESSAGE', // No se encontraron traslados / No transfers found
      DESCRIPTION: 'TREASURY.BANK_TRANSFER.EMPTY.DESCRIPTION', // Intente ajustar los filtros de búsqueda / Try adjusting your search filters
    },

    PLACEHOLDER: {
      SEARCH: 'TREASURY.BANK_TRANSFER.PLACEHOLDER.SEARCH', // Buscar por consecutivo, banco, cuenta... / Search by consecutive, bank, account...
    },

    /** Panel lateral del formulario: resumen, lo que falta y la nota de uso. */
    PANEL: {
      SUMMARY: 'TREASURY.BANK_TRANSFER.PANEL.SUMMARY', // Resumen / Summary
      SUMMARY_TITLE_EMPTY: 'TREASURY.BANK_TRANSFER.PANEL.SUMMARY_TITLE_EMPTY', // Sin descripción / No description
      CHECKLIST: 'TREASURY.BANK_TRANSFER.PANEL.CHECKLIST', // Antes de guardar / Before saving
      USAGE: 'TREASURY.BANK_TRANSFER.PANEL.USAGE', // Cómo se usa / How to use
      USAGE_HINT: 'TREASURY.BANK_TRANSFER.PANEL.USAGE_HINT', // Elija con la lupa la cuenta de origen (crédito) y la de destino (débito)... / Use the magnifier to choose...
    },

    FORM: {
      FIELDS: {
        FECHA_TRASLADO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.FECHA_TRASLADO', // Fecha Traslado / Transfer Date
        VALOR_TRASLADO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.VALOR_TRASLADO', // Valor Traslado / Transfer Amount
        BANCO_CREDITO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.BANCO_CREDITO', // Código Banco / Bank Code
        CUENTA_CREDITO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.CUENTA_CREDITO', // Numero de Cuenta / Account Number
        BANCO_DEBITO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.BANCO_DEBITO', // Código Banco / Bank Code
        CUENTA_DEBITO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.CUENTA_DEBITO', // Numero de Cuenta / Account Number
        ELABORADO_POR: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.ELABORADO_POR', // Elaborado por / Prepared by
        APROBADO_POR: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.APROBADO_POR', // Aprobado por / Approved by
        ESTADO: 'COMMON.STATUS', // Estado / Status
        ESTADO_OPTIONS: {
          APROBADO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.ESTADO_OPTIONS.APROBADO', // Aprobado / Approved
          ANULADO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.ESTADO_OPTIONS.ANULADO', // Anulado / Cancelled
        },
        DESCRIPCION: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.DESCRIPCION', // Descripción / Description
        CONSECUTIVO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.CONSECUTIVO', // Consecutivo / Consecutive
        NOMBRE_CUENTA_CREDITO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.NOMBRE_CUENTA_CREDITO', // Nombre Cuenta Credito/ Credit Account Name
        NOMBRE_CUENTA_DEBITO: 'TREASURY.BANK_TRANSFER.FORM.FIELDS.NOMBRE_CUENTA_DEBITO', // Nombre Cuenta Debito / Debit Account Name
      },
      PLACEHOLDERS: {
        FECHA_TRASLADO: 'TREASURY.BANK_TRANSFER.FORM.PLACEHOLDERS.FECHA_TRASLADO', // Seleccione fecha / Select date
        VALOR_TRASLADO: 'TREASURY.BANK_TRANSFER.FORM.PLACEHOLDERS.VALOR_TRASLADO', // Ingrese el valor / Enter amount
        BANCO_CREDITO: 'TREASURY.BANK_TRANSFER.FORM.PLACEHOLDERS.BANCO_CREDITO', // Seleccione banco / Select bank
        CUENTA_CREDITO: 'TREASURY.BANK_TRANSFER.FORM.PLACEHOLDERS.CUENTA_CREDITO', // Seleccione cuenta / Select account
        BANCO_DEBITO: 'TREASURY.BANK_TRANSFER.FORM.PLACEHOLDERS.BANCO_DEBITO', // Seleccione banco / Select bank
        CUENTA_DEBITO: 'TREASURY.BANK_TRANSFER.FORM.PLACEHOLDERS.CUENTA_DEBITO', // Seleccione cuenta / Select account
        DESCRIPCION: 'TREASURY.BANK_TRANSFER.FORM.PLACEHOLDERS.DESCRIPCION', // Ingrese una descripción / Enter a description
      },
      TOOLTIPS: {
        CONSECUTIVO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.CONSECUTIVO', // Consecutivo generado automáticamente / Auto-generated consecutive
        FECHA_TRASLADO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.FECHA_TRASLADO', // Fecha en que se realiza el traslado / Date when the transfer is made
        VALOR_TRASLADO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.VALOR_TRASLADO', // Monto a trasladar entre cuentas / Amount to transfer between accounts
        DESCRIPCION: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.DESCRIPCION', // Justificación del traslado / Transfer justification
        BANCO_CREDITO_CODIGO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.BANCO_CREDITO_CODIGO', // Banco origen del traslado / Source bank of transfer
        CUENTA_CREDITO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.CUENTA_CREDITO', // Cuenta origen del traslado / Source account of transfer
        NOMBRE_CUENTA_CREDITO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.NOMBRE_CUENTA_CREDITO', // Nombre de la cuenta origen / Source account name
        BANCO_DEBITO_CODIGO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.BANCO_DEBITO_CODIGO', // Banco destino del traslado / Destination bank of transfer
        CUENTA_DEBITO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.CUENTA_DEBITO', // Cuenta destino del traslado / Destination account of transfer
        NOMBRE_CUENTA_DEBITO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.NOMBRE_CUENTA_DEBITO', // Nombre de la cuenta destino / Destination account name
        USUARIO_APRUEBA: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.USUARIO_APRUEBA', // Usuario que aprueba el traslado / User who approves the transfer
        USUARIO_ELABORA: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.USUARIO_ELABORA', // Usuario que elabora el traslado / User who prepares the transfer
        ESTADO: 'TREASURY.BANK_TRANSFER.FORM.TOOLTIPS.ESTADO', // Estado del traslado / Transfer status
      },
    },

    TAB: {
      TITLES: {
        GENERAL_INFO: 'TREASURY.BANK_TRANSFER.TAB.TITLES.GENERAL_INFO', // Información General / General Information
        BANKS: 'TREASURY.BANK_TRANSFER.TAB.TITLES.BANKS', // Bancos / Banks
        CREDIT_BANK: 'TREASURY.BANK_TRANSFER.TAB.TITLES.CREDIT_BANK', // Banco Crédito / Credit Bank
        DEBIT_BANK: 'TREASURY.BANK_TRANSFER.TAB.TITLES.DEBIT_BANK', // Banco Débito / Debit Bank
        APPROVAL: 'TREASURY.BANK_TRANSFER.TAB.TITLES.APPROVAL', // Aprobación / Approval
      },
      SUBTITLES: {
        GENERAL_INFO: 'TREASURY.BANK_TRANSFER.TAB.SUBTITLES.GENERAL_INFO', // Datos básicos del traslado / Basic transfer data
        BANKS: 'TREASURY.BANK_TRANSFER.TAB.SUBTITLES.BANKS', // Configuración de cuentas bancarias para el traslado / Bank account configuration for the transfer
        CREDIT_BANK: 'TREASURY.BANK_TRANSFER.TAB.SUBTITLES.CREDIT_BANK', // Cuenta origen del dinero / Source account of money
        DEBIT_BANK: 'TREASURY.BANK_TRANSFER.TAB.SUBTITLES.DEBIT_BANK', // Cuenta destino del dinero / Destination account of money
        APPROVAL: 'TREASURY.BANK_TRANSFER.TAB.SUBTITLES.APPROVAL', // Control y seguimiento / Control and tracking
      },
    },

    MODAL: {
      TITLE_CREDIT_BANK: 'TREASURY.BANK_TRANSFER.MODAL.TITLE_CREDIT_BANK', // Cuentas de Bancos / Bank Accounts
      TITLE_DEBIT_BANK: 'TREASURY.BANK_TRANSFER.MODAL.TITLE_DEBIT_BANK', // Cuentas de Bancos / Bank Accounts
      COL_BANK_CODE: 'TREASURY.BANK_TRANSFER.MODAL.COL_BANK_CODE', // Cod. Cuenta / Account Code
      COL_ACCOUNT_NUMBER: 'TREASURY.BANK_TRANSFER.MODAL.COL_ACCOUNT_NUMBER', // # de Cuenta / Account Number
      COL_ACCOUNT_NAME: 'TREASURY.BANK_TRANSFER.MODAL.COL_ACCOUNT_NAME', // Nombre Cuenta / Account Name
    },

    TABLE: {
      COLUMNS: {
        BANCO_CREDITO_CODIGO: 'TREASURY.BANK_TRANSFER.TABLE.COLUMNS.BANCO_CREDITO_CODIGO', // Cod. Banco Crédito / Credit Bank Code
        BANCO_DEBITO_CODIGO: 'TREASURY.BANK_TRANSFER.TABLE.COLUMNS.BANCO_DEBITO_CODIGO', // Cod. Banco Débito / Debit Bank Code
        VALOR_TRASLADO: 'TREASURY.BANK_TRANSFER.TABLE.COLUMNS.VALOR_TRASLADO', // Valor Traslado / Transfer Amount
        FECHA_TRASLADO: 'TREASURY.BANK_TRANSFER.TABLE.COLUMNS.FECHA_TRASLADO', // Fecha Traslado / Transfer Date
      },
    },

    EMPTY_STATES: {
      NO_DATA: {
        MESSAGE: 'TREASURY.BANK_TRANSFER.EMPTY_STATES.NO_DATA.MESSAGE', // No se encontraron traslados bancarios registrados en el mes actual / No bank transfers found for the current month
        DESCRIPTION: 'TREASURY.BANK_TRANSFER.EMPTY_STATES.NO_DATA.DESCRIPTION', // Cree un nuevo traslado para comenzar / Create a new transfer to start
      },
      NO_RESULTS: {
        MESSAGE: 'TREASURY.BANK_TRANSFER.EMPTY_STATES.NO_RESULTS.MESSAGE', // No se encontraron resultados / No results found
        DESCRIPTION: 'TREASURY.BANK_TRANSFER.EMPTY_STATES.NO_RESULTS.DESCRIPTION', // Intente con otros criterios de búsqueda / Try different search criteria
      },
    },

    ERRORS: {
      LOAD_APPROVERS: 'TREASURY.BANK_TRANSFER.ERRORS.LOAD_APPROVERS', // Error al cargar usuarios aprobadores / Error loading approving users
      SAME_ACCOUNT: 'TREASURY.BANK_TRANSFER.ERRORS.SAME_ACCOUNT', // Operación inválida: La cuenta destino debe ser diferente a la cuenta origen / Invalid operation: Destination account must be different from source account
      SELECT_ACCOUNTS: 'TREASURY.BANK_TRANSFER.ERRORS.SELECT_ACCOUNTS', // Debe seleccionar las cuentas bancarias de crédito y débito / You must select both credit and debit bank accounts
      NO_ACCOUNTING_CODE_CREDIT: 'TREASURY.BANK_TRANSFER.ERRORS.NO_ACCOUNTING_CODE_CREDIT', // No se puede contabilizar: la cuenta bancaria {0} no tiene una cuenta contable asociada. Verifique la parametrización / Cannot post: bank account {0} does not have an associated accounting account. Check configuration
      NO_ACCOUNTING_CODE_DEBIT: 'TREASURY.BANK_TRANSFER.ERRORS.NO_ACCOUNTING_CODE_DEBIT', // No se puede contabilizar: la cuenta bancaria {0} no tiene una cuenta contable asociada. Verifique la parametrización / Cannot post: bank account {0} does not have an associated accounting account. Check configuration
      INSUFFICIENT_BALANCE: 'TREASURY.BANK_TRANSFER.ERRORS.INSUFFICIENT_BALANCE', // Operación rechazada: La cuenta origen no permite sobregiros y el saldo actual es insuficiente / Operation rejected: Source account does not allow overdrafts and current balance is insufficient
      INVALID_SEARCH_TERM: 'TREASURY.BANK_TRANSFER.ERRORS.INVALID_SEARCH_TERM', // Por favor, ingrese un término de búsqueda válido / Please enter a valid search term
      LOAD_ERROR: 'TREASURY.BANK_TRANSFER.ERRORS.LOAD_ERROR', // Error al cargar los traslados bancarios / Error loading bank transfers
    },

    VALIDATIONS: {
      FUTURE_DATE: 'TREASURY.BANK_TRANSFER.VALIDATIONS.FUTURE_DATE', // No se permiten traslados con fecha futura / Transfers with future dates are not allowed
      DATE_BEFORE_CLOSURE: 'TREASURY.BANK_TRANSFER.VALIDATIONS.DATE_BEFORE_CLOSURE', // La fecha de traslado no puede ser menor o igual a la fecha de cierre de banco / Transfer date cannot be less than or equal to bank closure date
      AMOUNT_ZERO: 'TREASURY.BANK_TRANSFER.VALIDATIONS.AMOUNT_ZERO', // El valor del traslado debe ser mayor a cero / Transfer amount must be greater than zero
      AMOUNT_MAX_LENGTH: 'TREASURY.BANK_TRANSFER.VALIDATIONS.AMOUNT_MAX_LENGTH', // El valor excede la longitud permitida (máximo 15 dígitos enteros) / Value exceeds allowed length (maximum 15 integer digits)
      AMOUNT_MAX_DECIMALS: 'TREASURY.BANK_TRANSFER.VALIDATIONS.AMOUNT_MAX_DECIMALS', // El valor debe tener máximo 2 decimales / Value must have maximum 2 decimals
      MAX_LENGTH: 'TREASURY.BANK_TRANSFER.VALIDATIONS.MAX_LENGTH', // Máximo {0} caracteres / Maximum {0} characters
      CREATED: 'TREASURY.BANK_TRANSFER.VALIDATIONS.CREATED', // Traslado bancario creado exitosamente / Bank transfer successfully created
    },
  },
  /**
   * Embargos (`HT_TES_002`).
   *
   * La pantalla no conserva NINGUNA cadena de texto en el codigo: titulos, cabeceras, filtro,
   * formulario, modal de levantamiento, confirmaciones y mensajes de resultado y de error salen
   * todos de aqui.
   */
  EMBARGO: {
    // El buscador de terceros del embargo: sus columnas se pintaban en español fijo.
    THIRD_PARTY: {
      COLUMN: {
        IDENTIFICATION: 'TREASURY.EMBARGO.THIRD_PARTY.COLUMN.IDENTIFICATION',
        NAME: 'TREASURY.EMBARGO.THIRD_PARTY.COLUMN.NAME',
      },
    },
    TITLE: {
      // Embargos
      LIST: 'TREASURY.EMBARGO.TITLE.LIST',
      // Registrar Embargo
      CREATE: 'TREASURY.EMBARGO.TITLE.CREATE',
      // Editar Embargo
      EDIT: 'TREASURY.EMBARGO.TITLE.EDIT',
      // Consultar Embargo
      VIEW: 'TREASURY.EMBARGO.TITLE.VIEW',
    },
    SUBTITLE: {
      // Maestro de embargos de Tesorería
      LIST: 'TREASURY.EMBARGO.SUBTITLE.LIST',
      // Complete los datos del nuevo embargo
      CREATE: 'TREASURY.EMBARGO.SUBTITLE.CREATE',
      // Solo cuenta contable y estado son editables
      EDIT: 'TREASURY.EMBARGO.SUBTITLE.EDIT',
      // Detalle del embargo
      VIEW: 'TREASURY.EMBARGO.SUBTITLE.VIEW',
    },
    COLUMNS: {
      // Consecutivo
      CONSECUTIVE: 'TREASURY.EMBARGO.COLUMNS.CONSECUTIVE',
      // Tipo
      TYPE: 'TREASURY.EMBARGO.COLUMNS.TYPE',
      // Orden judicial
      JUDICIAL_ORDER: 'TREASURY.EMBARGO.COLUMNS.JUDICIAL_ORDER',
      // Deudor
      DEBTOR: 'TREASURY.EMBARGO.COLUMNS.DEBTOR',
      // Acreedor
      CREDITOR: 'TREASURY.EMBARGO.COLUMNS.CREDITOR',
      // Saldo
      BALANCE: 'TREASURY.EMBARGO.COLUMNS.BALANCE',
      // Estado
      STATUS: 'TREASURY.EMBARGO.COLUMNS.STATUS',
    },
    // Buscar por deudor, acreedor u orden judicial
    SEARCH_PLACEHOLDER: 'TREASURY.EMBARGO.SEARCH_PLACEHOLDER',
    COUNTER: {
      // embargo
      SINGULAR: 'TREASURY.EMBARGO.COUNTER.SINGULAR',
      // embargos
      PLURAL: 'TREASURY.EMBARGO.COUNTER.PLURAL',
    },
    EMPTY: {
      // No se encontraron embargos
      MESSAGE: 'TREASURY.EMBARGO.EMPTY.MESSAGE',
      // Intenta con otro término o registra un nuevo embargo.
      DESCRIPTION: 'TREASURY.EMBARGO.EMPTY.DESCRIPTION',
    },
    FILTER: {
      // Todos los estados
      ALL_STATUS: 'TREASURY.EMBARGO.FILTER.ALL_STATUS',
    },
    TYPE: {
      // Pensión alimenticia
      PENSION: 'TREASURY.EMBARGO.TYPE.PENSION',
      // Obligaciones fiscales
      TAX: 'TREASURY.EMBARGO.TYPE.TAX',
      // Civiles / bancarios
      CIVIL: 'TREASURY.EMBARGO.TYPE.CIVIL',
    },
    ORDERED_BY: {
      // Por porcentaje
      PERCENTAGE: 'TREASURY.EMBARGO.ORDERED_BY.PERCENTAGE',
      // Por valor fijo
      FIXED: 'TREASURY.EMBARGO.ORDERED_BY.FIXED',
    },
    STATUS: {
      // Activo
      ACTIVE: 'TREASURY.EMBARGO.STATUS.ACTIVE',
      // Inactivo
      INACTIVE: 'TREASURY.EMBARGO.STATUS.INACTIVE',
      // Levantado
      LIFTED: 'TREASURY.EMBARGO.STATUS.LIFTED',
    },
    ACTION: {
      // Levantar
      LIFT: 'TREASURY.EMBARGO.ACTION.LIFT',
    },
    FORM: {
      TYPE: {
        // Tipo de embargo
        LABEL: 'TREASURY.EMBARGO.FORM.TYPE.LABEL',
        // Define condicionalidad y orden
        TOOLTIP: 'TREASURY.EMBARGO.FORM.TYPE.TOOLTIP',
      },
      JUDICIAL_ORDER: {
        // Orden judicial
        LABEL: 'TREASURY.EMBARGO.FORM.JUDICIAL_ORDER.LABEL',
        // Número de la orden
        TOOLTIP: 'TREASURY.EMBARGO.FORM.JUDICIAL_ORDER.TOOLTIP',
        // Máximo 30 caracteres
        PLACEHOLDER: 'TREASURY.EMBARGO.FORM.JUDICIAL_ORDER.PLACEHOLDER',
      },
      DEBTOR: {
        // Deudor
        LABEL: 'TREASURY.EMBARGO.FORM.DEBTOR.LABEL',
        // Tercero deudor (activo)
        TOOLTIP: 'TREASURY.EMBARGO.FORM.DEBTOR.TOOLTIP',
        // Seleccione el deudor
        PLACEHOLDER: 'TREASURY.EMBARGO.FORM.DEBTOR.PLACEHOLDER',
      },
      CREDITOR: {
        // Acreedor
        LABEL: 'TREASURY.EMBARGO.FORM.CREDITOR.LABEL',
        // Tercero acreedor (activo)
        TOOLTIP: 'TREASURY.EMBARGO.FORM.CREDITOR.TOOLTIP',
        // Seleccione el acreedor
        PLACEHOLDER: 'TREASURY.EMBARGO.FORM.CREDITOR.PLACEHOLDER',
      },
      MAJORITY_DATE: {
        // Mayoría de edad
        LABEL: 'TREASURY.EMBARGO.FORM.MAJORITY_DATE.LABEL',
        // Solo pensión alimenticia
        TOOLTIP: 'TREASURY.EMBARGO.FORM.MAJORITY_DATE.TOOLTIP',
      },
      START_DATE: {
        // Fecha de inicio
        LABEL: 'TREASURY.EMBARGO.FORM.START_DATE.LABEL',
        // Inicio del embargo
        TOOLTIP: 'TREASURY.EMBARGO.FORM.START_DATE.TOOLTIP',
      },
      AMOUNT: {
        // Valor embargo
        LABEL: 'TREASURY.EMBARGO.FORM.AMOUNT.LABEL',
        // Valor total a embargar (no pensión)
        TOOLTIP: 'TREASURY.EMBARGO.FORM.AMOUNT.TOOLTIP',
      },
      ORDERED_BY: {
        // Ordenado por
        LABEL: 'TREASURY.EMBARGO.FORM.ORDERED_BY.LABEL',
        // Forma de descuento
        TOOLTIP: 'TREASURY.EMBARGO.FORM.ORDERED_BY.TOOLTIP',
      },
      PERCENTAGE: {
        // Porcentaje (%)
        LABEL: 'TREASURY.EMBARGO.FORM.PERCENTAGE.LABEL',
        // > 0 y ≤ 100
        TOOLTIP: 'TREASURY.EMBARGO.FORM.PERCENTAGE.TOOLTIP',
      },
      FIXED_AMOUNT: {
        // Valor fijo
        LABEL: 'TREASURY.EMBARGO.FORM.FIXED_AMOUNT.LABEL',
        // > 0 y ≤ valor embargo
        TOOLTIP: 'TREASURY.EMBARGO.FORM.FIXED_AMOUNT.TOOLTIP',
      },
      ACCOUNT: {
        // Cuenta contable
        LABEL: 'TREASURY.EMBARGO.FORM.ACCOUNT.LABEL',
        // Cuenta de movimiento
        TOOLTIP: 'TREASURY.EMBARGO.FORM.ACCOUNT.TOOLTIP',
        // Seleccione la cuenta
        PLACEHOLDER: 'TREASURY.EMBARGO.FORM.ACCOUNT.PLACEHOLDER',
      },
      STATUS: {
        // Estado
        LABEL: 'TREASURY.EMBARGO.FORM.STATUS.LABEL',
        // Activo o Inactivo
        TOOLTIP: 'TREASURY.EMBARGO.FORM.STATUS.TOOLTIP',
      },
      BALANCE: {
        // Saldo embargo
        LABEL: 'TREASURY.EMBARGO.FORM.BALANCE.LABEL',
        // Calculado (pendiente módulo egresos)
        TOOLTIP: 'TREASURY.EMBARGO.FORM.BALANCE.TOOLTIP',
      },
      LIFT_ORDER: {
        // Orden judicial levantamiento
        LABEL: 'TREASURY.EMBARGO.FORM.LIFT_ORDER.LABEL',
      },
      LIFT_DATE: {
        // Fecha levantamiento
        LABEL: 'TREASURY.EMBARGO.FORM.LIFT_DATE.LABEL',
      },
      // dd/MM/yyyy
      DATE_PLACEHOLDER: 'TREASURY.EMBARGO.FORM.DATE_PLACEHOLDER',
      // Cuenta #{{id}}
      ACCOUNT_FALLBACK: 'TREASURY.EMBARGO.FORM.ACCOUNT_FALLBACK',
      /** Secciones del formulario en el motor. */
      SECTION: {
        // Datos del embargo / Garnishment data
        DATA: 'TREASURY.EMBARGO.FORM.SECTION.DATA',
        // Saldo y levantamiento / Balance and release
        BALANCE: 'TREASURY.EMBARGO.FORM.SECTION.BALANCE',
      },
    },
    /** Panel lateral del formulario: resumen, lo que falta y la nota de uso. */
    PANEL: {
      SUMMARY: 'TREASURY.EMBARGO.PANEL.SUMMARY', // Resumen / Summary
      SUMMARY_TITLE_EMPTY: 'TREASURY.EMBARGO.PANEL.SUMMARY_TITLE_EMPTY', // Sin orden judicial / No court order
      CHECKLIST: 'TREASURY.EMBARGO.PANEL.CHECKLIST', // Antes de guardar / Before saving
      USAGE: 'TREASURY.EMBARGO.PANEL.USAGE', // Cómo se usa / How to use
      USAGE_HINT: 'TREASURY.EMBARGO.PANEL.USAGE_HINT', // Al editar solo cambian la cuenta contable y el estado... / When editing, only...
    },
    LIFT: {
      // Levantar embargo
      TITLE: 'TREASURY.EMBARGO.LIFT.TITLE',
      // Orden judicial de levantamiento
      ORDER_LABEL: 'TREASURY.EMBARGO.LIFT.ORDER_LABEL',
      // Fecha de levantamiento
      DATE_LABEL: 'TREASURY.EMBARGO.LIFT.DATE_LABEL',
      // Levantar
      CONFIRM: 'TREASURY.EMBARGO.LIFT.CONFIRM',
    },
    MODAL: {
      // Seleccionar Deudor
      DEBTOR: 'TREASURY.EMBARGO.MODAL.DEBTOR',
      // Seleccionar Acreedor
      CREDITOR: 'TREASURY.EMBARGO.MODAL.CREDITOR',
      // Seleccionar Cuenta Contable
      ACCOUNT: 'TREASURY.EMBARGO.MODAL.ACCOUNT',
    },
    WARN: {
      // Este embargo no es editable en su estado actual
      NOT_EDITABLE: 'TREASURY.EMBARGO.WARN.NOT_EDITABLE',
      // Solo se puede levantar un embargo Activo o Inactivo
      NOT_LIFTABLE: 'TREASURY.EMBARGO.WARN.NOT_LIFTABLE',
      // Solo se puede eliminar un embargo Inactivo y sin egresos asociados
      NOT_DELETABLE: 'TREASURY.EMBARGO.WARN.NOT_DELETABLE',
    },
    RESULT: {
      // Embargo registrado exitosamente
      CREATED: 'TREASURY.EMBARGO.RESULT.CREATED',
      // Embargo actualizado exitosamente
      UPDATED: 'TREASURY.EMBARGO.RESULT.UPDATED',
      // Embargo levantado exitosamente
      LIFTED: 'TREASURY.EMBARGO.RESULT.LIFTED',
    },
    ERROR: {
      // Error al registrar el embargo
      CREATE: 'TREASURY.EMBARGO.ERROR.CREATE',
      // Error al actualizar el embargo
      UPDATE: 'TREASURY.EMBARGO.ERROR.UPDATE',
      // Error al levantar el embargo
      LIFT: 'TREASURY.EMBARGO.ERROR.LIFT',
    },
    VALIDATION: {
      // Campo requerido
      REQUIRED: 'TREASURY.EMBARGO.VALIDATION.REQUIRED',
      // Máximo {{max}} caracteres
      MAX_LENGTH: 'TREASURY.EMBARGO.VALIDATION.MAX_LENGTH',
    },
  },
  BANK_TRANSFER_ANNULMENT: {
    TITLE: {
      LIST: 'TREASURY.BANK_TRANSFER_ANNULMENT.TITLE.LIST', // Anulación de Transferencias Bancarias / Bank Transfer Annulment
      VIEW: 'TREASURY.BANK_TRANSFER_ANNULMENT.TITLE.VIEW', // Consultar Transferencia / View Transfer
    },
    SUBTITLE: {
      LIST: 'TREASURY.BANK_TRANSFER_ANNULMENT.SUBTITLE.LIST', // Seleccione y anule transferencias bancarias aprobadas / Select and annul approved bank transfers
      VIEW: 'TREASURY.BANK_TRANSFER_ANNULMENT.SUBTITLE.VIEW', // Consulte los detalles de la transferencia / View transfer details
    },
    COUNTER: {
      SINGULAR: 'TREASURY.BANK_TRANSFER_ANNULMENT.COUNTER.SINGULAR', // transferencia
      PLURAL: 'TREASURY.BANK_TRANSFER_ANNULMENT.COUNTER.PLURAL', // transferencias
    },
    ACTIONS: {
      CONFIRM_ANNUL: 'TREASURY.BANK_TRANSFER_ANNULMENT.ACTIONS.CONFIRM_ANNUL', // Confirmar Anulación / Confirm Annulment
    },
    MODAL: {
      TITLE: 'TREASURY.BANK_TRANSFER_ANNULMENT.MODAL.TITLE', // Motivo de Anulación / Annulment Reason
      DESCRIPTION: 'TREASURY.BANK_TRANSFER_ANNULMENT.MODAL.DESCRIPTION', // Por favor, indique el motivo de la anulación / Please indicate the reason for the annulment
    },
    FORM: {
      MOTIVO_ANULACION: 'TREASURY.BANK_TRANSFER_ANNULMENT.FORM.MOTIVO_ANULACION', // Motivo de Anulación / Annulment Reason
      MOTIVO_PLACEHOLDER: 'TREASURY.BANK_TRANSFER_ANNULMENT.FORM.MOTIVO_PLACEHOLDER', // Describa el motivo de la anulación... / Describe the reason for annulment...
    },
    EMPTY: {
      NO_DATA: {
        MESSAGE: 'TREASURY.BANK_TRANSFER_ANNULMENT.EMPTY.NO_DATA.MESSAGE', // No se encontraron transferencias bancarias registradas en el mes actual / No bank transfers found in current month
        DESCRIPTION: 'TREASURY.BANK_TRANSFER_ANNULMENT.EMPTY.NO_DATA.DESCRIPTION', // Solo se muestran transferencias en estado APROBADO / Only APPROVED transfers are shown
      },
      NO_RESULTS: {
        MESSAGE: 'TREASURY.BANK_TRANSFER_ANNULMENT.EMPTY.NO_RESULTS.MESSAGE', // No se encontraron resultados / No results found
        DESCRIPTION: 'TREASURY.BANK_TRANSFER_ANNULMENT.EMPTY.NO_RESULTS.DESCRIPTION', // Intente con otros criterios de búsqueda / Try different search criteria
      },
    },
    MESSAGES: {
      SUCCESS: {
        ANNULLED: 'TREASURY.BANK_TRANSFER_ANNULMENT.MESSAGES.SUCCESS.ANNULLED', // Transferencias anuladas exitosamente / Transfers annulled successfully
      },
      ERROR: {
        ANNUL_FAILED: 'TREASURY.BANK_TRANSFER_ANNULMENT.MESSAGES.ERROR.ANNUL_FAILED', // Error al anular las transferencias / Error annulling transfers
        LOAD_DETAIL_FAILED: 'TREASURY.BANK_TRANSFER_ANNULMENT.MESSAGES.ERROR.LOAD_DETAIL_FAILED', // Error al cargar el detalle de la transferencia / Error loading transfer detail
      },
    },
    DETAIL: {
      FIELDS: {
        DESCRIPCION: 'TREASURY.BANK_TRANSFER_ANNULMENT.DETAIL.FIELDS.DESCRIPCION', // Descripción / Description
        ELABORADO_POR: 'TREASURY.BANK_TRANSFER_ANNULMENT.DETAIL.FIELDS.ELABORADO_POR', // Elaborado por / Created by
        APROBADO_POR: 'TREASURY.BANK_TRANSFER_ANNULMENT.DETAIL.FIELDS.APROBADO_POR', // Aprobado por / Approved by
      },
    },
  },

  BANK_CLOSURES: {
    TITLE: 'TREASURY.BANK_CLOSURES.TITLE',
    SUBTITLE: 'TREASURY.BANK_CLOSURES.SUBTITLE',

    /** Historial de cierres: prefijo del CRUD (buscador, contador, vacio) y sus columnas. */
    TABLE: {
      PREFIX: 'TREASURY.BANK_CLOSURES.TABLE',
      COLUMNS: {
        FECHA_CIERRE: 'TREASURY.BANK_CLOSURES.TABLE.COLUMNS.FECHA_CIERRE',
        ESTADO_CIERRE: 'TREASURY.BANK_CLOSURES.TABLE.COLUMNS.ESTADO_CIERRE',
        CUENTAS_PROCESADAS: 'TREASURY.BANK_CLOSURES.TABLE.COLUMNS.CUENTAS_PROCESADAS',
        EJECUTADO_POR: 'TREASURY.BANK_CLOSURES.TABLE.COLUMNS.EJECUTADO_POR',
        FECHA_HORA: 'billing.cierreFacturacion.historial.columna.fechaHora',
      },
    },

    /** Estado del cierre: las claves del enum del servidor. */
    ESTADO: {
      EJECUTADO: 'treasury.cierre_bancario.estado.ejecutado',
      ABORTADO: 'treasury.cierre_bancario.estado.abortado',
      REVERTIDO: 'treasury.cierre_bancario.estado.revertido',
    } as Record<string, string>,

    SECTION: {
      PERIOD: 'TREASURY.BANK_CLOSURES.SECTION.PERIOD',
      BALANCES: 'TREASURY.BANK_CLOSURES.SECTION.BALANCES',
      CLOSE: 'TREASURY.BANK_CLOSURES.SECTION.CLOSE',
      REVERSAL: 'INVOICING.BILLING_CLOSURE.SECTION.REVERSION',
    },

    /** Linea del periodo: ultimo cierre, desde y hasta. */
    PERIOD_LINE: {
      LAST_CLOSE: 'TREASURY.BANK_CLOSURES.CONTEXT.LAST_CLOSE_DATE',
      FROM: 'COMMON.DATE_RANGE.FROM',
      TO: 'COMMON.DATE_RANGE.TO',
    },

    /** Avisos de validacion antes de cerrar. */
    CHECK: {
      ACCOUNTS_TITLE: 'TREASURY.BANK_CLOSURES.CHECK.ACCOUNTS_TITLE',
      ACCOUNTS_DETAIL: 'TREASURY.BANK_CLOSURES.CHECK.ACCOUNTS_DETAIL',
      MOVEMENTS_TITLE: 'TREASURY.BANK_CLOSURES.CHECK.MOVEMENTS_TITLE',
      MOVEMENTS_TITLE_ONE: 'TREASURY.BANK_CLOSURES.CHECK.MOVEMENTS_TITLE_ONE',
      NO_MOVEMENTS_TITLE: 'TREASURY.BANK_CLOSURES.CHECK.NO_MOVEMENTS_TITLE',
      MOVEMENTS_DETAIL: 'TREASURY.BANK_CLOSURES.CHECK.MOVEMENTS_DETAIL',
      CONTINUOUS_TITLE: 'TREASURY.BANK_CLOSURES.CHECK.CONTINUOUS_TITLE',
      CONTINUOUS_DETAIL: 'TREASURY.BANK_CLOSURES.CHECK.CONTINUOUS_DETAIL',
    },

    /** Totales del periodo (indicadores). */
    TOTALS: {
      PREVIOUS: 'TREASURY.BANK_CLOSURES.TOTALS.PREVIOUS',
      INCOME: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.INCOME.LABEL',
      EXPENSES: 'TREASURY.PARAMETERS.FIELDS.CONCEPTS.EXPENSE.LABEL',
      CLOSING: 'TREASURY.BANK_CLOSURES.TOTALS.CLOSING',
    },

    /**
     * Reversion del ultimo cierre (decision de Carlos del 14-oct-2026): el mismo proceso
     * extraordinario del Cierre de Facturacion, con sus textos; la advertencia es la propia.
     */
    REVERSION: {
      ACTION: 'INVOICING.BILLING_CLOSURE.ACTIONS.REVERT',
      TITLE: 'INVOICING.BILLING_CLOSURE.REVERSION.TITLE',
      SUBTITLE: 'INVOICING.BILLING_CLOSURE.REVERSION.SUBTITLE',
      WARNING: 'TREASURY.BANK_CLOSURES.REVERSION.WARNING',
      REQUEST_CODE: 'INVOICING.BILLING_CLOSURE.REVERSION.REQUEST_CODE',
      REQUEST_CODE_HINT: 'INVOICING.BILLING_CLOSURE.REVERSION.REQUEST_CODE_HINT',
      RESEND_CODE: 'INVOICING.BILLING_CLOSURE.REVERSION.RESEND_CODE',
      CODE_SENT: 'INVOICING.BILLING_CLOSURE.REVERSION.CODE_SENT',
      CODE: 'INVOICING.BILLING_CLOSURE.REVERSION.CODE',
      CONFIRMATION: 'INVOICING.BILLING_CLOSURE.CONFIRM.CONFIRMATION',
      REASON: 'billing.cierreFacturacion.historial.columna.motivo',
      REFERENCE: 'billing.cierreFacturacion.historial.columna.referencia',
      ERROR: {
        MOTIVO: 'billing.validation.cierreFacturacion.motivo.range',
        REFERENCIA: 'billing.validation.cierreFacturacion.referencia.max',
        CONFIRMACION: 'treasury.cierreBancario.error.escribaRevertir',
        TOKEN: 'billing.validation.cierreFacturacion.token.formato',
      },
    },

    /** Consulta del cierre: la foto de una ejecucion del historial. */
    VIEW: {
      PREVIOUS_CLOSE: 'TREASURY.BANK_CLOSURES.VIEW.PREVIOUS_CLOSE',
      CONSOLIDATED_DAYS: 'TREASURY.BANK_CLOSURES.VIEW.CONSOLIDATED_DAYS',
      RESULT: 'LAYOUT.TASK_CENTER.ORDER.RESULT',
      NEGATIVE_ACCOUNTS: 'TREASURY.BANK_CLOSURES.VIEW.NEGATIVE_ACCOUNTS',
      REASON: 'billing.cierreFacturacion.historial.columna.motivo',
      REFERENCE: 'billing.cierreFacturacion.historial.columna.referencia',
      REVERTED_BY: 'TREASURY.BANK_CLOSURES.VIEW.REVERTED_BY',
      REVERTED_AT: 'TREASURY.BANK_CLOSURES.VIEW.REVERTED_AT',
    },

    CONTEXT: {
      ARIA_LABEL: 'TREASURY.BANK_CLOSURES.CONTEXT.ARIA_LABEL',
      VIGENCIA: 'TREASURY.BANK_CLOSURES.CONTEXT.VIGENCIA',
      SYSTEM_DATE: 'TREASURY.BANK_CLOSURES.CONTEXT.SYSTEM_DATE',
      LAST_CLOSE_DATE: 'TREASURY.BANK_CLOSURES.CONTEXT.LAST_CLOSE_DATE',
      NOT_DEFINED: 'TREASURY.BANK_CLOSURES.CONTEXT.NOT_DEFINED',
    },

    FORM: {
      CLOSE_DATE_LABEL: 'TREASURY.BANK_CLOSURES.FORM.CLOSE_DATE_LABEL',
      CLOSE_DATE_TOOLTIP: 'TREASURY.BANK_CLOSURES.FORM.CLOSE_DATE_TOOLTIP',
      CLOSE_DATE_PLACEHOLDER: 'TREASURY.BANK_CLOSURES.FORM.CLOSE_DATE_PLACEHOLDER',
    },

    /** Ayuda (i) de cada campo (R3-14, orden de Carlos del 14-oct-2026). */
    TOOLTIP: {
      FECHA_CIERRE: 'TREASURY.BANK_CLOSURES.TOOLTIP.FECHA_CIERRE',
      ESTADO: 'TREASURY.BANK_CLOSURES.TOOLTIP.ESTADO',
      VIGENCIA: 'TREASURY.BANK_CLOSURES.TOOLTIP.VIGENCIA',
      CIERRE_ANTERIOR: 'TREASURY.BANK_CLOSURES.TOOLTIP.CIERRE_ANTERIOR',
      DIAS_CONSOLIDADOS: 'TREASURY.BANK_CLOSURES.TOOLTIP.DIAS_CONSOLIDADOS',
      CUENTAS_PROCESADAS: 'TREASURY.BANK_CLOSURES.TOOLTIP.CUENTAS_PROCESADAS',
      EJECUTADO_POR: 'TREASURY.BANK_CLOSURES.TOOLTIP.EJECUTADO_POR',
      FECHA_HORA: 'TREASURY.BANK_CLOSURES.TOOLTIP.FECHA_HORA',
      RESULTADO: 'TREASURY.BANK_CLOSURES.TOOLTIP.RESULTADO',
      CUENTAS_NEGATIVAS: 'TREASURY.BANK_CLOSURES.TOOLTIP.CUENTAS_NEGATIVAS',
      REVERTIDO_POR: 'TREASURY.BANK_CLOSURES.TOOLTIP.REVERTIDO_POR',
      FECHA_REVERSION: 'TREASURY.BANK_CLOSURES.TOOLTIP.FECHA_REVERSION',
      REFERENCIA: 'TREASURY.BANK_CLOSURES.TOOLTIP.REFERENCIA',
      MOTIVO: 'TREASURY.BANK_CLOSURES.TOOLTIP.MOTIVO',
    },

    ACTION: {
      CANCEL: 'TREASURY.BANK_CLOSURES.ACTION.CANCEL',
      CLOSE: 'TREASURY.BANK_CLOSURES.ACTION.CLOSE',
      BALANCE_QUERY: 'TREASURY.BANK_CLOSURES.ACTION.BALANCE_QUERY',
      CLOSE_QUERY: 'TREASURY.BANK_CLOSURES.ACTION.CLOSE_QUERY',
      EXPORT: 'ACTIONS.EXPORT',
    },

    STATUS: {
      LABEL: 'COMMON.STATUS',
      NO_DATE: 'TREASURY.BANK_CLOSURES.STATUS.NO_DATE',
      PENDING: 'COMMON.PENDING',
      CLOSED: 'COMMON.CLOSED',
    },

    MESSAGE: {
      CANCELLED: 'TREASURY.BANK_CLOSURES.MESSAGE.CANCELLED',
      QUERY_CLOSED: 'TREASURY.BANK_CLOSURES.MESSAGE.QUERY_CLOSED',
      NO_DATA: 'TREASURY.BANK_CLOSURES.MESSAGE.NO_DATA',
    },

    QUERY: {
      TITLE: 'TREASURY.BANK_CLOSURES.QUERY.TITLE',
      PERIOD: 'TREASURY.BANK_CLOSURES.QUERY.PERIOD',
      PERIOD_NO_CLOSE: 'TREASURY.BANK_CLOSURES.QUERY.PERIOD_NO_CLOSE',
      TOTAL: 'TREASURY.BANK_CLOSURES.QUERY.TOTAL',
      SEARCH_PLACEHOLDER: 'TREASURY.BANK_CLOSURES.QUERY.SEARCH_PLACEHOLDER',
      COUNTER: {
        SINGULAR: 'ACCOUNTING.BANK_RECONCILIATION.COUNTER.SINGULAR',
        PLURAL: 'ACCOUNTING.BANK_RECONCILIATION.COUNTER.PLURAL',
      },
      RECALCULATE: 'ACCOUNTING.BALANCES.MAINTENANCE.RECALCULATE',
      COLUMNS: {
        ACCOUNT: 'TREASURY.INCOME.DEDUCTIONS.TABLE.COLUMNS.CUENTA',
        SOURCE: 'COLUMNS.SOURCE',
        CODE: 'TREASURY.BANK_CLOSURES.QUERY.COLUMNS.CODE',
        NAME: 'TREASURY.BANK_CLOSURES.QUERY.COLUMNS.NAME',
        BANK: 'TREASURY.BANK_ACCOUNTS.COLUMN.BANK',
        FUNDING_SOURCE: 'TREASURY.BANK_ACCOUNTS.LABEL.FUNDING_SOURCE',
        LAST_CLOSE_DATE: 'TREASURY.BANK_CLOSURES.QUERY.COLUMNS.LAST_CLOSE_DATE',
        LAST_CLOSE_BALANCE: 'TREASURY.BANK_CLOSURES.QUERY.COLUMNS.LAST_CLOSE_BALANCE',
        PENDING_INCOME: 'TREASURY.BANK_CLOSURES.QUERY.COLUMNS.PENDING_INCOME',
        PENDING_EXPENSES: 'TREASURY.BANK_CLOSURES.QUERY.COLUMNS.PENDING_EXPENSES',
        BALANCE: 'TREASURY.BANK_PAYMENTS.LABEL.BALANCE',
      },
    },

    DIALOG: {
      CANCEL_CONFIRM: {
        TITLE: 'TREASURY.BANK_CLOSURES.DIALOG.CANCEL.TITLE',
        MESSAGE: 'TREASURY.BANK_CLOSURES.DIALOG.CANCEL.MESSAGE',
      },
      CLOSE: {
        TITLE: 'TREASURY.BANK_CLOSURES.DIALOG.CLOSE.TITLE',
        MESSAGE: 'TREASURY.BANK_CLOSURES.DIALOG.CLOSE.MESSAGE',
        PARALLEL_NOTICE: 'El proceso de cierre se ejecutará en segundo plano.',
      },
      IN_PROGRESS: {
        TITLE: 'TREASURY.BANK_CLOSURES.DIALOG.IN_PROGRESS.TITLE',
        MESSAGE: 'TREASURY.BANK_CLOSURES.DIALOG.IN_PROGRESS.MESSAGE',
      },
      CONFIRM: 'TREASURY.BANK_CLOSURES.DIALOG.CONFIRM',
      CANCEL: 'TREASURY.BANK_CLOSURES.DIALOG.CANCEL_BUTTON',
    },

    ERROR: {
      CONTEXT_LOAD: 'TREASURY.BANK_CLOSURES.ERROR.CONTEXT_LOAD',
      EXECUTE_CLOSE: 'TREASURY.BANK_CLOSURES.ERROR.EXECUTE_CLOSE',
    },

    VALIDATION: {
      DATE_BEFORE_SYSTEM: 'TREASURY.BANK_CLOSURES.VALIDATION.DATE_BEFORE_SYSTEM',
      PERIOD_ALREADY_CLOSED: 'TREASURY.BANK_CLOSURES.VALIDATION.ALREADY_CLOSED',
      AFTER_LAST_CLOSE: 'TREASURY.BANK_CLOSURES.VALIDATION.AFTER_LAST_CLOSE',
      NOT_AFTER_SYSTEM: 'TREASURY.BANK_CLOSURES.VALIDATION.NOT_AFTER_SYSTEM',
      NO_PERMISSION: 'TREASURY.BANK_CLOSURES.VALIDATION.NO_PERMISSION',
    },
  },
  PAYMENT_FILE_STRUCTURE: {
    COUNTER: {
      PLURAL: 'TREASURY.PAYMENT_FILE_STRUCTURE.COUNTER.PLURAL',
      SINGULAR: 'TREASURY.PAYMENT_FILE_STRUCTURE.COUNTER.SINGULAR',
    },
    EMPTY: {
      MESSAGE: 'TREASURY.PAYMENT_FILE_STRUCTURE.EMPTY.MESSAGE',
      DESCRIPTION: 'TREASURY.PAYMENT_FILE_STRUCTURE.EMPTY.DESCRIPTION',
    },

    SEARCH_PLACEHOLDER: 'TREASURY.PAYMENT_FILE_STRUCTURE.SEARCH_PLACEHOLDER',
    TITLE: {
      LIST: 'TREASURY.PAYMENT_FILE_STRUCTURE.TITLE.LIST',
      CREATE: 'TREASURY.PAYMENT_FILE_STRUCTURE.TITLE.CREATE',
      EDIT: 'TREASURY.PAYMENT_FILE_STRUCTURE.TITLE.EDIT',
      VIEW: 'TREASURY.PAYMENT_FILE_STRUCTURE.TITLE.VIEW',
    },
    SUBTITLE: {
      LIST: 'TREASURY.PAYMENT_FILE_STRUCTURE.SUBTITLE.LIST',
      CREATE: 'TREASURY.PAYMENT_FILE_STRUCTURE.SUBTITLE.CREATE',
      EDIT: 'TREASURY.PAYMENT_FILE_STRUCTURE.SUBTITLE.EDIT',
      VIEW: 'TREASURY.PAYMENT_FILE_STRUCTURE.SUBTITLE.VIEW',
    },
    SECTION: {
      TECHNICAL_CONDITIONS: 'TREASURY.PAYMENT_FILE_STRUCTURE.SECTION.TECHNICAL_CONDITIONS',
    },
    LABEL: {
      BANK: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.BANK',
      STRUCTURE_NAME: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.STRUCTURE_NAME',
      STATUS: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.STATUS',
      EXTENSION: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.EXTENSION',
      ENCODING: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.ENCODING',
      MAXIMUM_SIZE_MB: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.MAXIMUM_SIZE_MB',
      RECORD_LENGTH: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.RECORD_LENGTH',
      NUMERIC_ALIGNMENT: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.NUMERIC_ALIGNMENT',
      NUMERIC_FILL: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.NUMERIC_FILL',
      ALPHANUMERIC_ALIGNMENT: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.ALPHANUMERIC_ALIGNMENT',
      ALPHANUMERIC_FILL: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.ALPHANUMERIC_FILL',
      LINE_TERMINATOR: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.LINE_TERMINATOR',
      LAST_RECORD_TERMINATOR: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.LAST_RECORD_TERMINATOR',
      NOTES: 'TREASURY.PAYMENT_FILE_STRUCTURE.LABEL.NOTES',
    },
    PLACEHOLDER: {
      SELECT_BANK: 'TREASURY.PAYMENT_FILE_STRUCTURE.PLACEHOLDER.SELECT_BANK',
    },
    TOOLTIP: {
      BANK: 'TREASURY.BANK_ACCOUNTS.ACTION.SEARCH',
      STRUCTURE_NAME: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.STRUCTURE_NAME',
      STATUS: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.STATUS',
      EXTENSION: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.EXTENSION',
      ENCODING: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.ENCODING',
      MAXIMUM_SIZE_MB: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.MAXIMUM_SIZE_MB',
      RECORD_LENGTH: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.RECORD_LENGTH',
      NUMERIC_ALIGNMENT: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.NUMERIC_ALIGNMENT',
      NUMERIC_FILL: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.NUMERIC_FILL',
      ALPHANUMERIC_ALIGNMENT: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.ALPHANUMERIC_ALIGNMENT',
      ALPHANUMERIC_FILL: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.ALPHANUMERIC_FILL',
      LINE_TERMINATOR: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.LINE_TERMINATOR',
      LAST_RECORD_TERMINATOR: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.LAST_RECORD_TERMINATOR',
      NOTES: 'TREASURY.PAYMENT_FILE_STRUCTURE.TOOLTIP.NOTES',
    },
    TABLE: {
      COLUMNS: {
        ORDER: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.ORDER',
        FIELD_NAME: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.FIELD_NAME',
        FIELD_TYPE: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.FIELD_TYPE',
        REQUIRED: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.REQUIRED',
        LENGTH: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.LENGTH',
        START_POSITION: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.START_POSITION',
        VALUE_FORMAT: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.VALUE_FORMAT',
        BANK_CODE: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.BANK_CODE',
        BANK: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.BANK',
        STRUCTURE_NAME: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.STRUCTURE_NAME',
        CREATION_DATE: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.CREATION_DATE',
        STATUS: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.STATUS',
        USER: 'TREASURY.PAYMENT_FILE_STRUCTURE.TABLE.COLUMNS.USER',
      },
    },
    STATUS: {
      ACTIVE: 'TREASURY.PAYMENT_FILE_STRUCTURE.STATUS.ACTIVE',
      INACTIVE: 'TREASURY.PAYMENT_FILE_STRUCTURE.STATUS.INACTIVE',
    },
    ACTIONS: {
      ADD_FIELD: 'TREASURY.PAYMENT_FILE_STRUCTURE.ACTIONS.ADD_FIELD',
      MOVE_UP: 'TREASURY.PAYMENT_FILE_STRUCTURE.ACTIONS.MOVE_UP',
      MOVE_DOWN: 'TREASURY.PAYMENT_FILE_STRUCTURE.ACTIONS.MOVE_DOWN',
      DELETE: 'TREASURY.PAYMENT_FILE_STRUCTURE.ACTIONS.DELETE',
    },

    TITLES: {
      TABLE_FIELDS: 'TREASURY.PAYMENT_FILE_STRUCTURE.TITLES.TABLE_FIELDS',
      IDENTIFICATION: 'TREASURY.PAYMENT_FILE_STRUCTURE.TITLES.IDENTIFICATION',
    },
    VALIDATION: {
      STRUCTURE_NAME: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.STRUCTURE_NAME',
      BANK_NAME: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.BANK_NAME',
      STATUS: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.STATUS',
      EXTENSION: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.EXTENSION',
      FILE_TYPE: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.FILE_TYPE',
      ENCODING: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.ENCODING',
      MAXIMUM_SIZE_MB: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.MAXIMUM_SIZE_MB',
      RECORD_LENGTH: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.RECORD_LENGTH',
      NUMERIC_ALIGNMENT: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.NUMERIC_ALIGNMENT',
      NUMERIC_FILL: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.NUMERIC_FILL',
      ALPHANUMERIC_ALIGNMENT: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.ALPHANUMERIC_ALIGNMENT',
      ALPHANUMERIC_FILL: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.ALPHANUMERIC_FILL',
      LINE_TERMINATOR: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.LINE_TERMINATOR',
      LAST_RECORD_TERMINATOR: 'TREASURY.PAYMENT_FILE_STRUCTURE.VALIDATION.LAST_RECORD_TERMINATOR',
    },
    PANEL: {
      SUMMARY: 'TREASURY.PAYMENT_FILE_STRUCTURE.PANEL.SUMMARY',
      SUMMARY_TITLE_EMPTY: 'TREASURY.PAYMENT_FILE_STRUCTURE.PANEL.SUMMARY_TITLE_EMPTY',
      CHECKLIST: 'TREASURY.PAYMENT_FILE_STRUCTURE.PANEL.CHECKLIST',
    },
  },
} as const;
